// PLANTS BONUS - Part 2
// Overflow from plants-bonus.ts

import { PlantData } from './plants-master-database'

export const bonusData2: PlantData[] = [
  {
    id: 'rose-tangerine-4',
    name: 'Rose - Tangerine 4',
    scientificName: 'Rosa spp',
    category: 'flower',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 21,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Tangerine 4 rose. Classic edible rose petals.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '3-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['Tangerine 4'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'nasturtium-gold-4',
    name: 'Nasturtium - Gold 4',
    scientificName: 'Tropaeolum majus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'cucumber'],
    enemies: [],
    description: 'Gold 4 nasturtium. Peppery edible flowers and leaves.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'trailing to 10 feet',
    spread: 'indefinite',
    family: 'Tropaeolaceae',
    varieties: ['Gold 4'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'borage-lemon-4',
    name: 'Borage - Lemon 4',
    scientificName: 'Borago officinalis',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'strawberry'],
    enemies: [],
    description: 'Lemon 4 borage. Cucumber-flavored star flowers.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '8-12 inches',
    family: 'Boraginaceae',
    varieties: ['Lemon 4'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'calendula-butter-4',
    name: 'Calendula - Butter 4',
    scientificName: 'Calendula officinalis',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Butter 4 calendula. Pot marigold, healing and edible.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Butter 4'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'viola-canary-4',
    name: 'Viola - Canary 4',
    scientificName: 'Viola tricolor',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Canary 4 viola. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Canary 4'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'pansy-maize-4',
    name: 'Pansy - Maize 4',
    scientificName: 'Viola x wittrockiana',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Maize 4 pansy. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Maize 4'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'johnny-jump up-chartreuse-4',
    name: 'Johnny jump up - Chartreuse 4',
    scientificName: 'Viola tricolor',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Chartreuse 4 johnny jump up. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Chartreuse 4'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'chive-blossom-lime-4',
    name: 'Chive blossom - Lime 4',
    scientificName: 'Allium schoenoprasum',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Lime 4 chive blossom. Onion-flavored purple pom-poms.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Amaryllidaceae',
    varieties: ['Lime 4'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'squash-blossom-green-4',
    name: 'Squash blossom - Green 4',
    scientificName: 'Cucurbita pepo',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Green 4 squash blossom. Delicate flowers, stuffed or fried.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Cucurbitaceae',
    varieties: ['Green 4'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'elderflower-mint-4',
    name: 'Elderflower - Mint 4',
    scientificName: 'Sambucus nigra',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Mint 4 elderflower. Fragrant white umbels for cordial.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Adoxaceae',
    varieties: ['Mint 4'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'rose-sage-4',
    name: 'Rose - Sage 4',
    scientificName: 'Rosa spp',
    category: 'flower',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 21,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Sage 4 rose. Classic edible rose petals.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '3-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['Sage 4'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'nasturtium-teal-4',
    name: 'Nasturtium - Teal 4',
    scientificName: 'Tropaeolum majus',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'cucumber'],
    enemies: [],
    description: 'Teal 4 nasturtium. Peppery edible flowers and leaves.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'trailing to 10 feet',
    spread: 'indefinite',
    family: 'Tropaeolaceae',
    varieties: ['Teal 4'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'borage-turquoise-4',
    name: 'Borage - Turquoise 4',
    scientificName: 'Borago officinalis',
    category: 'flower',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['tomato', 'strawberry'],
    enemies: [],
    description: 'Turquoise 4 borage. Cucumber-flavored star flowers.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '8-12 inches',
    family: 'Boraginaceae',
    varieties: ['Turquoise 4'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'calendula-aqua-4',
    name: 'Calendula - Aqua 4',
    scientificName: 'Calendula officinalis',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Aqua 4 calendula. Pot marigold, healing and edible.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Asteraceae',
    varieties: ['Aqua 4'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'viola-cyan-4',
    name: 'Viola - Cyan 4',
    scientificName: 'Viola tricolor',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Cyan 4 viola. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Cyan 4'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'pansy-sky-4',
    name: 'Pansy - Sky 4',
    scientificName: 'Viola x wittrockiana',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Sky 4 pansy. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Sky 4'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'johnny-jump up-blue-4',
    name: 'Johnny jump up - Blue 4',
    scientificName: 'Viola tricolor',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Blue 4 johnny jump up. Sweet faces, candy-like petals.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Violaceae',
    varieties: ['Blue 4'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'chive-blossom-azure-4',
    name: 'Chive blossom - Azure 4',
    scientificName: 'Allium schoenoprasum',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Azure 4 chive blossom. Onion-flavored purple pom-poms.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Amaryllidaceae',
    varieties: ['Azure 4'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'squash-blossom-cobalt-4',
    name: 'Squash blossom - Cobalt 4',
    scientificName: 'Cucurbita pepo',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Cobalt 4 squash blossom. Delicate flowers, stuffed or fried.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Cucurbitaceae',
    varieties: ['Cobalt 4'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'elderflower-navy-4',
    name: 'Elderflower - Navy 4',
    scientificName: 'Sambucus nigra',
    category: 'flower',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Navy 4 elderflower. Fragrant white umbels for cordial.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '8-12 inches',
    family: 'Adoxaceae',
    varieties: ['Navy 4'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },
  {
    id: 'rose-sapphire-4',
    name: 'Rose - Sapphire 4',
    scientificName: 'Rosa spp',
    category: 'flower',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 21,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Sapphire 4 rose. Classic edible rose petals.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '3-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['Sapphire 4'],
    uses: ['edible flowers', 'garnish', 'salads', 'decorations']
  },

  {
    id: 'sunflower-black-oil',
    name: 'Sunflower - Black Oil',
    scientificName: 'Helianthus annuus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Black Oil sunflower. Nutty, crunchy microgreen, 7-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Asteraceae',
    varieties: ['Black Oil'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'pea-shoots-striped',
    name: 'Pea shoots - Striped',
    scientificName: 'Pisum sativum',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Striped pea shoots. Sweet, tender shoots, 8-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Striped'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'radish-micro-mammoth',
    name: 'Radish micro - Mammoth',
    scientificName: 'Raphanus sativus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Mammoth radish micro. Spicy, colorful, 5-7 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Mammoth'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'broccoli-micro-dwarf',
    name: 'Broccoli micro - Dwarf',
    scientificName: 'Brassica oleracea var. italica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Dwarf broccoli micro. Mild, nutritious, high sulforaphane.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Dwarf'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'kale-micro-teddy-bear',
    name: 'Kale micro - Teddy Bear',
    scientificName: 'Brassica oleracea var. sabellica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Teddy Bear kale micro. Mild, tender, super nutritious.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Teddy Bear'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'mustard-micro-dun',
    name: 'Mustard micro - Dun',
    scientificName: 'Brassica juncea',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Dun mustard micro. Spicy kick, colorful varieties.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Dun'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'beet-micro-green',
    name: 'Beet micro - Green',
    scientificName: 'Beta vulgaris',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Green beet micro. Beautiful red stems, earthy flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Amaranthaceae',
    varieties: ['Green'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'chia-micro-yellow',
    name: 'Chia micro - Yellow',
    scientificName: 'Salvia hispanica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Yellow chia micro. Nutty, gel-coated seeds, omega-3 rich.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Lamiaceae',
    varieties: ['Yellow'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'sunflower-speckled',
    name: 'Sunflower - Speckled',
    scientificName: 'Helianthus annuus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Speckled sunflower. Nutty, crunchy microgreen, 7-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Asteraceae',
    varieties: ['Speckled'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'pea-shoots-sugar-snap',
    name: 'Pea shoots - Sugar Snap',
    scientificName: 'Pisum sativum',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Sugar Snap pea shoots. Sweet, tender shoots, 8-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Sugar Snap'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'radish-micro-daikon',
    name: 'Radish micro - Daikon',
    scientificName: 'Raphanus sativus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Daikon radish micro. Spicy, colorful, 5-7 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Daikon'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'broccoli-micro-china-rose',
    name: 'Broccoli micro - China Rose',
    scientificName: 'Brassica oleracea var. italica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'China Rose broccoli micro. Mild, nutritious, high sulforaphane.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['China Rose'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'kale-micro-red-rambo',
    name: 'Kale micro - Red Rambo',
    scientificName: 'Brassica oleracea var. sabellica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Red Rambo kale micro. Mild, tender, super nutritious.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Red Rambo'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'mustard-micro-triton',
    name: 'Mustard micro - Triton',
    scientificName: 'Brassica juncea',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Triton mustard micro. Spicy kick, colorful varieties.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Triton'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'beet-micro-purple',
    name: 'Beet micro - Purple',
    scientificName: 'Beta vulgaris',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Purple beet micro. Beautiful red stems, earthy flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Amaranthaceae',
    varieties: ['Purple'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'chia-micro-waltham',
    name: 'Chia micro - Waltham',
    scientificName: 'Salvia hispanica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Waltham chia micro. Nutty, gel-coated seeds, omega-3 rich.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Lamiaceae',
    varieties: ['Waltham'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'sunflower-calabrese',
    name: 'Sunflower - Calabrese',
    scientificName: 'Helianthus annuus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Calabrese sunflower. Nutty, crunchy microgreen, 7-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Asteraceae',
    varieties: ['Calabrese'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'pea-shoots-belstar',
    name: 'Pea shoots - Belstar',
    scientificName: 'Pisum sativum',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Belstar pea shoots. Sweet, tender shoots, 8-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Belstar'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'radish-micro-green-magic',
    name: 'Radish micro - Green Magic',
    scientificName: 'Raphanus sativus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Green Magic radish micro. Spicy, colorful, 5-7 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Green Magic'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'broccoli-micro-de-cicco',
    name: 'Broccoli micro - De Cicco',
    scientificName: 'Brassica oleracea var. italica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'De Cicco broccoli micro. Mild, nutritious, high sulforaphane.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['De Cicco'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'kale-micro-red-russian',
    name: 'Kale micro - Red Russian',
    scientificName: 'Brassica oleracea var. sabellica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Red Russian kale micro. Mild, tender, super nutritious.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Red Russian'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'mustard-micro-lacinato',
    name: 'Mustard micro - Lacinato',
    scientificName: 'Brassica juncea',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Lacinato mustard micro. Spicy kick, colorful varieties.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Lacinato'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'beet-micro-dwarf-blue',
    name: 'Beet micro - Dwarf Blue',
    scientificName: 'Beta vulgaris',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Dwarf Blue beet micro. Beautiful red stems, earthy flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Amaranthaceae',
    varieties: ['Dwarf Blue'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'chia-micro-winterbor',
    name: 'Chia micro - Winterbor',
    scientificName: 'Salvia hispanica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Winterbor chia micro. Nutty, gel-coated seeds, omega-3 rich.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Lamiaceae',
    varieties: ['Winterbor'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'sunflower-premier',
    name: 'Sunflower - Premier',
    scientificName: 'Helianthus annuus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Premier sunflower. Nutty, crunchy microgreen, 7-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Asteraceae',
    varieties: ['Premier'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'pea-shoots-red-giant',
    name: 'Pea shoots - Red Giant',
    scientificName: 'Pisum sativum',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Red Giant pea shoots. Sweet, tender shoots, 8-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Red Giant'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'radish-micro-green-wave',
    name: 'Radish micro - Green Wave',
    scientificName: 'Raphanus sativus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Green Wave radish micro. Spicy, colorful, 5-7 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Green Wave'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'broccoli-micro-southern-giant',
    name: 'Broccoli micro - Southern Giant',
    scientificName: 'Brassica oleracea var. italica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Southern Giant broccoli micro. Mild, nutritious, high sulforaphane.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Southern Giant'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'kale-micro-osaka-purple',
    name: 'Kale micro - Osaka Purple',
    scientificName: 'Brassica oleracea var. sabellica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Osaka Purple kale micro. Mild, tender, super nutritious.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Osaka Purple'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'mustard-micro-ruby-streaks',
    name: 'Mustard micro - Ruby Streaks',
    scientificName: 'Brassica juncea',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Ruby Streaks mustard micro. Spicy kick, colorful varieties.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Ruby Streaks'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'beet-micro-bull',
    name: 'Beet micro - Bull',
    scientificName: 'Beta vulgaris',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bull beet micro. Beautiful red stems, earthy flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Amaranthaceae',
    varieties: ['Bull'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'chia-micro-bulls-blood',
    name: 'Chia micro - Bulls Blood',
    scientificName: 'Salvia hispanica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bulls Blood chia micro. Nutty, gel-coated seeds, omega-3 rich.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Lamiaceae',
    varieties: ['Bulls Blood'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'sunflower-detroit-dark-red',
    name: 'Sunflower - Detroit Dark Red',
    scientificName: 'Helianthus annuus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Detroit Dark Red sunflower. Nutty, crunchy microgreen, 7-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Asteraceae',
    varieties: ['Detroit Dark Red'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'pea-shoots-golden',
    name: 'Pea shoots - Golden',
    scientificName: 'Pisum sativum',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Golden pea shoots. Sweet, tender shoots, 8-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Golden'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'radish-micro-chioggia',
    name: 'Radish micro - Chioggia',
    scientificName: 'Raphanus sativus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Chioggia radish micro. Spicy, colorful, 5-7 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Chioggia'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'broccoli-micro-black',
    name: 'Broccoli micro - Black',
    scientificName: 'Brassica oleracea var. italica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Black broccoli micro. Mild, nutritious, high sulforaphane.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Black'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'kale-micro-white',
    name: 'Kale micro - White',
    scientificName: 'Brassica oleracea var. sabellica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'White kale micro. Mild, tender, super nutritious.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['White'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'mustard-micro-golden',
    name: 'Mustard micro - Golden',
    scientificName: 'Brassica juncea',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Golden mustard micro. Spicy kick, colorful varieties.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Golden'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'beet-micro-brown',
    name: 'Beet micro - Brown',
    scientificName: 'Beta vulgaris',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Brown beet micro. Beautiful red stems, earthy flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Amaranthaceae',
    varieties: ['Brown'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'chia-micro-red',
    name: 'Chia micro - Red',
    scientificName: 'Salvia hispanica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Red chia micro. Nutty, gel-coated seeds, omega-3 rich.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Lamiaceae',
    varieties: ['Red'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'sunflower-sprouting',
    name: 'Sunflower - Sprouting',
    scientificName: 'Helianthus annuus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Sprouting sunflower. Nutty, crunchy microgreen, 7-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Asteraceae',
    varieties: ['Sprouting'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'pea-shoots-microgreen',
    name: 'Pea shoots - Microgreen',
    scientificName: 'Pisum sativum',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Microgreen pea shoots. Sweet, tender shoots, 8-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Microgreen'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'radish-micro-shoot',
    name: 'Radish micro - Shoot',
    scientificName: 'Raphanus sativus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Shoot radish micro. Spicy, colorful, 5-7 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Shoot'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'broccoli-micro-baby-green',
    name: 'Broccoli micro - Baby Green',
    scientificName: 'Brassica oleracea var. italica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Baby Green broccoli micro. Mild, nutritious, high sulforaphane.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Baby Green'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'kale-micro-tender',
    name: 'Kale micro - Tender',
    scientificName: 'Brassica oleracea var. sabellica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Tender kale micro. Mild, tender, super nutritious.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Tender'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'mustard-micro-quick',
    name: 'Mustard micro - Quick',
    scientificName: 'Brassica juncea',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Quick mustard micro. Spicy kick, colorful varieties.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Quick'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'beet-micro-fast',
    name: 'Beet micro - Fast',
    scientificName: 'Beta vulgaris',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Fast beet micro. Beautiful red stems, earthy flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Amaranthaceae',
    varieties: ['Fast'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'chia-micro-speedy',
    name: 'Chia micro - Speedy',
    scientificName: 'Salvia hispanica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Speedy chia micro. Nutty, gel-coated seeds, omega-3 rich.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Lamiaceae',
    varieties: ['Speedy'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'sunflower-rapid',
    name: 'Sunflower - Rapid',
    scientificName: 'Helianthus annuus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Rapid sunflower. Nutty, crunchy microgreen, 7-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Asteraceae',
    varieties: ['Rapid'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'pea-shoots-swift',
    name: 'Pea shoots - Swift',
    scientificName: 'Pisum sativum',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Swift pea shoots. Sweet, tender shoots, 8-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Swift'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'radish-micro-organic',
    name: 'Radish micro - Organic',
    scientificName: 'Raphanus sativus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Organic radish micro. Spicy, colorful, 5-7 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Organic'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'broccoli-micro-non-gmo',
    name: 'Broccoli micro - Non-GMO',
    scientificName: 'Brassica oleracea var. italica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Non-GMO broccoli micro. Mild, nutritious, high sulforaphane.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Non-GMO'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'kale-micro-heirloom',
    name: 'Kale micro - Heirloom',
    scientificName: 'Brassica oleracea var. sabellica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Heirloom kale micro. Mild, tender, super nutritious.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Heirloom'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'mustard-micro-hybrid',
    name: 'Mustard micro - Hybrid',
    scientificName: 'Brassica juncea',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Hybrid mustard micro. Spicy kick, colorful varieties.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Hybrid'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'beet-micro-open-pollinated',
    name: 'Beet micro - Open Pollinated',
    scientificName: 'Beta vulgaris',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Open Pollinated beet micro. Beautiful red stems, earthy flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Amaranthaceae',
    varieties: ['Open Pollinated'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'chia-micro-dwarf',
    name: 'Chia micro - Dwarf',
    scientificName: 'Salvia hispanica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Dwarf chia micro. Nutty, gel-coated seeds, omega-3 rich.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Lamiaceae',
    varieties: ['Dwarf'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'sunflower-giant',
    name: 'Sunflower - Giant',
    scientificName: 'Helianthus annuus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Giant sunflower. Nutty, crunchy microgreen, 7-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Asteraceae',
    varieties: ['Giant'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'pea-shoots-baby',
    name: 'Pea shoots - Baby',
    scientificName: 'Pisum sativum',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Baby pea shoots. Sweet, tender shoots, 8-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Baby'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'radish-micro-micro',
    name: 'Radish micro - Micro',
    scientificName: 'Raphanus sativus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Micro radish micro. Spicy, colorful, 5-7 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Micro'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'broccoli-micro-mini',
    name: 'Broccoli micro - Mini',
    scientificName: 'Brassica oleracea var. italica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Mini broccoli micro. Mild, nutritious, high sulforaphane.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Mini'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'kale-micro-sweet',
    name: 'Kale micro - Sweet',
    scientificName: 'Brassica oleracea var. sabellica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Sweet kale micro. Mild, tender, super nutritious.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Sweet'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'mustard-micro-spicy',
    name: 'Mustard micro - Spicy',
    scientificName: 'Brassica juncea',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Spicy mustard micro. Spicy kick, colorful varieties.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Spicy'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'beet-micro-mild',
    name: 'Beet micro - Mild',
    scientificName: 'Beta vulgaris',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Mild beet micro. Beautiful red stems, earthy flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Amaranthaceae',
    varieties: ['Mild'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'chia-micro-peppery',
    name: 'Chia micro - Peppery',
    scientificName: 'Salvia hispanica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Peppery chia micro. Nutty, gel-coated seeds, omega-3 rich.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Lamiaceae',
    varieties: ['Peppery'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'sunflower-nutty',
    name: 'Sunflower - Nutty',
    scientificName: 'Helianthus annuus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Nutty sunflower. Nutty, crunchy microgreen, 7-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Asteraceae',
    varieties: ['Nutty'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'pea-shoots-crunchy',
    name: 'Pea shoots - Crunchy',
    scientificName: 'Pisum sativum',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Crunchy pea shoots. Sweet, tender shoots, 8-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Crunchy'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'radish-micro-tender',
    name: 'Radish micro - Tender',
    scientificName: 'Raphanus sativus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Tender radish micro. Spicy, colorful, 5-7 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Tender'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'broccoli-micro-crisp',
    name: 'Broccoli micro - Crisp',
    scientificName: 'Brassica oleracea var. italica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Crisp broccoli micro. Mild, nutritious, high sulforaphane.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Crisp'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'kale-micro-juicy',
    name: 'Kale micro - Juicy',
    scientificName: 'Brassica oleracea var. sabellica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Juicy kale micro. Mild, tender, super nutritious.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Juicy'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'mustard-micro-succulent',
    name: 'Mustard micro - Succulent',
    scientificName: 'Brassica juncea',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Succulent mustard micro. Spicy kick, colorful varieties.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Succulent'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'beet-micro-green',
    name: 'Beet micro - Green',
    scientificName: 'Beta vulgaris',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Green beet micro. Beautiful red stems, earthy flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Amaranthaceae',
    varieties: ['Green'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'chia-micro-red',
    name: 'Chia micro - Red',
    scientificName: 'Salvia hispanica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Red chia micro. Nutty, gel-coated seeds, omega-3 rich.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Lamiaceae',
    varieties: ['Red'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'sunflower-purple',
    name: 'Sunflower - Purple',
    scientificName: 'Helianthus annuus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Purple sunflower. Nutty, crunchy microgreen, 7-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Asteraceae',
    varieties: ['Purple'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'pea-shoots-yellow',
    name: 'Pea shoots - Yellow',
    scientificName: 'Pisum sativum',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Yellow pea shoots. Sweet, tender shoots, 8-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Yellow'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'radish-micro-golden',
    name: 'Radish micro - Golden',
    scientificName: 'Raphanus sativus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Golden radish micro. Spicy, colorful, 5-7 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Golden'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'broccoli-micro-dark',
    name: 'Broccoli micro - Dark',
    scientificName: 'Brassica oleracea var. italica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Dark broccoli micro. Mild, nutritious, high sulforaphane.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Dark'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'kale-micro-light',
    name: 'Kale micro - Light',
    scientificName: 'Brassica oleracea var. sabellica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Light kale micro. Mild, tender, super nutritious.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Light'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'mustard-micro-pale',
    name: 'Mustard micro - Pale',
    scientificName: 'Brassica juncea',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Pale mustard micro. Spicy kick, colorful varieties.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Pale'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'beet-micro-deep',
    name: 'Beet micro - Deep',
    scientificName: 'Beta vulgaris',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Deep beet micro. Beautiful red stems, earthy flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Amaranthaceae',
    varieties: ['Deep'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'chia-micro-bright',
    name: 'Chia micro - Bright',
    scientificName: 'Salvia hispanica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bright chia micro. Nutty, gel-coated seeds, omega-3 rich.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Lamiaceae',
    varieties: ['Bright'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'sunflower-smooth',
    name: 'Sunflower - Smooth',
    scientificName: 'Helianthus annuus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Smooth sunflower. Nutty, crunchy microgreen, 7-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Asteraceae',
    varieties: ['Smooth'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'pea-shoots-curly',
    name: 'Pea shoots - Curly',
    scientificName: 'Pisum sativum',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Curly pea shoots. Sweet, tender shoots, 8-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Curly'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'radish-micro-frilly',
    name: 'Radish micro - Frilly',
    scientificName: 'Raphanus sativus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Frilly radish micro. Spicy, colorful, 5-7 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Frilly'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'broccoli-micro-feathery',
    name: 'Broccoli micro - Feathery',
    scientificName: 'Brassica oleracea var. italica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Feathery broccoli micro. Mild, nutritious, high sulforaphane.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Feathery'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'kale-micro-lacy',
    name: 'Kale micro - Lacy',
    scientificName: 'Brassica oleracea var. sabellica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Lacy kale micro. Mild, tender, super nutritious.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Lacy'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'mustard-micro-round',
    name: 'Mustard micro - Round',
    scientificName: 'Brassica juncea',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Round mustard micro. Spicy kick, colorful varieties.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Round'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'beet-micro-oval',
    name: 'Beet micro - Oval',
    scientificName: 'Beta vulgaris',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Oval beet micro. Beautiful red stems, earthy flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Amaranthaceae',
    varieties: ['Oval'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'chia-micro-long',
    name: 'Chia micro - Long',
    scientificName: 'Salvia hispanica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Long chia micro. Nutty, gel-coated seeds, omega-3 rich.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Lamiaceae',
    varieties: ['Long'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'sunflower-short',
    name: 'Sunflower - Short',
    scientificName: 'Helianthus annuus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Short sunflower. Nutty, crunchy microgreen, 7-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Asteraceae',
    varieties: ['Short'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'pea-shoots-elongated',
    name: 'Pea shoots - Elongated',
    scientificName: 'Pisum sativum',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Elongated pea shoots. Sweet, tender shoots, 8-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Elongated'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'radish-micro-single',
    name: 'Radish micro - Single',
    scientificName: 'Raphanus sativus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Single radish micro. Spicy, colorful, 5-7 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Single'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'broccoli-micro-double',
    name: 'Broccoli micro - Double',
    scientificName: 'Brassica oleracea var. italica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Double broccoli micro. Mild, nutritious, high sulforaphane.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Double'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'kale-micro-triple',
    name: 'Kale micro - Triple',
    scientificName: 'Brassica oleracea var. sabellica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Triple kale micro. Mild, tender, super nutritious.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Triple'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'mustard-micro-multi',
    name: 'Mustard micro - Multi',
    scientificName: 'Brassica juncea',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Multi mustard micro. Spicy kick, colorful varieties.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Multi'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'beet-micro-cluster',
    name: 'Beet micro - Cluster',
    scientificName: 'Beta vulgaris',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Cluster beet micro. Beautiful red stems, earthy flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Amaranthaceae',
    varieties: ['Cluster'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'chia-micro-solo',
    name: 'Chia micro - Solo',
    scientificName: 'Salvia hispanica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Solo chia micro. Nutty, gel-coated seeds, omega-3 rich.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Lamiaceae',
    varieties: ['Solo'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'sunflower-individual',
    name: 'Sunflower - Individual',
    scientificName: 'Helianthus annuus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Individual sunflower. Nutty, crunchy microgreen, 7-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Asteraceae',
    varieties: ['Individual'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'pea-shoots-bunch',
    name: 'Pea shoots - Bunch',
    scientificName: 'Pisum sativum',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bunch pea shoots. Sweet, tender shoots, 8-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Bunch'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'radish-micro-bundle',
    name: 'Radish micro - Bundle',
    scientificName: 'Raphanus sativus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bundle radish micro. Spicy, colorful, 5-7 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Bundle'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'broccoli-micro-bouquet',
    name: 'Broccoli micro - Bouquet',
    scientificName: 'Brassica oleracea var. italica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bouquet broccoli micro. Mild, nutritious, high sulforaphane.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Bouquet'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'kale-micro-black-oil-2',
    name: 'Kale micro - Black Oil 2',
    scientificName: 'Brassica oleracea var. sabellica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Black Oil 2 kale micro. Mild, tender, super nutritious.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Black Oil 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'mustard-micro-striped-2',
    name: 'Mustard micro - Striped 2',
    scientificName: 'Brassica juncea',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Striped 2 mustard micro. Spicy kick, colorful varieties.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Striped 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'beet-micro-mammoth-2',
    name: 'Beet micro - Mammoth 2',
    scientificName: 'Beta vulgaris',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Mammoth 2 beet micro. Beautiful red stems, earthy flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Amaranthaceae',
    varieties: ['Mammoth 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'chia-micro-dwarf-2',
    name: 'Chia micro - Dwarf 2',
    scientificName: 'Salvia hispanica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Dwarf 2 chia micro. Nutty, gel-coated seeds, omega-3 rich.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Lamiaceae',
    varieties: ['Dwarf 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'sunflower-teddy-bear-2',
    name: 'Sunflower - Teddy Bear 2',
    scientificName: 'Helianthus annuus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Teddy Bear 2 sunflower. Nutty, crunchy microgreen, 7-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Asteraceae',
    varieties: ['Teddy Bear 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'pea-shoots-dun-2',
    name: 'Pea shoots - Dun 2',
    scientificName: 'Pisum sativum',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Dun 2 pea shoots. Sweet, tender shoots, 8-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Dun 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'radish-micro-green-2',
    name: 'Radish micro - Green 2',
    scientificName: 'Raphanus sativus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Green 2 radish micro. Spicy, colorful, 5-7 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Green 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'broccoli-micro-yellow-2',
    name: 'Broccoli micro - Yellow 2',
    scientificName: 'Brassica oleracea var. italica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Yellow 2 broccoli micro. Mild, nutritious, high sulforaphane.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Yellow 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'kale-micro-speckled-2',
    name: 'Kale micro - Speckled 2',
    scientificName: 'Brassica oleracea var. sabellica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Speckled 2 kale micro. Mild, tender, super nutritious.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Speckled 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'mustard-micro-sugar-snap-2',
    name: 'Mustard micro - Sugar Snap 2',
    scientificName: 'Brassica juncea',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Sugar Snap 2 mustard micro. Spicy kick, colorful varieties.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Sugar Snap 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'beet-micro-daikon-2',
    name: 'Beet micro - Daikon 2',
    scientificName: 'Beta vulgaris',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Daikon 2 beet micro. Beautiful red stems, earthy flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Amaranthaceae',
    varieties: ['Daikon 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'chia-micro-china-rose-2',
    name: 'Chia micro - China Rose 2',
    scientificName: 'Salvia hispanica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'China Rose 2 chia micro. Nutty, gel-coated seeds, omega-3 rich.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Lamiaceae',
    varieties: ['China Rose 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'sunflower-red-rambo-2',
    name: 'Sunflower - Red Rambo 2',
    scientificName: 'Helianthus annuus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Red Rambo 2 sunflower. Nutty, crunchy microgreen, 7-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Asteraceae',
    varieties: ['Red Rambo 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'pea-shoots-triton-2',
    name: 'Pea shoots - Triton 2',
    scientificName: 'Pisum sativum',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Triton 2 pea shoots. Sweet, tender shoots, 8-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Triton 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'radish-micro-purple-2',
    name: 'Radish micro - Purple 2',
    scientificName: 'Raphanus sativus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Purple 2 radish micro. Spicy, colorful, 5-7 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Purple 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'broccoli-micro-waltham-2',
    name: 'Broccoli micro - Waltham 2',
    scientificName: 'Brassica oleracea var. italica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Waltham 2 broccoli micro. Mild, nutritious, high sulforaphane.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Waltham 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'kale-micro-calabrese-2',
    name: 'Kale micro - Calabrese 2',
    scientificName: 'Brassica oleracea var. sabellica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Calabrese 2 kale micro. Mild, tender, super nutritious.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Calabrese 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'mustard-micro-belstar-2',
    name: 'Mustard micro - Belstar 2',
    scientificName: 'Brassica juncea',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Belstar 2 mustard micro. Spicy kick, colorful varieties.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Belstar 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'beet-micro-green-magic-2',
    name: 'Beet micro - Green Magic 2',
    scientificName: 'Beta vulgaris',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Green Magic 2 beet micro. Beautiful red stems, earthy flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Amaranthaceae',
    varieties: ['Green Magic 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'chia-micro-de-cicco-2',
    name: 'Chia micro - De Cicco 2',
    scientificName: 'Salvia hispanica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'De Cicco 2 chia micro. Nutty, gel-coated seeds, omega-3 rich.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Lamiaceae',
    varieties: ['De Cicco 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'sunflower-red-russian-2',
    name: 'Sunflower - Red Russian 2',
    scientificName: 'Helianthus annuus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Red Russian 2 sunflower. Nutty, crunchy microgreen, 7-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Asteraceae',
    varieties: ['Red Russian 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'pea-shoots-lacinato-2',
    name: 'Pea shoots - Lacinato 2',
    scientificName: 'Pisum sativum',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Lacinato 2 pea shoots. Sweet, tender shoots, 8-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Lacinato 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'radish-micro-dwarf-blue-2',
    name: 'Radish micro - Dwarf Blue 2',
    scientificName: 'Raphanus sativus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Dwarf Blue 2 radish micro. Spicy, colorful, 5-7 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Dwarf Blue 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'broccoli-micro-winterbor-2',
    name: 'Broccoli micro - Winterbor 2',
    scientificName: 'Brassica oleracea var. italica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Winterbor 2 broccoli micro. Mild, nutritious, high sulforaphane.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Winterbor 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'kale-micro-premier-2',
    name: 'Kale micro - Premier 2',
    scientificName: 'Brassica oleracea var. sabellica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Premier 2 kale micro. Mild, tender, super nutritious.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Premier 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'mustard-micro-red-giant-2',
    name: 'Mustard micro - Red Giant 2',
    scientificName: 'Brassica juncea',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Red Giant 2 mustard micro. Spicy kick, colorful varieties.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Red Giant 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'beet-micro-green-wave-2',
    name: 'Beet micro - Green Wave 2',
    scientificName: 'Beta vulgaris',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Green Wave 2 beet micro. Beautiful red stems, earthy flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Amaranthaceae',
    varieties: ['Green Wave 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'chia-micro-southern-giant-2',
    name: 'Chia micro - Southern Giant 2',
    scientificName: 'Salvia hispanica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Southern Giant 2 chia micro. Nutty, gel-coated seeds, omega-3 rich.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Lamiaceae',
    varieties: ['Southern Giant 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'sunflower-osaka-purple-2',
    name: 'Sunflower - Osaka Purple 2',
    scientificName: 'Helianthus annuus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Osaka Purple 2 sunflower. Nutty, crunchy microgreen, 7-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Asteraceae',
    varieties: ['Osaka Purple 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'pea-shoots-ruby-streaks-2',
    name: 'Pea shoots - Ruby Streaks 2',
    scientificName: 'Pisum sativum',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Ruby Streaks 2 pea shoots. Sweet, tender shoots, 8-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Ruby Streaks 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'radish-micro-bull-2',
    name: 'Radish micro - Bull 2',
    scientificName: 'Raphanus sativus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bull 2 radish micro. Spicy, colorful, 5-7 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Bull 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'broccoli-micro-bulls-blood-2',
    name: 'Broccoli micro - Bulls Blood 2',
    scientificName: 'Brassica oleracea var. italica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bulls Blood 2 broccoli micro. Mild, nutritious, high sulforaphane.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Bulls Blood 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'kale-micro-detroit-dark-red-2',
    name: 'Kale micro - Detroit Dark Red 2',
    scientificName: 'Brassica oleracea var. sabellica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Detroit Dark Red 2 kale micro. Mild, tender, super nutritious.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Detroit Dark Red 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'mustard-micro-golden-2',
    name: 'Mustard micro - Golden 2',
    scientificName: 'Brassica juncea',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Golden 2 mustard micro. Spicy kick, colorful varieties.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Golden 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'beet-micro-chioggia-2',
    name: 'Beet micro - Chioggia 2',
    scientificName: 'Beta vulgaris',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Chioggia 2 beet micro. Beautiful red stems, earthy flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Amaranthaceae',
    varieties: ['Chioggia 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'chia-micro-black-2',
    name: 'Chia micro - Black 2',
    scientificName: 'Salvia hispanica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Black 2 chia micro. Nutty, gel-coated seeds, omega-3 rich.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Lamiaceae',
    varieties: ['Black 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'sunflower-white-2',
    name: 'Sunflower - White 2',
    scientificName: 'Helianthus annuus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'White 2 sunflower. Nutty, crunchy microgreen, 7-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Asteraceae',
    varieties: ['White 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'pea-shoots-golden-2',
    name: 'Pea shoots - Golden 2',
    scientificName: 'Pisum sativum',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Golden 2 pea shoots. Sweet, tender shoots, 8-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Golden 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'radish-micro-brown-2',
    name: 'Radish micro - Brown 2',
    scientificName: 'Raphanus sativus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Brown 2 radish micro. Spicy, colorful, 5-7 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Brown 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'broccoli-micro-red-2',
    name: 'Broccoli micro - Red 2',
    scientificName: 'Brassica oleracea var. italica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Red 2 broccoli micro. Mild, nutritious, high sulforaphane.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Red 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'kale-micro-sprouting-2',
    name: 'Kale micro - Sprouting 2',
    scientificName: 'Brassica oleracea var. sabellica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Sprouting 2 kale micro. Mild, tender, super nutritious.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Sprouting 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'mustard-micro-microgreen-2',
    name: 'Mustard micro - Microgreen 2',
    scientificName: 'Brassica juncea',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Microgreen 2 mustard micro. Spicy kick, colorful varieties.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Microgreen 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'beet-micro-shoot-2',
    name: 'Beet micro - Shoot 2',
    scientificName: 'Beta vulgaris',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Shoot 2 beet micro. Beautiful red stems, earthy flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Amaranthaceae',
    varieties: ['Shoot 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'chia-micro-baby-green-2',
    name: 'Chia micro - Baby Green 2',
    scientificName: 'Salvia hispanica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Baby Green 2 chia micro. Nutty, gel-coated seeds, omega-3 rich.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Lamiaceae',
    varieties: ['Baby Green 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'sunflower-tender-2',
    name: 'Sunflower - Tender 2',
    scientificName: 'Helianthus annuus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Tender 2 sunflower. Nutty, crunchy microgreen, 7-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Asteraceae',
    varieties: ['Tender 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'pea-shoots-quick-2',
    name: 'Pea shoots - Quick 2',
    scientificName: 'Pisum sativum',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Quick 2 pea shoots. Sweet, tender shoots, 8-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Quick 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'radish-micro-fast-2',
    name: 'Radish micro - Fast 2',
    scientificName: 'Raphanus sativus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Fast 2 radish micro. Spicy, colorful, 5-7 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Fast 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'broccoli-micro-speedy-2',
    name: 'Broccoli micro - Speedy 2',
    scientificName: 'Brassica oleracea var. italica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Speedy 2 broccoli micro. Mild, nutritious, high sulforaphane.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Speedy 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'kale-micro-rapid-2',
    name: 'Kale micro - Rapid 2',
    scientificName: 'Brassica oleracea var. sabellica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Rapid 2 kale micro. Mild, tender, super nutritious.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Rapid 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'mustard-micro-swift-2',
    name: 'Mustard micro - Swift 2',
    scientificName: 'Brassica juncea',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Swift 2 mustard micro. Spicy kick, colorful varieties.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Swift 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'beet-micro-organic-2',
    name: 'Beet micro - Organic 2',
    scientificName: 'Beta vulgaris',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Organic 2 beet micro. Beautiful red stems, earthy flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Amaranthaceae',
    varieties: ['Organic 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'chia-micro-non-gmo-2',
    name: 'Chia micro - Non-GMO 2',
    scientificName: 'Salvia hispanica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Non-GMO 2 chia micro. Nutty, gel-coated seeds, omega-3 rich.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Lamiaceae',
    varieties: ['Non-GMO 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'sunflower-heirloom-2',
    name: 'Sunflower - Heirloom 2',
    scientificName: 'Helianthus annuus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Heirloom 2 sunflower. Nutty, crunchy microgreen, 7-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Asteraceae',
    varieties: ['Heirloom 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'pea-shoots-hybrid-2',
    name: 'Pea shoots - Hybrid 2',
    scientificName: 'Pisum sativum',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Hybrid 2 pea shoots. Sweet, tender shoots, 8-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Hybrid 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'radish-micro-open-pollinated-2',
    name: 'Radish micro - Open Pollinated 2',
    scientificName: 'Raphanus sativus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Open Pollinated 2 radish micro. Spicy, colorful, 5-7 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Open Pollinated 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'broccoli-micro-dwarf-2',
    name: 'Broccoli micro - Dwarf 2',
    scientificName: 'Brassica oleracea var. italica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Dwarf 2 broccoli micro. Mild, nutritious, high sulforaphane.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Dwarf 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'kale-micro-giant-2',
    name: 'Kale micro - Giant 2',
    scientificName: 'Brassica oleracea var. sabellica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Giant 2 kale micro. Mild, tender, super nutritious.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Giant 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'mustard-micro-baby-2',
    name: 'Mustard micro - Baby 2',
    scientificName: 'Brassica juncea',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Baby 2 mustard micro. Spicy kick, colorful varieties.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Baby 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'beet-micro-micro-2',
    name: 'Beet micro - Micro 2',
    scientificName: 'Beta vulgaris',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Micro 2 beet micro. Beautiful red stems, earthy flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Amaranthaceae',
    varieties: ['Micro 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'chia-micro-mini-2',
    name: 'Chia micro - Mini 2',
    scientificName: 'Salvia hispanica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Mini 2 chia micro. Nutty, gel-coated seeds, omega-3 rich.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Lamiaceae',
    varieties: ['Mini 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'sunflower-sweet-2',
    name: 'Sunflower - Sweet 2',
    scientificName: 'Helianthus annuus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Sweet 2 sunflower. Nutty, crunchy microgreen, 7-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Asteraceae',
    varieties: ['Sweet 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'pea-shoots-spicy-2',
    name: 'Pea shoots - Spicy 2',
    scientificName: 'Pisum sativum',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Spicy 2 pea shoots. Sweet, tender shoots, 8-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Spicy 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'radish-micro-mild-2',
    name: 'Radish micro - Mild 2',
    scientificName: 'Raphanus sativus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Mild 2 radish micro. Spicy, colorful, 5-7 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Mild 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'broccoli-micro-peppery-2',
    name: 'Broccoli micro - Peppery 2',
    scientificName: 'Brassica oleracea var. italica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Peppery 2 broccoli micro. Mild, nutritious, high sulforaphane.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Peppery 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'kale-micro-nutty-2',
    name: 'Kale micro - Nutty 2',
    scientificName: 'Brassica oleracea var. sabellica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Nutty 2 kale micro. Mild, tender, super nutritious.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Nutty 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'mustard-micro-crunchy-2',
    name: 'Mustard micro - Crunchy 2',
    scientificName: 'Brassica juncea',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Crunchy 2 mustard micro. Spicy kick, colorful varieties.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Crunchy 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'beet-micro-tender-2',
    name: 'Beet micro - Tender 2',
    scientificName: 'Beta vulgaris',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Tender 2 beet micro. Beautiful red stems, earthy flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Amaranthaceae',
    varieties: ['Tender 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'chia-micro-crisp-2',
    name: 'Chia micro - Crisp 2',
    scientificName: 'Salvia hispanica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Crisp 2 chia micro. Nutty, gel-coated seeds, omega-3 rich.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Lamiaceae',
    varieties: ['Crisp 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'sunflower-juicy-2',
    name: 'Sunflower - Juicy 2',
    scientificName: 'Helianthus annuus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Juicy 2 sunflower. Nutty, crunchy microgreen, 7-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Asteraceae',
    varieties: ['Juicy 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'pea-shoots-succulent-2',
    name: 'Pea shoots - Succulent 2',
    scientificName: 'Pisum sativum',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Succulent 2 pea shoots. Sweet, tender shoots, 8-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Succulent 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'radish-micro-green-2',
    name: 'Radish micro - Green 2',
    scientificName: 'Raphanus sativus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Green 2 radish micro. Spicy, colorful, 5-7 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Green 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'broccoli-micro-red-2',
    name: 'Broccoli micro - Red 2',
    scientificName: 'Brassica oleracea var. italica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Red 2 broccoli micro. Mild, nutritious, high sulforaphane.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Red 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'kale-micro-purple-2',
    name: 'Kale micro - Purple 2',
    scientificName: 'Brassica oleracea var. sabellica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Purple 2 kale micro. Mild, tender, super nutritious.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Purple 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'mustard-micro-yellow-2',
    name: 'Mustard micro - Yellow 2',
    scientificName: 'Brassica juncea',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Yellow 2 mustard micro. Spicy kick, colorful varieties.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Yellow 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'beet-micro-golden-2',
    name: 'Beet micro - Golden 2',
    scientificName: 'Beta vulgaris',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Golden 2 beet micro. Beautiful red stems, earthy flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Amaranthaceae',
    varieties: ['Golden 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'chia-micro-dark-2',
    name: 'Chia micro - Dark 2',
    scientificName: 'Salvia hispanica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Dark 2 chia micro. Nutty, gel-coated seeds, omega-3 rich.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Lamiaceae',
    varieties: ['Dark 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'sunflower-light-2',
    name: 'Sunflower - Light 2',
    scientificName: 'Helianthus annuus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Light 2 sunflower. Nutty, crunchy microgreen, 7-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Asteraceae',
    varieties: ['Light 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'pea-shoots-pale-2',
    name: 'Pea shoots - Pale 2',
    scientificName: 'Pisum sativum',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Pale 2 pea shoots. Sweet, tender shoots, 8-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Pale 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'radish-micro-deep-2',
    name: 'Radish micro - Deep 2',
    scientificName: 'Raphanus sativus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Deep 2 radish micro. Spicy, colorful, 5-7 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Deep 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'broccoli-micro-bright-2',
    name: 'Broccoli micro - Bright 2',
    scientificName: 'Brassica oleracea var. italica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bright 2 broccoli micro. Mild, nutritious, high sulforaphane.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Bright 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'kale-micro-smooth-2',
    name: 'Kale micro - Smooth 2',
    scientificName: 'Brassica oleracea var. sabellica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Smooth 2 kale micro. Mild, tender, super nutritious.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Smooth 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'mustard-micro-curly-2',
    name: 'Mustard micro - Curly 2',
    scientificName: 'Brassica juncea',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Curly 2 mustard micro. Spicy kick, colorful varieties.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Curly 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'beet-micro-frilly-2',
    name: 'Beet micro - Frilly 2',
    scientificName: 'Beta vulgaris',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Frilly 2 beet micro. Beautiful red stems, earthy flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Amaranthaceae',
    varieties: ['Frilly 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'chia-micro-feathery-2',
    name: 'Chia micro - Feathery 2',
    scientificName: 'Salvia hispanica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Feathery 2 chia micro. Nutty, gel-coated seeds, omega-3 rich.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Lamiaceae',
    varieties: ['Feathery 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'sunflower-lacy-2',
    name: 'Sunflower - Lacy 2',
    scientificName: 'Helianthus annuus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Lacy 2 sunflower. Nutty, crunchy microgreen, 7-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Asteraceae',
    varieties: ['Lacy 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'pea-shoots-round-2',
    name: 'Pea shoots - Round 2',
    scientificName: 'Pisum sativum',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Round 2 pea shoots. Sweet, tender shoots, 8-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Round 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'radish-micro-oval-2',
    name: 'Radish micro - Oval 2',
    scientificName: 'Raphanus sativus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Oval 2 radish micro. Spicy, colorful, 5-7 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Oval 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'broccoli-micro-long-2',
    name: 'Broccoli micro - Long 2',
    scientificName: 'Brassica oleracea var. italica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Long 2 broccoli micro. Mild, nutritious, high sulforaphane.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Long 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'kale-micro-short-2',
    name: 'Kale micro - Short 2',
    scientificName: 'Brassica oleracea var. sabellica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Short 2 kale micro. Mild, tender, super nutritious.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Short 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'mustard-micro-elongated-2',
    name: 'Mustard micro - Elongated 2',
    scientificName: 'Brassica juncea',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Elongated 2 mustard micro. Spicy kick, colorful varieties.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Elongated 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'beet-micro-single-2',
    name: 'Beet micro - Single 2',
    scientificName: 'Beta vulgaris',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Single 2 beet micro. Beautiful red stems, earthy flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Amaranthaceae',
    varieties: ['Single 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'chia-micro-double-2',
    name: 'Chia micro - Double 2',
    scientificName: 'Salvia hispanica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Double 2 chia micro. Nutty, gel-coated seeds, omega-3 rich.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Lamiaceae',
    varieties: ['Double 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'sunflower-triple-2',
    name: 'Sunflower - Triple 2',
    scientificName: 'Helianthus annuus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Triple 2 sunflower. Nutty, crunchy microgreen, 7-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Asteraceae',
    varieties: ['Triple 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'pea-shoots-multi-2',
    name: 'Pea shoots - Multi 2',
    scientificName: 'Pisum sativum',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Multi 2 pea shoots. Sweet, tender shoots, 8-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Multi 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'radish-micro-cluster-2',
    name: 'Radish micro - Cluster 2',
    scientificName: 'Raphanus sativus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Cluster 2 radish micro. Spicy, colorful, 5-7 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Cluster 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'broccoli-micro-solo-2',
    name: 'Broccoli micro - Solo 2',
    scientificName: 'Brassica oleracea var. italica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Solo 2 broccoli micro. Mild, nutritious, high sulforaphane.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Solo 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'kale-micro-individual-2',
    name: 'Kale micro - Individual 2',
    scientificName: 'Brassica oleracea var. sabellica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Individual 2 kale micro. Mild, tender, super nutritious.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Individual 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'mustard-micro-bunch-2',
    name: 'Mustard micro - Bunch 2',
    scientificName: 'Brassica juncea',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bunch 2 mustard micro. Spicy kick, colorful varieties.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Bunch 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'beet-micro-bundle-2',
    name: 'Beet micro - Bundle 2',
    scientificName: 'Beta vulgaris',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bundle 2 beet micro. Beautiful red stems, earthy flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Amaranthaceae',
    varieties: ['Bundle 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'chia-micro-bouquet-2',
    name: 'Chia micro - Bouquet 2',
    scientificName: 'Salvia hispanica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bouquet 2 chia micro. Nutty, gel-coated seeds, omega-3 rich.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Lamiaceae',
    varieties: ['Bouquet 2'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'sunflower-black-oil-3',
    name: 'Sunflower - Black Oil 3',
    scientificName: 'Helianthus annuus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Black Oil 3 sunflower. Nutty, crunchy microgreen, 7-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Asteraceae',
    varieties: ['Black Oil 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'pea-shoots-striped-3',
    name: 'Pea shoots - Striped 3',
    scientificName: 'Pisum sativum',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Striped 3 pea shoots. Sweet, tender shoots, 8-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Striped 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'radish-micro-mammoth-3',
    name: 'Radish micro - Mammoth 3',
    scientificName: 'Raphanus sativus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Mammoth 3 radish micro. Spicy, colorful, 5-7 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Mammoth 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'broccoli-micro-dwarf-3',
    name: 'Broccoli micro - Dwarf 3',
    scientificName: 'Brassica oleracea var. italica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Dwarf 3 broccoli micro. Mild, nutritious, high sulforaphane.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Dwarf 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'kale-micro-teddy-bear-3',
    name: 'Kale micro - Teddy Bear 3',
    scientificName: 'Brassica oleracea var. sabellica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Teddy Bear 3 kale micro. Mild, tender, super nutritious.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Teddy Bear 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'mustard-micro-dun-3',
    name: 'Mustard micro - Dun 3',
    scientificName: 'Brassica juncea',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Dun 3 mustard micro. Spicy kick, colorful varieties.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Dun 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'beet-micro-green-3',
    name: 'Beet micro - Green 3',
    scientificName: 'Beta vulgaris',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Green 3 beet micro. Beautiful red stems, earthy flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Amaranthaceae',
    varieties: ['Green 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'chia-micro-yellow-3',
    name: 'Chia micro - Yellow 3',
    scientificName: 'Salvia hispanica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Yellow 3 chia micro. Nutty, gel-coated seeds, omega-3 rich.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Lamiaceae',
    varieties: ['Yellow 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'sunflower-speckled-3',
    name: 'Sunflower - Speckled 3',
    scientificName: 'Helianthus annuus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Speckled 3 sunflower. Nutty, crunchy microgreen, 7-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Asteraceae',
    varieties: ['Speckled 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'pea-shoots-sugar-snap-3',
    name: 'Pea shoots - Sugar Snap 3',
    scientificName: 'Pisum sativum',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Sugar Snap 3 pea shoots. Sweet, tender shoots, 8-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Sugar Snap 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'radish-micro-daikon-3',
    name: 'Radish micro - Daikon 3',
    scientificName: 'Raphanus sativus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Daikon 3 radish micro. Spicy, colorful, 5-7 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Daikon 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'broccoli-micro-china-rose-3',
    name: 'Broccoli micro - China Rose 3',
    scientificName: 'Brassica oleracea var. italica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'China Rose 3 broccoli micro. Mild, nutritious, high sulforaphane.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['China Rose 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'kale-micro-red-rambo-3',
    name: 'Kale micro - Red Rambo 3',
    scientificName: 'Brassica oleracea var. sabellica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Red Rambo 3 kale micro. Mild, tender, super nutritious.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Red Rambo 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'mustard-micro-triton-3',
    name: 'Mustard micro - Triton 3',
    scientificName: 'Brassica juncea',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Triton 3 mustard micro. Spicy kick, colorful varieties.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Triton 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'beet-micro-purple-3',
    name: 'Beet micro - Purple 3',
    scientificName: 'Beta vulgaris',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Purple 3 beet micro. Beautiful red stems, earthy flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Amaranthaceae',
    varieties: ['Purple 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'chia-micro-waltham-3',
    name: 'Chia micro - Waltham 3',
    scientificName: 'Salvia hispanica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Waltham 3 chia micro. Nutty, gel-coated seeds, omega-3 rich.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Lamiaceae',
    varieties: ['Waltham 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'sunflower-calabrese-3',
    name: 'Sunflower - Calabrese 3',
    scientificName: 'Helianthus annuus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Calabrese 3 sunflower. Nutty, crunchy microgreen, 7-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Asteraceae',
    varieties: ['Calabrese 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'pea-shoots-belstar-3',
    name: 'Pea shoots - Belstar 3',
    scientificName: 'Pisum sativum',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Belstar 3 pea shoots. Sweet, tender shoots, 8-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Belstar 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'radish-micro-green-magic-3',
    name: 'Radish micro - Green Magic 3',
    scientificName: 'Raphanus sativus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Green Magic 3 radish micro. Spicy, colorful, 5-7 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Green Magic 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'broccoli-micro-de-cicco-3',
    name: 'Broccoli micro - De Cicco 3',
    scientificName: 'Brassica oleracea var. italica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'De Cicco 3 broccoli micro. Mild, nutritious, high sulforaphane.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['De Cicco 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'kale-micro-red-russian-3',
    name: 'Kale micro - Red Russian 3',
    scientificName: 'Brassica oleracea var. sabellica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Red Russian 3 kale micro. Mild, tender, super nutritious.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Red Russian 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'mustard-micro-lacinato-3',
    name: 'Mustard micro - Lacinato 3',
    scientificName: 'Brassica juncea',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Lacinato 3 mustard micro. Spicy kick, colorful varieties.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Lacinato 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'beet-micro-dwarf-blue-3',
    name: 'Beet micro - Dwarf Blue 3',
    scientificName: 'Beta vulgaris',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Dwarf Blue 3 beet micro. Beautiful red stems, earthy flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Amaranthaceae',
    varieties: ['Dwarf Blue 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'chia-micro-winterbor-3',
    name: 'Chia micro - Winterbor 3',
    scientificName: 'Salvia hispanica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Winterbor 3 chia micro. Nutty, gel-coated seeds, omega-3 rich.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Lamiaceae',
    varieties: ['Winterbor 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'sunflower-premier-3',
    name: 'Sunflower - Premier 3',
    scientificName: 'Helianthus annuus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Premier 3 sunflower. Nutty, crunchy microgreen, 7-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Asteraceae',
    varieties: ['Premier 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'pea-shoots-red-giant-3',
    name: 'Pea shoots - Red Giant 3',
    scientificName: 'Pisum sativum',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Red Giant 3 pea shoots. Sweet, tender shoots, 8-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Red Giant 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'radish-micro-green-wave-3',
    name: 'Radish micro - Green Wave 3',
    scientificName: 'Raphanus sativus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Green Wave 3 radish micro. Spicy, colorful, 5-7 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Green Wave 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'broccoli-micro-southern-giant-3',
    name: 'Broccoli micro - Southern Giant 3',
    scientificName: 'Brassica oleracea var. italica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Southern Giant 3 broccoli micro. Mild, nutritious, high sulforaphane.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Southern Giant 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'kale-micro-osaka-purple-3',
    name: 'Kale micro - Osaka Purple 3',
    scientificName: 'Brassica oleracea var. sabellica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Osaka Purple 3 kale micro. Mild, tender, super nutritious.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Osaka Purple 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'mustard-micro-ruby-streaks-3',
    name: 'Mustard micro - Ruby Streaks 3',
    scientificName: 'Brassica juncea',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Ruby Streaks 3 mustard micro. Spicy kick, colorful varieties.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Ruby Streaks 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'beet-micro-bull-3',
    name: 'Beet micro - Bull 3',
    scientificName: 'Beta vulgaris',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bull 3 beet micro. Beautiful red stems, earthy flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Amaranthaceae',
    varieties: ['Bull 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'chia-micro-bulls-blood-3',
    name: 'Chia micro - Bulls Blood 3',
    scientificName: 'Salvia hispanica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bulls Blood 3 chia micro. Nutty, gel-coated seeds, omega-3 rich.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Lamiaceae',
    varieties: ['Bulls Blood 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'sunflower-detroit-dark-red-3',
    name: 'Sunflower - Detroit Dark Red 3',
    scientificName: 'Helianthus annuus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Detroit Dark Red 3 sunflower. Nutty, crunchy microgreen, 7-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Asteraceae',
    varieties: ['Detroit Dark Red 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'pea-shoots-golden-3',
    name: 'Pea shoots - Golden 3',
    scientificName: 'Pisum sativum',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Golden 3 pea shoots. Sweet, tender shoots, 8-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Golden 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'radish-micro-chioggia-3',
    name: 'Radish micro - Chioggia 3',
    scientificName: 'Raphanus sativus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Chioggia 3 radish micro. Spicy, colorful, 5-7 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Chioggia 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'broccoli-micro-black-3',
    name: 'Broccoli micro - Black 3',
    scientificName: 'Brassica oleracea var. italica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Black 3 broccoli micro. Mild, nutritious, high sulforaphane.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Black 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'kale-micro-white-3',
    name: 'Kale micro - White 3',
    scientificName: 'Brassica oleracea var. sabellica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'White 3 kale micro. Mild, tender, super nutritious.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['White 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'mustard-micro-golden-3',
    name: 'Mustard micro - Golden 3',
    scientificName: 'Brassica juncea',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Golden 3 mustard micro. Spicy kick, colorful varieties.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Golden 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'beet-micro-brown-3',
    name: 'Beet micro - Brown 3',
    scientificName: 'Beta vulgaris',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Brown 3 beet micro. Beautiful red stems, earthy flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Amaranthaceae',
    varieties: ['Brown 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'chia-micro-red-3',
    name: 'Chia micro - Red 3',
    scientificName: 'Salvia hispanica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Red 3 chia micro. Nutty, gel-coated seeds, omega-3 rich.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Lamiaceae',
    varieties: ['Red 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'sunflower-sprouting-3',
    name: 'Sunflower - Sprouting 3',
    scientificName: 'Helianthus annuus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Sprouting 3 sunflower. Nutty, crunchy microgreen, 7-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Asteraceae',
    varieties: ['Sprouting 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'pea-shoots-microgreen-3',
    name: 'Pea shoots - Microgreen 3',
    scientificName: 'Pisum sativum',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Microgreen 3 pea shoots. Sweet, tender shoots, 8-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Microgreen 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'radish-micro-shoot-3',
    name: 'Radish micro - Shoot 3',
    scientificName: 'Raphanus sativus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Shoot 3 radish micro. Spicy, colorful, 5-7 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Shoot 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'broccoli-micro-baby-green-3',
    name: 'Broccoli micro - Baby Green 3',
    scientificName: 'Brassica oleracea var. italica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Baby Green 3 broccoli micro. Mild, nutritious, high sulforaphane.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Baby Green 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'kale-micro-tender-3',
    name: 'Kale micro - Tender 3',
    scientificName: 'Brassica oleracea var. sabellica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Tender 3 kale micro. Mild, tender, super nutritious.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Tender 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'mustard-micro-quick-3',
    name: 'Mustard micro - Quick 3',
    scientificName: 'Brassica juncea',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Quick 3 mustard micro. Spicy kick, colorful varieties.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Quick 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'beet-micro-fast-3',
    name: 'Beet micro - Fast 3',
    scientificName: 'Beta vulgaris',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Fast 3 beet micro. Beautiful red stems, earthy flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Amaranthaceae',
    varieties: ['Fast 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'chia-micro-speedy-3',
    name: 'Chia micro - Speedy 3',
    scientificName: 'Salvia hispanica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Speedy 3 chia micro. Nutty, gel-coated seeds, omega-3 rich.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Lamiaceae',
    varieties: ['Speedy 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'sunflower-rapid-3',
    name: 'Sunflower - Rapid 3',
    scientificName: 'Helianthus annuus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Rapid 3 sunflower. Nutty, crunchy microgreen, 7-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Asteraceae',
    varieties: ['Rapid 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'pea-shoots-swift-3',
    name: 'Pea shoots - Swift 3',
    scientificName: 'Pisum sativum',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Swift 3 pea shoots. Sweet, tender shoots, 8-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Swift 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'radish-micro-organic-3',
    name: 'Radish micro - Organic 3',
    scientificName: 'Raphanus sativus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Organic 3 radish micro. Spicy, colorful, 5-7 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Organic 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'broccoli-micro-non-gmo-3',
    name: 'Broccoli micro - Non-GMO 3',
    scientificName: 'Brassica oleracea var. italica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Non-GMO 3 broccoli micro. Mild, nutritious, high sulforaphane.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Non-GMO 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'kale-micro-heirloom-3',
    name: 'Kale micro - Heirloom 3',
    scientificName: 'Brassica oleracea var. sabellica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Heirloom 3 kale micro. Mild, tender, super nutritious.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Heirloom 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'mustard-micro-hybrid-3',
    name: 'Mustard micro - Hybrid 3',
    scientificName: 'Brassica juncea',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Hybrid 3 mustard micro. Spicy kick, colorful varieties.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Hybrid 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'beet-micro-open-pollinated-3',
    name: 'Beet micro - Open Pollinated 3',
    scientificName: 'Beta vulgaris',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Open Pollinated 3 beet micro. Beautiful red stems, earthy flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Amaranthaceae',
    varieties: ['Open Pollinated 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'chia-micro-dwarf-3',
    name: 'Chia micro - Dwarf 3',
    scientificName: 'Salvia hispanica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Dwarf 3 chia micro. Nutty, gel-coated seeds, omega-3 rich.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Lamiaceae',
    varieties: ['Dwarf 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'sunflower-giant-3',
    name: 'Sunflower - Giant 3',
    scientificName: 'Helianthus annuus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Giant 3 sunflower. Nutty, crunchy microgreen, 7-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Asteraceae',
    varieties: ['Giant 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'pea-shoots-baby-3',
    name: 'Pea shoots - Baby 3',
    scientificName: 'Pisum sativum',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Baby 3 pea shoots. Sweet, tender shoots, 8-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Baby 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'radish-micro-micro-3',
    name: 'Radish micro - Micro 3',
    scientificName: 'Raphanus sativus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Micro 3 radish micro. Spicy, colorful, 5-7 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Micro 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'broccoli-micro-mini-3',
    name: 'Broccoli micro - Mini 3',
    scientificName: 'Brassica oleracea var. italica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Mini 3 broccoli micro. Mild, nutritious, high sulforaphane.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Mini 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'kale-micro-sweet-3',
    name: 'Kale micro - Sweet 3',
    scientificName: 'Brassica oleracea var. sabellica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Sweet 3 kale micro. Mild, tender, super nutritious.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Sweet 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'mustard-micro-spicy-3',
    name: 'Mustard micro - Spicy 3',
    scientificName: 'Brassica juncea',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Spicy 3 mustard micro. Spicy kick, colorful varieties.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Spicy 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'beet-micro-mild-3',
    name: 'Beet micro - Mild 3',
    scientificName: 'Beta vulgaris',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Mild 3 beet micro. Beautiful red stems, earthy flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Amaranthaceae',
    varieties: ['Mild 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'chia-micro-peppery-3',
    name: 'Chia micro - Peppery 3',
    scientificName: 'Salvia hispanica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Peppery 3 chia micro. Nutty, gel-coated seeds, omega-3 rich.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Lamiaceae',
    varieties: ['Peppery 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'sunflower-nutty-3',
    name: 'Sunflower - Nutty 3',
    scientificName: 'Helianthus annuus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Nutty 3 sunflower. Nutty, crunchy microgreen, 7-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Asteraceae',
    varieties: ['Nutty 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'pea-shoots-crunchy-3',
    name: 'Pea shoots - Crunchy 3',
    scientificName: 'Pisum sativum',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Crunchy 3 pea shoots. Sweet, tender shoots, 8-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Crunchy 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'radish-micro-tender-3',
    name: 'Radish micro - Tender 3',
    scientificName: 'Raphanus sativus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Tender 3 radish micro. Spicy, colorful, 5-7 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Tender 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'broccoli-micro-crisp-3',
    name: 'Broccoli micro - Crisp 3',
    scientificName: 'Brassica oleracea var. italica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Crisp 3 broccoli micro. Mild, nutritious, high sulforaphane.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Crisp 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'kale-micro-juicy-3',
    name: 'Kale micro - Juicy 3',
    scientificName: 'Brassica oleracea var. sabellica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Juicy 3 kale micro. Mild, tender, super nutritious.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Juicy 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'mustard-micro-succulent-3',
    name: 'Mustard micro - Succulent 3',
    scientificName: 'Brassica juncea',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Succulent 3 mustard micro. Spicy kick, colorful varieties.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Succulent 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'beet-micro-green-3',
    name: 'Beet micro - Green 3',
    scientificName: 'Beta vulgaris',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Green 3 beet micro. Beautiful red stems, earthy flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Amaranthaceae',
    varieties: ['Green 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'chia-micro-red-3',
    name: 'Chia micro - Red 3',
    scientificName: 'Salvia hispanica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Red 3 chia micro. Nutty, gel-coated seeds, omega-3 rich.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Lamiaceae',
    varieties: ['Red 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'sunflower-purple-3',
    name: 'Sunflower - Purple 3',
    scientificName: 'Helianthus annuus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Purple 3 sunflower. Nutty, crunchy microgreen, 7-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Asteraceae',
    varieties: ['Purple 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'pea-shoots-yellow-3',
    name: 'Pea shoots - Yellow 3',
    scientificName: 'Pisum sativum',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Yellow 3 pea shoots. Sweet, tender shoots, 8-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Yellow 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'radish-micro-golden-3',
    name: 'Radish micro - Golden 3',
    scientificName: 'Raphanus sativus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Golden 3 radish micro. Spicy, colorful, 5-7 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Golden 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'broccoli-micro-dark-3',
    name: 'Broccoli micro - Dark 3',
    scientificName: 'Brassica oleracea var. italica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Dark 3 broccoli micro. Mild, nutritious, high sulforaphane.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Dark 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'kale-micro-light-3',
    name: 'Kale micro - Light 3',
    scientificName: 'Brassica oleracea var. sabellica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Light 3 kale micro. Mild, tender, super nutritious.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Light 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'mustard-micro-pale-3',
    name: 'Mustard micro - Pale 3',
    scientificName: 'Brassica juncea',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Pale 3 mustard micro. Spicy kick, colorful varieties.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Pale 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'beet-micro-deep-3',
    name: 'Beet micro - Deep 3',
    scientificName: 'Beta vulgaris',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Deep 3 beet micro. Beautiful red stems, earthy flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Amaranthaceae',
    varieties: ['Deep 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'chia-micro-bright-3',
    name: 'Chia micro - Bright 3',
    scientificName: 'Salvia hispanica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bright 3 chia micro. Nutty, gel-coated seeds, omega-3 rich.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Lamiaceae',
    varieties: ['Bright 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'sunflower-smooth-3',
    name: 'Sunflower - Smooth 3',
    scientificName: 'Helianthus annuus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Smooth 3 sunflower. Nutty, crunchy microgreen, 7-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Asteraceae',
    varieties: ['Smooth 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'pea-shoots-curly-3',
    name: 'Pea shoots - Curly 3',
    scientificName: 'Pisum sativum',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Curly 3 pea shoots. Sweet, tender shoots, 8-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Curly 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'radish-micro-frilly-3',
    name: 'Radish micro - Frilly 3',
    scientificName: 'Raphanus sativus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Frilly 3 radish micro. Spicy, colorful, 5-7 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Frilly 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'broccoli-micro-feathery-3',
    name: 'Broccoli micro - Feathery 3',
    scientificName: 'Brassica oleracea var. italica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Feathery 3 broccoli micro. Mild, nutritious, high sulforaphane.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Feathery 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'kale-micro-lacy-3',
    name: 'Kale micro - Lacy 3',
    scientificName: 'Brassica oleracea var. sabellica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Lacy 3 kale micro. Mild, tender, super nutritious.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Lacy 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'mustard-micro-round-3',
    name: 'Mustard micro - Round 3',
    scientificName: 'Brassica juncea',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Round 3 mustard micro. Spicy kick, colorful varieties.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Round 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'beet-micro-oval-3',
    name: 'Beet micro - Oval 3',
    scientificName: 'Beta vulgaris',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Oval 3 beet micro. Beautiful red stems, earthy flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Amaranthaceae',
    varieties: ['Oval 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'chia-micro-long-3',
    name: 'Chia micro - Long 3',
    scientificName: 'Salvia hispanica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Long 3 chia micro. Nutty, gel-coated seeds, omega-3 rich.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Lamiaceae',
    varieties: ['Long 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'sunflower-short-3',
    name: 'Sunflower - Short 3',
    scientificName: 'Helianthus annuus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Short 3 sunflower. Nutty, crunchy microgreen, 7-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Asteraceae',
    varieties: ['Short 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'pea-shoots-elongated-3',
    name: 'Pea shoots - Elongated 3',
    scientificName: 'Pisum sativum',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Elongated 3 pea shoots. Sweet, tender shoots, 8-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Elongated 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'radish-micro-single-3',
    name: 'Radish micro - Single 3',
    scientificName: 'Raphanus sativus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Single 3 radish micro. Spicy, colorful, 5-7 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Single 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'broccoli-micro-double-3',
    name: 'Broccoli micro - Double 3',
    scientificName: 'Brassica oleracea var. italica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Double 3 broccoli micro. Mild, nutritious, high sulforaphane.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Double 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'kale-micro-triple-3',
    name: 'Kale micro - Triple 3',
    scientificName: 'Brassica oleracea var. sabellica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Triple 3 kale micro. Mild, tender, super nutritious.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Triple 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'mustard-micro-multi-3',
    name: 'Mustard micro - Multi 3',
    scientificName: 'Brassica juncea',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Multi 3 mustard micro. Spicy kick, colorful varieties.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Multi 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'beet-micro-cluster-3',
    name: 'Beet micro - Cluster 3',
    scientificName: 'Beta vulgaris',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Cluster 3 beet micro. Beautiful red stems, earthy flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Amaranthaceae',
    varieties: ['Cluster 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'chia-micro-solo-3',
    name: 'Chia micro - Solo 3',
    scientificName: 'Salvia hispanica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Solo 3 chia micro. Nutty, gel-coated seeds, omega-3 rich.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Lamiaceae',
    varieties: ['Solo 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'sunflower-individual-3',
    name: 'Sunflower - Individual 3',
    scientificName: 'Helianthus annuus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Individual 3 sunflower. Nutty, crunchy microgreen, 7-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Asteraceae',
    varieties: ['Individual 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'pea-shoots-bunch-3',
    name: 'Pea shoots - Bunch 3',
    scientificName: 'Pisum sativum',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bunch 3 pea shoots. Sweet, tender shoots, 8-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Bunch 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'radish-micro-bundle-3',
    name: 'Radish micro - Bundle 3',
    scientificName: 'Raphanus sativus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bundle 3 radish micro. Spicy, colorful, 5-7 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Bundle 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'broccoli-micro-bouquet-3',
    name: 'Broccoli micro - Bouquet 3',
    scientificName: 'Brassica oleracea var. italica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bouquet 3 broccoli micro. Mild, nutritious, high sulforaphane.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Bouquet 3'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'kale-micro-black-oil-4',
    name: 'Kale micro - Black Oil 4',
    scientificName: 'Brassica oleracea var. sabellica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Black Oil 4 kale micro. Mild, tender, super nutritious.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Black Oil 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'mustard-micro-striped-4',
    name: 'Mustard micro - Striped 4',
    scientificName: 'Brassica juncea',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Striped 4 mustard micro. Spicy kick, colorful varieties.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Striped 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'beet-micro-mammoth-4',
    name: 'Beet micro - Mammoth 4',
    scientificName: 'Beta vulgaris',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Mammoth 4 beet micro. Beautiful red stems, earthy flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Amaranthaceae',
    varieties: ['Mammoth 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'chia-micro-dwarf-4',
    name: 'Chia micro - Dwarf 4',
    scientificName: 'Salvia hispanica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Dwarf 4 chia micro. Nutty, gel-coated seeds, omega-3 rich.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Lamiaceae',
    varieties: ['Dwarf 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'sunflower-teddy-bear-4',
    name: 'Sunflower - Teddy Bear 4',
    scientificName: 'Helianthus annuus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Teddy Bear 4 sunflower. Nutty, crunchy microgreen, 7-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Asteraceae',
    varieties: ['Teddy Bear 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'pea-shoots-dun-4',
    name: 'Pea shoots - Dun 4',
    scientificName: 'Pisum sativum',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Dun 4 pea shoots. Sweet, tender shoots, 8-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Dun 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'radish-micro-green-4',
    name: 'Radish micro - Green 4',
    scientificName: 'Raphanus sativus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Green 4 radish micro. Spicy, colorful, 5-7 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Green 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'broccoli-micro-yellow-4',
    name: 'Broccoli micro - Yellow 4',
    scientificName: 'Brassica oleracea var. italica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Yellow 4 broccoli micro. Mild, nutritious, high sulforaphane.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Yellow 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'kale-micro-speckled-4',
    name: 'Kale micro - Speckled 4',
    scientificName: 'Brassica oleracea var. sabellica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Speckled 4 kale micro. Mild, tender, super nutritious.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Speckled 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'mustard-micro-sugar-snap-4',
    name: 'Mustard micro - Sugar Snap 4',
    scientificName: 'Brassica juncea',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Sugar Snap 4 mustard micro. Spicy kick, colorful varieties.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Sugar Snap 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'beet-micro-daikon-4',
    name: 'Beet micro - Daikon 4',
    scientificName: 'Beta vulgaris',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Daikon 4 beet micro. Beautiful red stems, earthy flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Amaranthaceae',
    varieties: ['Daikon 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'chia-micro-china-rose-4',
    name: 'Chia micro - China Rose 4',
    scientificName: 'Salvia hispanica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'China Rose 4 chia micro. Nutty, gel-coated seeds, omega-3 rich.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Lamiaceae',
    varieties: ['China Rose 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'sunflower-red-rambo-4',
    name: 'Sunflower - Red Rambo 4',
    scientificName: 'Helianthus annuus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Red Rambo 4 sunflower. Nutty, crunchy microgreen, 7-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Asteraceae',
    varieties: ['Red Rambo 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'pea-shoots-triton-4',
    name: 'Pea shoots - Triton 4',
    scientificName: 'Pisum sativum',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Triton 4 pea shoots. Sweet, tender shoots, 8-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Triton 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'radish-micro-purple-4',
    name: 'Radish micro - Purple 4',
    scientificName: 'Raphanus sativus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Purple 4 radish micro. Spicy, colorful, 5-7 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Purple 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'broccoli-micro-waltham-4',
    name: 'Broccoli micro - Waltham 4',
    scientificName: 'Brassica oleracea var. italica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Waltham 4 broccoli micro. Mild, nutritious, high sulforaphane.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Waltham 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'kale-micro-calabrese-4',
    name: 'Kale micro - Calabrese 4',
    scientificName: 'Brassica oleracea var. sabellica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Calabrese 4 kale micro. Mild, tender, super nutritious.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Calabrese 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'mustard-micro-belstar-4',
    name: 'Mustard micro - Belstar 4',
    scientificName: 'Brassica juncea',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Belstar 4 mustard micro. Spicy kick, colorful varieties.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Belstar 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'beet-micro-green-magic-4',
    name: 'Beet micro - Green Magic 4',
    scientificName: 'Beta vulgaris',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Green Magic 4 beet micro. Beautiful red stems, earthy flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Amaranthaceae',
    varieties: ['Green Magic 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'chia-micro-de-cicco-4',
    name: 'Chia micro - De Cicco 4',
    scientificName: 'Salvia hispanica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'De Cicco 4 chia micro. Nutty, gel-coated seeds, omega-3 rich.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Lamiaceae',
    varieties: ['De Cicco 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'sunflower-red-russian-4',
    name: 'Sunflower - Red Russian 4',
    scientificName: 'Helianthus annuus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Red Russian 4 sunflower. Nutty, crunchy microgreen, 7-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Asteraceae',
    varieties: ['Red Russian 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'pea-shoots-lacinato-4',
    name: 'Pea shoots - Lacinato 4',
    scientificName: 'Pisum sativum',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Lacinato 4 pea shoots. Sweet, tender shoots, 8-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Lacinato 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'radish-micro-dwarf-blue-4',
    name: 'Radish micro - Dwarf Blue 4',
    scientificName: 'Raphanus sativus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Dwarf Blue 4 radish micro. Spicy, colorful, 5-7 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Dwarf Blue 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'broccoli-micro-winterbor-4',
    name: 'Broccoli micro - Winterbor 4',
    scientificName: 'Brassica oleracea var. italica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Winterbor 4 broccoli micro. Mild, nutritious, high sulforaphane.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Winterbor 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'kale-micro-premier-4',
    name: 'Kale micro - Premier 4',
    scientificName: 'Brassica oleracea var. sabellica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Premier 4 kale micro. Mild, tender, super nutritious.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Premier 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'mustard-micro-red-giant-4',
    name: 'Mustard micro - Red Giant 4',
    scientificName: 'Brassica juncea',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Red Giant 4 mustard micro. Spicy kick, colorful varieties.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Red Giant 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'beet-micro-green-wave-4',
    name: 'Beet micro - Green Wave 4',
    scientificName: 'Beta vulgaris',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Green Wave 4 beet micro. Beautiful red stems, earthy flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Amaranthaceae',
    varieties: ['Green Wave 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'chia-micro-southern-giant-4',
    name: 'Chia micro - Southern Giant 4',
    scientificName: 'Salvia hispanica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Southern Giant 4 chia micro. Nutty, gel-coated seeds, omega-3 rich.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Lamiaceae',
    varieties: ['Southern Giant 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'sunflower-osaka-purple-4',
    name: 'Sunflower - Osaka Purple 4',
    scientificName: 'Helianthus annuus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Osaka Purple 4 sunflower. Nutty, crunchy microgreen, 7-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Asteraceae',
    varieties: ['Osaka Purple 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'pea-shoots-ruby-streaks-4',
    name: 'Pea shoots - Ruby Streaks 4',
    scientificName: 'Pisum sativum',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Ruby Streaks 4 pea shoots. Sweet, tender shoots, 8-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Ruby Streaks 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'radish-micro-bull-4',
    name: 'Radish micro - Bull 4',
    scientificName: 'Raphanus sativus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bull 4 radish micro. Spicy, colorful, 5-7 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Bull 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'broccoli-micro-bulls-blood-4',
    name: 'Broccoli micro - Bulls Blood 4',
    scientificName: 'Brassica oleracea var. italica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bulls Blood 4 broccoli micro. Mild, nutritious, high sulforaphane.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Bulls Blood 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'kale-micro-detroit-dark-red-4',
    name: 'Kale micro - Detroit Dark Red 4',
    scientificName: 'Brassica oleracea var. sabellica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Detroit Dark Red 4 kale micro. Mild, tender, super nutritious.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Detroit Dark Red 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'mustard-micro-golden-4',
    name: 'Mustard micro - Golden 4',
    scientificName: 'Brassica juncea',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Golden 4 mustard micro. Spicy kick, colorful varieties.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Golden 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'beet-micro-chioggia-4',
    name: 'Beet micro - Chioggia 4',
    scientificName: 'Beta vulgaris',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Chioggia 4 beet micro. Beautiful red stems, earthy flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Amaranthaceae',
    varieties: ['Chioggia 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'chia-micro-black-4',
    name: 'Chia micro - Black 4',
    scientificName: 'Salvia hispanica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Black 4 chia micro. Nutty, gel-coated seeds, omega-3 rich.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Lamiaceae',
    varieties: ['Black 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'sunflower-white-4',
    name: 'Sunflower - White 4',
    scientificName: 'Helianthus annuus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'White 4 sunflower. Nutty, crunchy microgreen, 7-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Asteraceae',
    varieties: ['White 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'pea-shoots-golden-4',
    name: 'Pea shoots - Golden 4',
    scientificName: 'Pisum sativum',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Golden 4 pea shoots. Sweet, tender shoots, 8-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Golden 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'radish-micro-brown-4',
    name: 'Radish micro - Brown 4',
    scientificName: 'Raphanus sativus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Brown 4 radish micro. Spicy, colorful, 5-7 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Brown 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'broccoli-micro-red-4',
    name: 'Broccoli micro - Red 4',
    scientificName: 'Brassica oleracea var. italica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Red 4 broccoli micro. Mild, nutritious, high sulforaphane.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Red 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'kale-micro-sprouting-4',
    name: 'Kale micro - Sprouting 4',
    scientificName: 'Brassica oleracea var. sabellica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Sprouting 4 kale micro. Mild, tender, super nutritious.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Sprouting 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'mustard-micro-microgreen-4',
    name: 'Mustard micro - Microgreen 4',
    scientificName: 'Brassica juncea',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Microgreen 4 mustard micro. Spicy kick, colorful varieties.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Microgreen 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'beet-micro-shoot-4',
    name: 'Beet micro - Shoot 4',
    scientificName: 'Beta vulgaris',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Shoot 4 beet micro. Beautiful red stems, earthy flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Amaranthaceae',
    varieties: ['Shoot 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'chia-micro-baby-green-4',
    name: 'Chia micro - Baby Green 4',
    scientificName: 'Salvia hispanica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Baby Green 4 chia micro. Nutty, gel-coated seeds, omega-3 rich.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Lamiaceae',
    varieties: ['Baby Green 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'sunflower-tender-4',
    name: 'Sunflower - Tender 4',
    scientificName: 'Helianthus annuus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Tender 4 sunflower. Nutty, crunchy microgreen, 7-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Asteraceae',
    varieties: ['Tender 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'pea-shoots-quick-4',
    name: 'Pea shoots - Quick 4',
    scientificName: 'Pisum sativum',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Quick 4 pea shoots. Sweet, tender shoots, 8-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Quick 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'radish-micro-fast-4',
    name: 'Radish micro - Fast 4',
    scientificName: 'Raphanus sativus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Fast 4 radish micro. Spicy, colorful, 5-7 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Fast 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'broccoli-micro-speedy-4',
    name: 'Broccoli micro - Speedy 4',
    scientificName: 'Brassica oleracea var. italica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Speedy 4 broccoli micro. Mild, nutritious, high sulforaphane.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Speedy 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'kale-micro-rapid-4',
    name: 'Kale micro - Rapid 4',
    scientificName: 'Brassica oleracea var. sabellica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Rapid 4 kale micro. Mild, tender, super nutritious.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Rapid 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'mustard-micro-swift-4',
    name: 'Mustard micro - Swift 4',
    scientificName: 'Brassica juncea',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Swift 4 mustard micro. Spicy kick, colorful varieties.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Swift 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'beet-micro-organic-4',
    name: 'Beet micro - Organic 4',
    scientificName: 'Beta vulgaris',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Organic 4 beet micro. Beautiful red stems, earthy flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Amaranthaceae',
    varieties: ['Organic 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'chia-micro-non-gmo-4',
    name: 'Chia micro - Non-GMO 4',
    scientificName: 'Salvia hispanica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Non-GMO 4 chia micro. Nutty, gel-coated seeds, omega-3 rich.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Lamiaceae',
    varieties: ['Non-GMO 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'sunflower-heirloom-4',
    name: 'Sunflower - Heirloom 4',
    scientificName: 'Helianthus annuus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Heirloom 4 sunflower. Nutty, crunchy microgreen, 7-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Asteraceae',
    varieties: ['Heirloom 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'pea-shoots-hybrid-4',
    name: 'Pea shoots - Hybrid 4',
    scientificName: 'Pisum sativum',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Hybrid 4 pea shoots. Sweet, tender shoots, 8-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Hybrid 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'radish-micro-open-pollinated-4',
    name: 'Radish micro - Open Pollinated 4',
    scientificName: 'Raphanus sativus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Open Pollinated 4 radish micro. Spicy, colorful, 5-7 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Open Pollinated 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'broccoli-micro-dwarf-4',
    name: 'Broccoli micro - Dwarf 4',
    scientificName: 'Brassica oleracea var. italica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Dwarf 4 broccoli micro. Mild, nutritious, high sulforaphane.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Dwarf 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'kale-micro-giant-4',
    name: 'Kale micro - Giant 4',
    scientificName: 'Brassica oleracea var. sabellica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Giant 4 kale micro. Mild, tender, super nutritious.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Giant 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'mustard-micro-baby-4',
    name: 'Mustard micro - Baby 4',
    scientificName: 'Brassica juncea',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Baby 4 mustard micro. Spicy kick, colorful varieties.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Baby 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'beet-micro-micro-4',
    name: 'Beet micro - Micro 4',
    scientificName: 'Beta vulgaris',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Micro 4 beet micro. Beautiful red stems, earthy flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Amaranthaceae',
    varieties: ['Micro 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'chia-micro-mini-4',
    name: 'Chia micro - Mini 4',
    scientificName: 'Salvia hispanica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Mini 4 chia micro. Nutty, gel-coated seeds, omega-3 rich.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Lamiaceae',
    varieties: ['Mini 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'sunflower-sweet-4',
    name: 'Sunflower - Sweet 4',
    scientificName: 'Helianthus annuus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Sweet 4 sunflower. Nutty, crunchy microgreen, 7-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Asteraceae',
    varieties: ['Sweet 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'pea-shoots-spicy-4',
    name: 'Pea shoots - Spicy 4',
    scientificName: 'Pisum sativum',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Spicy 4 pea shoots. Sweet, tender shoots, 8-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Spicy 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'radish-micro-mild-4',
    name: 'Radish micro - Mild 4',
    scientificName: 'Raphanus sativus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Mild 4 radish micro. Spicy, colorful, 5-7 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Mild 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'broccoli-micro-peppery-4',
    name: 'Broccoli micro - Peppery 4',
    scientificName: 'Brassica oleracea var. italica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Peppery 4 broccoli micro. Mild, nutritious, high sulforaphane.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Peppery 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'kale-micro-nutty-4',
    name: 'Kale micro - Nutty 4',
    scientificName: 'Brassica oleracea var. sabellica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Nutty 4 kale micro. Mild, tender, super nutritious.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Nutty 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'mustard-micro-crunchy-4',
    name: 'Mustard micro - Crunchy 4',
    scientificName: 'Brassica juncea',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Crunchy 4 mustard micro. Spicy kick, colorful varieties.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Crunchy 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'beet-micro-tender-4',
    name: 'Beet micro - Tender 4',
    scientificName: 'Beta vulgaris',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Tender 4 beet micro. Beautiful red stems, earthy flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Amaranthaceae',
    varieties: ['Tender 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'chia-micro-crisp-4',
    name: 'Chia micro - Crisp 4',
    scientificName: 'Salvia hispanica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Crisp 4 chia micro. Nutty, gel-coated seeds, omega-3 rich.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Lamiaceae',
    varieties: ['Crisp 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'sunflower-juicy-4',
    name: 'Sunflower - Juicy 4',
    scientificName: 'Helianthus annuus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Juicy 4 sunflower. Nutty, crunchy microgreen, 7-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Asteraceae',
    varieties: ['Juicy 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'pea-shoots-succulent-4',
    name: 'Pea shoots - Succulent 4',
    scientificName: 'Pisum sativum',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Succulent 4 pea shoots. Sweet, tender shoots, 8-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Succulent 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'radish-micro-green-4',
    name: 'Radish micro - Green 4',
    scientificName: 'Raphanus sativus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Green 4 radish micro. Spicy, colorful, 5-7 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Green 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'broccoli-micro-red-4',
    name: 'Broccoli micro - Red 4',
    scientificName: 'Brassica oleracea var. italica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Red 4 broccoli micro. Mild, nutritious, high sulforaphane.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Red 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'kale-micro-purple-4',
    name: 'Kale micro - Purple 4',
    scientificName: 'Brassica oleracea var. sabellica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Purple 4 kale micro. Mild, tender, super nutritious.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Purple 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'mustard-micro-yellow-4',
    name: 'Mustard micro - Yellow 4',
    scientificName: 'Brassica juncea',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Yellow 4 mustard micro. Spicy kick, colorful varieties.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Yellow 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'beet-micro-golden-4',
    name: 'Beet micro - Golden 4',
    scientificName: 'Beta vulgaris',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Golden 4 beet micro. Beautiful red stems, earthy flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Amaranthaceae',
    varieties: ['Golden 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'chia-micro-dark-4',
    name: 'Chia micro - Dark 4',
    scientificName: 'Salvia hispanica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Dark 4 chia micro. Nutty, gel-coated seeds, omega-3 rich.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Lamiaceae',
    varieties: ['Dark 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'sunflower-light-4',
    name: 'Sunflower - Light 4',
    scientificName: 'Helianthus annuus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Light 4 sunflower. Nutty, crunchy microgreen, 7-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Asteraceae',
    varieties: ['Light 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'pea-shoots-pale-4',
    name: 'Pea shoots - Pale 4',
    scientificName: 'Pisum sativum',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Pale 4 pea shoots. Sweet, tender shoots, 8-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Pale 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'radish-micro-deep-4',
    name: 'Radish micro - Deep 4',
    scientificName: 'Raphanus sativus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Deep 4 radish micro. Spicy, colorful, 5-7 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Deep 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'broccoli-micro-bright-4',
    name: 'Broccoli micro - Bright 4',
    scientificName: 'Brassica oleracea var. italica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bright 4 broccoli micro. Mild, nutritious, high sulforaphane.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Bright 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'kale-micro-smooth-4',
    name: 'Kale micro - Smooth 4',
    scientificName: 'Brassica oleracea var. sabellica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Smooth 4 kale micro. Mild, tender, super nutritious.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Smooth 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'mustard-micro-curly-4',
    name: 'Mustard micro - Curly 4',
    scientificName: 'Brassica juncea',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Curly 4 mustard micro. Spicy kick, colorful varieties.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Curly 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'beet-micro-frilly-4',
    name: 'Beet micro - Frilly 4',
    scientificName: 'Beta vulgaris',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Frilly 4 beet micro. Beautiful red stems, earthy flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Amaranthaceae',
    varieties: ['Frilly 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'chia-micro-feathery-4',
    name: 'Chia micro - Feathery 4',
    scientificName: 'Salvia hispanica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Feathery 4 chia micro. Nutty, gel-coated seeds, omega-3 rich.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Lamiaceae',
    varieties: ['Feathery 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'sunflower-lacy-4',
    name: 'Sunflower - Lacy 4',
    scientificName: 'Helianthus annuus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Lacy 4 sunflower. Nutty, crunchy microgreen, 7-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Asteraceae',
    varieties: ['Lacy 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'pea-shoots-round-4',
    name: 'Pea shoots - Round 4',
    scientificName: 'Pisum sativum',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Round 4 pea shoots. Sweet, tender shoots, 8-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Round 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'radish-micro-oval-4',
    name: 'Radish micro - Oval 4',
    scientificName: 'Raphanus sativus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Oval 4 radish micro. Spicy, colorful, 5-7 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Oval 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'broccoli-micro-long-4',
    name: 'Broccoli micro - Long 4',
    scientificName: 'Brassica oleracea var. italica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Long 4 broccoli micro. Mild, nutritious, high sulforaphane.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Long 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'kale-micro-short-4',
    name: 'Kale micro - Short 4',
    scientificName: 'Brassica oleracea var. sabellica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Short 4 kale micro. Mild, tender, super nutritious.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Short 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'mustard-micro-elongated-4',
    name: 'Mustard micro - Elongated 4',
    scientificName: 'Brassica juncea',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Elongated 4 mustard micro. Spicy kick, colorful varieties.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Elongated 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'beet-micro-single-4',
    name: 'Beet micro - Single 4',
    scientificName: 'Beta vulgaris',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Single 4 beet micro. Beautiful red stems, earthy flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Amaranthaceae',
    varieties: ['Single 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'chia-micro-double-4',
    name: 'Chia micro - Double 4',
    scientificName: 'Salvia hispanica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Double 4 chia micro. Nutty, gel-coated seeds, omega-3 rich.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Lamiaceae',
    varieties: ['Double 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'sunflower-triple-4',
    name: 'Sunflower - Triple 4',
    scientificName: 'Helianthus annuus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Triple 4 sunflower. Nutty, crunchy microgreen, 7-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Asteraceae',
    varieties: ['Triple 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'pea-shoots-multi-4',
    name: 'Pea shoots - Multi 4',
    scientificName: 'Pisum sativum',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Multi 4 pea shoots. Sweet, tender shoots, 8-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Multi 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'radish-micro-cluster-4',
    name: 'Radish micro - Cluster 4',
    scientificName: 'Raphanus sativus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Cluster 4 radish micro. Spicy, colorful, 5-7 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Cluster 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'broccoli-micro-solo-4',
    name: 'Broccoli micro - Solo 4',
    scientificName: 'Brassica oleracea var. italica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Solo 4 broccoli micro. Mild, nutritious, high sulforaphane.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Solo 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'kale-micro-individual-4',
    name: 'Kale micro - Individual 4',
    scientificName: 'Brassica oleracea var. sabellica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Individual 4 kale micro. Mild, tender, super nutritious.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Individual 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'mustard-micro-bunch-4',
    name: 'Mustard micro - Bunch 4',
    scientificName: 'Brassica juncea',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bunch 4 mustard micro. Spicy kick, colorful varieties.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Bunch 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'beet-micro-bundle-4',
    name: 'Beet micro - Bundle 4',
    scientificName: 'Beta vulgaris',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bundle 4 beet micro. Beautiful red stems, earthy flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Amaranthaceae',
    varieties: ['Bundle 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'chia-micro-bouquet-4',
    name: 'Chia micro - Bouquet 4',
    scientificName: 'Salvia hispanica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bouquet 4 chia micro. Nutty, gel-coated seeds, omega-3 rich.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Lamiaceae',
    varieties: ['Bouquet 4'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'sunflower-black-oil-5',
    name: 'Sunflower - Black Oil 5',
    scientificName: 'Helianthus annuus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Black Oil 5 sunflower. Nutty, crunchy microgreen, 7-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Asteraceae',
    varieties: ['Black Oil 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'pea-shoots-striped-5',
    name: 'Pea shoots - Striped 5',
    scientificName: 'Pisum sativum',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Striped 5 pea shoots. Sweet, tender shoots, 8-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Striped 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'radish-micro-mammoth-5',
    name: 'Radish micro - Mammoth 5',
    scientificName: 'Raphanus sativus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Mammoth 5 radish micro. Spicy, colorful, 5-7 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Mammoth 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'broccoli-micro-dwarf-5',
    name: 'Broccoli micro - Dwarf 5',
    scientificName: 'Brassica oleracea var. italica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Dwarf 5 broccoli micro. Mild, nutritious, high sulforaphane.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Dwarf 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'kale-micro-teddy-bear-5',
    name: 'Kale micro - Teddy Bear 5',
    scientificName: 'Brassica oleracea var. sabellica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Teddy Bear 5 kale micro. Mild, tender, super nutritious.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Teddy Bear 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'mustard-micro-dun-5',
    name: 'Mustard micro - Dun 5',
    scientificName: 'Brassica juncea',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Dun 5 mustard micro. Spicy kick, colorful varieties.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Dun 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'beet-micro-green-5',
    name: 'Beet micro - Green 5',
    scientificName: 'Beta vulgaris',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Green 5 beet micro. Beautiful red stems, earthy flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Amaranthaceae',
    varieties: ['Green 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'chia-micro-yellow-5',
    name: 'Chia micro - Yellow 5',
    scientificName: 'Salvia hispanica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Yellow 5 chia micro. Nutty, gel-coated seeds, omega-3 rich.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Lamiaceae',
    varieties: ['Yellow 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'sunflower-speckled-5',
    name: 'Sunflower - Speckled 5',
    scientificName: 'Helianthus annuus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Speckled 5 sunflower. Nutty, crunchy microgreen, 7-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Asteraceae',
    varieties: ['Speckled 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'pea-shoots-sugar-snap-5',
    name: 'Pea shoots - Sugar Snap 5',
    scientificName: 'Pisum sativum',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Sugar Snap 5 pea shoots. Sweet, tender shoots, 8-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Sugar Snap 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'radish-micro-daikon-5',
    name: 'Radish micro - Daikon 5',
    scientificName: 'Raphanus sativus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Daikon 5 radish micro. Spicy, colorful, 5-7 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Daikon 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'broccoli-micro-china-rose-5',
    name: 'Broccoli micro - China Rose 5',
    scientificName: 'Brassica oleracea var. italica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'China Rose 5 broccoli micro. Mild, nutritious, high sulforaphane.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['China Rose 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'kale-micro-red-rambo-5',
    name: 'Kale micro - Red Rambo 5',
    scientificName: 'Brassica oleracea var. sabellica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Red Rambo 5 kale micro. Mild, tender, super nutritious.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Red Rambo 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'mustard-micro-triton-5',
    name: 'Mustard micro - Triton 5',
    scientificName: 'Brassica juncea',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Triton 5 mustard micro. Spicy kick, colorful varieties.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Triton 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'beet-micro-purple-5',
    name: 'Beet micro - Purple 5',
    scientificName: 'Beta vulgaris',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Purple 5 beet micro. Beautiful red stems, earthy flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Amaranthaceae',
    varieties: ['Purple 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'chia-micro-waltham-5',
    name: 'Chia micro - Waltham 5',
    scientificName: 'Salvia hispanica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Waltham 5 chia micro. Nutty, gel-coated seeds, omega-3 rich.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Lamiaceae',
    varieties: ['Waltham 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'sunflower-calabrese-5',
    name: 'Sunflower - Calabrese 5',
    scientificName: 'Helianthus annuus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Calabrese 5 sunflower. Nutty, crunchy microgreen, 7-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Asteraceae',
    varieties: ['Calabrese 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'pea-shoots-belstar-5',
    name: 'Pea shoots - Belstar 5',
    scientificName: 'Pisum sativum',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Belstar 5 pea shoots. Sweet, tender shoots, 8-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Belstar 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'radish-micro-green-magic-5',
    name: 'Radish micro - Green Magic 5',
    scientificName: 'Raphanus sativus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Green Magic 5 radish micro. Spicy, colorful, 5-7 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Green Magic 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'broccoli-micro-de-cicco-5',
    name: 'Broccoli micro - De Cicco 5',
    scientificName: 'Brassica oleracea var. italica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'De Cicco 5 broccoli micro. Mild, nutritious, high sulforaphane.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['De Cicco 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'kale-micro-red-russian-5',
    name: 'Kale micro - Red Russian 5',
    scientificName: 'Brassica oleracea var. sabellica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Red Russian 5 kale micro. Mild, tender, super nutritious.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Red Russian 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'mustard-micro-lacinato-5',
    name: 'Mustard micro - Lacinato 5',
    scientificName: 'Brassica juncea',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Lacinato 5 mustard micro. Spicy kick, colorful varieties.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Lacinato 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'beet-micro-dwarf-blue-5',
    name: 'Beet micro - Dwarf Blue 5',
    scientificName: 'Beta vulgaris',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Dwarf Blue 5 beet micro. Beautiful red stems, earthy flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Amaranthaceae',
    varieties: ['Dwarf Blue 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'chia-micro-winterbor-5',
    name: 'Chia micro - Winterbor 5',
    scientificName: 'Salvia hispanica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Winterbor 5 chia micro. Nutty, gel-coated seeds, omega-3 rich.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Lamiaceae',
    varieties: ['Winterbor 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'sunflower-premier-5',
    name: 'Sunflower - Premier 5',
    scientificName: 'Helianthus annuus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Premier 5 sunflower. Nutty, crunchy microgreen, 7-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Asteraceae',
    varieties: ['Premier 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'pea-shoots-red-giant-5',
    name: 'Pea shoots - Red Giant 5',
    scientificName: 'Pisum sativum',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Red Giant 5 pea shoots. Sweet, tender shoots, 8-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Red Giant 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'radish-micro-green-wave-5',
    name: 'Radish micro - Green Wave 5',
    scientificName: 'Raphanus sativus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Green Wave 5 radish micro. Spicy, colorful, 5-7 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Green Wave 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'broccoli-micro-southern-giant-5',
    name: 'Broccoli micro - Southern Giant 5',
    scientificName: 'Brassica oleracea var. italica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Southern Giant 5 broccoli micro. Mild, nutritious, high sulforaphane.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Southern Giant 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'kale-micro-osaka-purple-5',
    name: 'Kale micro - Osaka Purple 5',
    scientificName: 'Brassica oleracea var. sabellica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Osaka Purple 5 kale micro. Mild, tender, super nutritious.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Osaka Purple 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'mustard-micro-ruby-streaks-5',
    name: 'Mustard micro - Ruby Streaks 5',
    scientificName: 'Brassica juncea',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Ruby Streaks 5 mustard micro. Spicy kick, colorful varieties.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Ruby Streaks 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'beet-micro-bull-5',
    name: 'Beet micro - Bull 5',
    scientificName: 'Beta vulgaris',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bull 5 beet micro. Beautiful red stems, earthy flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Amaranthaceae',
    varieties: ['Bull 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'chia-micro-bulls-blood-5',
    name: 'Chia micro - Bulls Blood 5',
    scientificName: 'Salvia hispanica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bulls Blood 5 chia micro. Nutty, gel-coated seeds, omega-3 rich.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Lamiaceae',
    varieties: ['Bulls Blood 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'sunflower-detroit-dark-red-5',
    name: 'Sunflower - Detroit Dark Red 5',
    scientificName: 'Helianthus annuus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Detroit Dark Red 5 sunflower. Nutty, crunchy microgreen, 7-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Asteraceae',
    varieties: ['Detroit Dark Red 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'pea-shoots-golden-5',
    name: 'Pea shoots - Golden 5',
    scientificName: 'Pisum sativum',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Golden 5 pea shoots. Sweet, tender shoots, 8-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Golden 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'radish-micro-chioggia-5',
    name: 'Radish micro - Chioggia 5',
    scientificName: 'Raphanus sativus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Chioggia 5 radish micro. Spicy, colorful, 5-7 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Chioggia 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'broccoli-micro-black-5',
    name: 'Broccoli micro - Black 5',
    scientificName: 'Brassica oleracea var. italica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Black 5 broccoli micro. Mild, nutritious, high sulforaphane.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Black 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'kale-micro-white-5',
    name: 'Kale micro - White 5',
    scientificName: 'Brassica oleracea var. sabellica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'White 5 kale micro. Mild, tender, super nutritious.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['White 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'mustard-micro-golden-5',
    name: 'Mustard micro - Golden 5',
    scientificName: 'Brassica juncea',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Golden 5 mustard micro. Spicy kick, colorful varieties.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Golden 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'beet-micro-brown-5',
    name: 'Beet micro - Brown 5',
    scientificName: 'Beta vulgaris',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Brown 5 beet micro. Beautiful red stems, earthy flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Amaranthaceae',
    varieties: ['Brown 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'chia-micro-red-5',
    name: 'Chia micro - Red 5',
    scientificName: 'Salvia hispanica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Red 5 chia micro. Nutty, gel-coated seeds, omega-3 rich.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Lamiaceae',
    varieties: ['Red 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'sunflower-sprouting-5',
    name: 'Sunflower - Sprouting 5',
    scientificName: 'Helianthus annuus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Sprouting 5 sunflower. Nutty, crunchy microgreen, 7-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Asteraceae',
    varieties: ['Sprouting 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'pea-shoots-microgreen-5',
    name: 'Pea shoots - Microgreen 5',
    scientificName: 'Pisum sativum',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Microgreen 5 pea shoots. Sweet, tender shoots, 8-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Microgreen 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'radish-micro-shoot-5',
    name: 'Radish micro - Shoot 5',
    scientificName: 'Raphanus sativus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Shoot 5 radish micro. Spicy, colorful, 5-7 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Shoot 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'broccoli-micro-baby-green-5',
    name: 'Broccoli micro - Baby Green 5',
    scientificName: 'Brassica oleracea var. italica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Baby Green 5 broccoli micro. Mild, nutritious, high sulforaphane.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Baby Green 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'kale-micro-tender-5',
    name: 'Kale micro - Tender 5',
    scientificName: 'Brassica oleracea var. sabellica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Tender 5 kale micro. Mild, tender, super nutritious.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Tender 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'mustard-micro-quick-5',
    name: 'Mustard micro - Quick 5',
    scientificName: 'Brassica juncea',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Quick 5 mustard micro. Spicy kick, colorful varieties.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Quick 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'beet-micro-fast-5',
    name: 'Beet micro - Fast 5',
    scientificName: 'Beta vulgaris',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Fast 5 beet micro. Beautiful red stems, earthy flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Amaranthaceae',
    varieties: ['Fast 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'chia-micro-speedy-5',
    name: 'Chia micro - Speedy 5',
    scientificName: 'Salvia hispanica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Speedy 5 chia micro. Nutty, gel-coated seeds, omega-3 rich.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Lamiaceae',
    varieties: ['Speedy 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'sunflower-rapid-5',
    name: 'Sunflower - Rapid 5',
    scientificName: 'Helianthus annuus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Rapid 5 sunflower. Nutty, crunchy microgreen, 7-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Asteraceae',
    varieties: ['Rapid 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'pea-shoots-swift-5',
    name: 'Pea shoots - Swift 5',
    scientificName: 'Pisum sativum',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Swift 5 pea shoots. Sweet, tender shoots, 8-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Swift 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'radish-micro-organic-5',
    name: 'Radish micro - Organic 5',
    scientificName: 'Raphanus sativus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Organic 5 radish micro. Spicy, colorful, 5-7 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Organic 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'broccoli-micro-non-gmo-5',
    name: 'Broccoli micro - Non-GMO 5',
    scientificName: 'Brassica oleracea var. italica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Non-GMO 5 broccoli micro. Mild, nutritious, high sulforaphane.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Non-GMO 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'kale-micro-heirloom-5',
    name: 'Kale micro - Heirloom 5',
    scientificName: 'Brassica oleracea var. sabellica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Heirloom 5 kale micro. Mild, tender, super nutritious.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Heirloom 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'mustard-micro-hybrid-5',
    name: 'Mustard micro - Hybrid 5',
    scientificName: 'Brassica juncea',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Hybrid 5 mustard micro. Spicy kick, colorful varieties.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Hybrid 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'beet-micro-open-pollinated-5',
    name: 'Beet micro - Open Pollinated 5',
    scientificName: 'Beta vulgaris',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Open Pollinated 5 beet micro. Beautiful red stems, earthy flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Amaranthaceae',
    varieties: ['Open Pollinated 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'chia-micro-dwarf-5',
    name: 'Chia micro - Dwarf 5',
    scientificName: 'Salvia hispanica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Dwarf 5 chia micro. Nutty, gel-coated seeds, omega-3 rich.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Lamiaceae',
    varieties: ['Dwarf 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'sunflower-giant-5',
    name: 'Sunflower - Giant 5',
    scientificName: 'Helianthus annuus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Giant 5 sunflower. Nutty, crunchy microgreen, 7-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Asteraceae',
    varieties: ['Giant 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'pea-shoots-baby-5',
    name: 'Pea shoots - Baby 5',
    scientificName: 'Pisum sativum',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Baby 5 pea shoots. Sweet, tender shoots, 8-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Baby 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'radish-micro-micro-5',
    name: 'Radish micro - Micro 5',
    scientificName: 'Raphanus sativus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Micro 5 radish micro. Spicy, colorful, 5-7 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Micro 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'broccoli-micro-mini-5',
    name: 'Broccoli micro - Mini 5',
    scientificName: 'Brassica oleracea var. italica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Mini 5 broccoli micro. Mild, nutritious, high sulforaphane.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Mini 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'kale-micro-sweet-5',
    name: 'Kale micro - Sweet 5',
    scientificName: 'Brassica oleracea var. sabellica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Sweet 5 kale micro. Mild, tender, super nutritious.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Sweet 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'mustard-micro-spicy-5',
    name: 'Mustard micro - Spicy 5',
    scientificName: 'Brassica juncea',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Spicy 5 mustard micro. Spicy kick, colorful varieties.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Spicy 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'beet-micro-mild-5',
    name: 'Beet micro - Mild 5',
    scientificName: 'Beta vulgaris',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Mild 5 beet micro. Beautiful red stems, earthy flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Amaranthaceae',
    varieties: ['Mild 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'chia-micro-peppery-5',
    name: 'Chia micro - Peppery 5',
    scientificName: 'Salvia hispanica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Peppery 5 chia micro. Nutty, gel-coated seeds, omega-3 rich.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Lamiaceae',
    varieties: ['Peppery 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'sunflower-nutty-5',
    name: 'Sunflower - Nutty 5',
    scientificName: 'Helianthus annuus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Nutty 5 sunflower. Nutty, crunchy microgreen, 7-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Asteraceae',
    varieties: ['Nutty 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'pea-shoots-crunchy-5',
    name: 'Pea shoots - Crunchy 5',
    scientificName: 'Pisum sativum',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Crunchy 5 pea shoots. Sweet, tender shoots, 8-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Crunchy 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'radish-micro-tender-5',
    name: 'Radish micro - Tender 5',
    scientificName: 'Raphanus sativus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Tender 5 radish micro. Spicy, colorful, 5-7 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Tender 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'broccoli-micro-crisp-5',
    name: 'Broccoli micro - Crisp 5',
    scientificName: 'Brassica oleracea var. italica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Crisp 5 broccoli micro. Mild, nutritious, high sulforaphane.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Crisp 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'kale-micro-juicy-5',
    name: 'Kale micro - Juicy 5',
    scientificName: 'Brassica oleracea var. sabellica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Juicy 5 kale micro. Mild, tender, super nutritious.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Juicy 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'mustard-micro-succulent-5',
    name: 'Mustard micro - Succulent 5',
    scientificName: 'Brassica juncea',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Succulent 5 mustard micro. Spicy kick, colorful varieties.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Succulent 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'beet-micro-green-5',
    name: 'Beet micro - Green 5',
    scientificName: 'Beta vulgaris',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Green 5 beet micro. Beautiful red stems, earthy flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Amaranthaceae',
    varieties: ['Green 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'chia-micro-red-5',
    name: 'Chia micro - Red 5',
    scientificName: 'Salvia hispanica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Red 5 chia micro. Nutty, gel-coated seeds, omega-3 rich.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Lamiaceae',
    varieties: ['Red 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'sunflower-purple-5',
    name: 'Sunflower - Purple 5',
    scientificName: 'Helianthus annuus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Purple 5 sunflower. Nutty, crunchy microgreen, 7-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Asteraceae',
    varieties: ['Purple 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'pea-shoots-yellow-5',
    name: 'Pea shoots - Yellow 5',
    scientificName: 'Pisum sativum',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Yellow 5 pea shoots. Sweet, tender shoots, 8-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Yellow 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'radish-micro-golden-5',
    name: 'Radish micro - Golden 5',
    scientificName: 'Raphanus sativus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Golden 5 radish micro. Spicy, colorful, 5-7 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Golden 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'broccoli-micro-dark-5',
    name: 'Broccoli micro - Dark 5',
    scientificName: 'Brassica oleracea var. italica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Dark 5 broccoli micro. Mild, nutritious, high sulforaphane.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Dark 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'kale-micro-light-5',
    name: 'Kale micro - Light 5',
    scientificName: 'Brassica oleracea var. sabellica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Light 5 kale micro. Mild, tender, super nutritious.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Light 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'mustard-micro-pale-5',
    name: 'Mustard micro - Pale 5',
    scientificName: 'Brassica juncea',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Pale 5 mustard micro. Spicy kick, colorful varieties.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Pale 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'beet-micro-deep-5',
    name: 'Beet micro - Deep 5',
    scientificName: 'Beta vulgaris',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Deep 5 beet micro. Beautiful red stems, earthy flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Amaranthaceae',
    varieties: ['Deep 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'chia-micro-bright-5',
    name: 'Chia micro - Bright 5',
    scientificName: 'Salvia hispanica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bright 5 chia micro. Nutty, gel-coated seeds, omega-3 rich.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Lamiaceae',
    varieties: ['Bright 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'sunflower-smooth-5',
    name: 'Sunflower - Smooth 5',
    scientificName: 'Helianthus annuus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Smooth 5 sunflower. Nutty, crunchy microgreen, 7-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Asteraceae',
    varieties: ['Smooth 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'pea-shoots-curly-5',
    name: 'Pea shoots - Curly 5',
    scientificName: 'Pisum sativum',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Curly 5 pea shoots. Sweet, tender shoots, 8-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Curly 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'radish-micro-frilly-5',
    name: 'Radish micro - Frilly 5',
    scientificName: 'Raphanus sativus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Frilly 5 radish micro. Spicy, colorful, 5-7 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Frilly 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'broccoli-micro-feathery-5',
    name: 'Broccoli micro - Feathery 5',
    scientificName: 'Brassica oleracea var. italica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Feathery 5 broccoli micro. Mild, nutritious, high sulforaphane.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Feathery 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'kale-micro-lacy-5',
    name: 'Kale micro - Lacy 5',
    scientificName: 'Brassica oleracea var. sabellica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Lacy 5 kale micro. Mild, tender, super nutritious.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Lacy 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'mustard-micro-round-5',
    name: 'Mustard micro - Round 5',
    scientificName: 'Brassica juncea',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Round 5 mustard micro. Spicy kick, colorful varieties.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Round 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'beet-micro-oval-5',
    name: 'Beet micro - Oval 5',
    scientificName: 'Beta vulgaris',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Oval 5 beet micro. Beautiful red stems, earthy flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Amaranthaceae',
    varieties: ['Oval 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'chia-micro-long-5',
    name: 'Chia micro - Long 5',
    scientificName: 'Salvia hispanica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Long 5 chia micro. Nutty, gel-coated seeds, omega-3 rich.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Lamiaceae',
    varieties: ['Long 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'sunflower-short-5',
    name: 'Sunflower - Short 5',
    scientificName: 'Helianthus annuus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Short 5 sunflower. Nutty, crunchy microgreen, 7-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Asteraceae',
    varieties: ['Short 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'pea-shoots-elongated-5',
    name: 'Pea shoots - Elongated 5',
    scientificName: 'Pisum sativum',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Elongated 5 pea shoots. Sweet, tender shoots, 8-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Elongated 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'radish-micro-single-5',
    name: 'Radish micro - Single 5',
    scientificName: 'Raphanus sativus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Single 5 radish micro. Spicy, colorful, 5-7 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Single 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'broccoli-micro-double-5',
    name: 'Broccoli micro - Double 5',
    scientificName: 'Brassica oleracea var. italica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Double 5 broccoli micro. Mild, nutritious, high sulforaphane.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Double 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'kale-micro-triple-5',
    name: 'Kale micro - Triple 5',
    scientificName: 'Brassica oleracea var. sabellica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Triple 5 kale micro. Mild, tender, super nutritious.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Triple 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'mustard-micro-multi-5',
    name: 'Mustard micro - Multi 5',
    scientificName: 'Brassica juncea',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Multi 5 mustard micro. Spicy kick, colorful varieties.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Multi 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'beet-micro-cluster-5',
    name: 'Beet micro - Cluster 5',
    scientificName: 'Beta vulgaris',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Cluster 5 beet micro. Beautiful red stems, earthy flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Amaranthaceae',
    varieties: ['Cluster 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'chia-micro-solo-5',
    name: 'Chia micro - Solo 5',
    scientificName: 'Salvia hispanica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Solo 5 chia micro. Nutty, gel-coated seeds, omega-3 rich.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Lamiaceae',
    varieties: ['Solo 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'sunflower-individual-5',
    name: 'Sunflower - Individual 5',
    scientificName: 'Helianthus annuus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Individual 5 sunflower. Nutty, crunchy microgreen, 7-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Asteraceae',
    varieties: ['Individual 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'pea-shoots-bunch-5',
    name: 'Pea shoots - Bunch 5',
    scientificName: 'Pisum sativum',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 12,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bunch 5 pea shoots. Sweet, tender shoots, 8-12 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Bunch 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'radish-micro-bundle-5',
    name: 'Radish micro - Bundle 5',
    scientificName: 'Raphanus sativus',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bundle 5 radish micro. Spicy, colorful, 5-7 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Bundle 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  },
  {
    id: 'broccoli-micro-bouquet-5',
    name: 'Broccoli micro - Bouquet 5',
    scientificName: 'Brassica oleracea var. italica',
    category: 'microgreen',
    spacing: 0.25,
    rowSpacing: 0.5,
    daysToGermination: 3,
    daysToHarvest: 7,
    sun: 'partial',
    water: 'medium',
    soil: 'seed starting mix',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bouquet 5 broccoli micro. Mild, nutritious, high sulforaphane.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-3 inches',
    spread: 'dense mat',
    family: 'Brassicaceae',
    varieties: ['Bouquet 5'],
    uses: ['salads', 'sandwiches', 'garnish', 'smoothies', 'nutrition']
  }
,
  {
    id: 'alfalfa-standard',
    name: 'Alfalfa - Standard',
    scientificName: 'Medicago sativa',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Standard alfalfa. Mild, nutty, classic sandwich sprout.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Standard'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'mung-bean-organic',
    name: 'Mung bean - Organic',
    scientificName: 'Vigna radiata',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 4,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Organic mung bean. Crunchy, mild, Asian cuisine staple.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Organic'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'lentil-non-gmo',
    name: 'Lentil - Non-GMO',
    scientificName: 'Lens culinaris',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Non-GMO lentil. Peppery, protein-rich, 2-3 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Non-GMO'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'chickpea-heirloom',
    name: 'Chickpea - Heirloom',
    scientificName: 'Cicer arietinum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Heirloom chickpea. Nutty, substantial, hummus sprouts.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Heirloom'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'broccoli-sprout-hybrid',
    name: 'Broccoli sprout - Hybrid',
    scientificName: 'Brassica oleracea var. italica',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Hybrid broccoli sprout. High sulforaphane, cancer-fighting compound.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Hybrid'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'radish-sprout-green',
    name: 'Radish sprout - Green',
    scientificName: 'Raphanus sativus',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Green radish sprout. Spicy kick, colorful, 3-4 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Green'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'clover-sprout-golden',
    name: 'Clover sprout - Golden',
    scientificName: 'Trifolium pratense',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Golden clover sprout. Mild, sweet, similar to alfalfa.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Golden'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'fenugreek-yellow',
    name: 'Fenugreek - Yellow',
    scientificName: 'Trigonella foenum-graecum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Yellow fenugreek. Bitter, aromatic, curry spice flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Yellow'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'alfalfa-brown',
    name: 'Alfalfa - Brown',
    scientificName: 'Medicago sativa',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Brown alfalfa. Mild, nutty, classic sandwich sprout.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Brown'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'mung-bean-black',
    name: 'Mung bean - Black',
    scientificName: 'Vigna radiata',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 4,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Black mung bean. Crunchy, mild, Asian cuisine staple.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Black'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'lentil-french',
    name: 'Lentil - French',
    scientificName: 'Lens culinaris',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'French lentil. Peppery, protein-rich, 2-3 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['French'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'chickpea-spanish',
    name: 'Chickpea - Spanish',
    scientificName: 'Cicer arietinum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Spanish chickpea. Nutty, substantial, hummus sprouts.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Spanish'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'broccoli-sprout-italian',
    name: 'Broccoli sprout - Italian',
    scientificName: 'Brassica oleracea var. italica',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Italian broccoli sprout. High sulforaphane, cancer-fighting compound.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Italian'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'radish-sprout-greek',
    name: 'Radish sprout - Greek',
    scientificName: 'Raphanus sativus',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Greek radish sprout. Spicy kick, colorful, 3-4 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Greek'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'clover-sprout-turkish',
    name: 'Clover sprout - Turkish',
    scientificName: 'Trifolium pratense',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Turkish clover sprout. Mild, sweet, similar to alfalfa.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Turkish'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'fenugreek-indian',
    name: 'Fenugreek - Indian',
    scientificName: 'Trigonella foenum-graecum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Indian fenugreek. Bitter, aromatic, curry spice flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Indian'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'alfalfa-chinese',
    name: 'Alfalfa - Chinese',
    scientificName: 'Medicago sativa',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Chinese alfalfa. Mild, nutty, classic sandwich sprout.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Chinese'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'mung-bean-japanese',
    name: 'Mung bean - Japanese',
    scientificName: 'Vigna radiata',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 4,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Japanese mung bean. Crunchy, mild, Asian cuisine staple.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Japanese'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'lentil-korean',
    name: 'Lentil - Korean',
    scientificName: 'Lens culinaris',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Korean lentil. Peppery, protein-rich, 2-3 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Korean'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'chickpea-thai',
    name: 'Chickpea - Thai',
    scientificName: 'Cicer arietinum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Thai chickpea. Nutty, substantial, hummus sprouts.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Thai'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'broccoli-sprout-dwarf',
    name: 'Broccoli sprout - Dwarf',
    scientificName: 'Brassica oleracea var. italica',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Dwarf broccoli sprout. High sulforaphane, cancer-fighting compound.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Dwarf'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'radish-sprout-giant',
    name: 'Radish sprout - Giant',
    scientificName: 'Raphanus sativus',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Giant radish sprout. Spicy kick, colorful, 3-4 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Giant'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'clover-sprout-baby',
    name: 'Clover sprout - Baby',
    scientificName: 'Trifolium pratense',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Baby clover sprout. Mild, sweet, similar to alfalfa.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Baby'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'fenugreek-micro',
    name: 'Fenugreek - Micro',
    scientificName: 'Trigonella foenum-graecum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Micro fenugreek. Bitter, aromatic, curry spice flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Micro'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'alfalfa-mini',
    name: 'Alfalfa - Mini',
    scientificName: 'Medicago sativa',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Mini alfalfa. Mild, nutty, classic sandwich sprout.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Mini'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'mung-bean-quick',
    name: 'Mung bean - Quick',
    scientificName: 'Vigna radiata',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 4,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Quick mung bean. Crunchy, mild, Asian cuisine staple.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Quick'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'lentil-fast',
    name: 'Lentil - Fast',
    scientificName: 'Lens culinaris',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Fast lentil. Peppery, protein-rich, 2-3 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Fast'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'chickpea-speedy',
    name: 'Chickpea - Speedy',
    scientificName: 'Cicer arietinum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Speedy chickpea. Nutty, substantial, hummus sprouts.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Speedy'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'broccoli-sprout-rapid',
    name: 'Broccoli sprout - Rapid',
    scientificName: 'Brassica oleracea var. italica',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Rapid broccoli sprout. High sulforaphane, cancer-fighting compound.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Rapid'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'radish-sprout-swift',
    name: 'Radish sprout - Swift',
    scientificName: 'Raphanus sativus',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Swift radish sprout. Spicy kick, colorful, 3-4 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Swift'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'clover-sprout-sweet',
    name: 'Clover sprout - Sweet',
    scientificName: 'Trifolium pratense',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Sweet clover sprout. Mild, sweet, similar to alfalfa.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Sweet'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'fenugreek-spicy',
    name: 'Fenugreek - Spicy',
    scientificName: 'Trigonella foenum-graecum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Spicy fenugreek. Bitter, aromatic, curry spice flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Spicy'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'alfalfa-mild',
    name: 'Alfalfa - Mild',
    scientificName: 'Medicago sativa',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Mild alfalfa. Mild, nutty, classic sandwich sprout.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Mild'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'mung-bean-bitter',
    name: 'Mung bean - Bitter',
    scientificName: 'Vigna radiata',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 4,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bitter mung bean. Crunchy, mild, Asian cuisine staple.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Bitter'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'lentil-nutty',
    name: 'Lentil - Nutty',
    scientificName: 'Lens culinaris',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Nutty lentil. Peppery, protein-rich, 2-3 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Nutty'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'chickpea-crunchy',
    name: 'Chickpea - Crunchy',
    scientificName: 'Cicer arietinum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Crunchy chickpea. Nutty, substantial, hummus sprouts.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Crunchy'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'broccoli-sprout-tender',
    name: 'Broccoli sprout - Tender',
    scientificName: 'Brassica oleracea var. italica',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Tender broccoli sprout. High sulforaphane, cancer-fighting compound.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Tender'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'radish-sprout-crisp',
    name: 'Radish sprout - Crisp',
    scientificName: 'Raphanus sativus',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Crisp radish sprout. Spicy kick, colorful, 3-4 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Crisp'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'clover-sprout-soft',
    name: 'Clover sprout - Soft',
    scientificName: 'Trifolium pratense',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Soft clover sprout. Mild, sweet, similar to alfalfa.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Soft'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'fenugreek-firm',
    name: 'Fenugreek - Firm',
    scientificName: 'Trigonella foenum-graecum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Firm fenugreek. Bitter, aromatic, curry spice flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Firm'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'alfalfa-green',
    name: 'Alfalfa - Green',
    scientificName: 'Medicago sativa',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Green alfalfa. Mild, nutty, classic sandwich sprout.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Green'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'mung-bean-red',
    name: 'Mung bean - Red',
    scientificName: 'Vigna radiata',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 4,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Red mung bean. Crunchy, mild, Asian cuisine staple.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Red'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'lentil-purple',
    name: 'Lentil - Purple',
    scientificName: 'Lens culinaris',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Purple lentil. Peppery, protein-rich, 2-3 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Purple'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'chickpea-yellow',
    name: 'Chickpea - Yellow',
    scientificName: 'Cicer arietinum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Yellow chickpea. Nutty, substantial, hummus sprouts.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Yellow'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'broccoli-sprout-golden',
    name: 'Broccoli sprout - Golden',
    scientificName: 'Brassica oleracea var. italica',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Golden broccoli sprout. High sulforaphane, cancer-fighting compound.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Golden'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'radish-sprout-dark',
    name: 'Radish sprout - Dark',
    scientificName: 'Raphanus sativus',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Dark radish sprout. Spicy kick, colorful, 3-4 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Dark'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'clover-sprout-light',
    name: 'Clover sprout - Light',
    scientificName: 'Trifolium pratense',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Light clover sprout. Mild, sweet, similar to alfalfa.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Light'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'fenugreek-pale',
    name: 'Fenugreek - Pale',
    scientificName: 'Trigonella foenum-graecum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Pale fenugreek. Bitter, aromatic, curry spice flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Pale'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'alfalfa-deep',
    name: 'Alfalfa - Deep',
    scientificName: 'Medicago sativa',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Deep alfalfa. Mild, nutty, classic sandwich sprout.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Deep'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'mung-bean-bright',
    name: 'Mung bean - Bright',
    scientificName: 'Vigna radiata',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 4,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bright mung bean. Crunchy, mild, Asian cuisine staple.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Bright'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'lentil-round',
    name: 'Lentil - Round',
    scientificName: 'Lens culinaris',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Round lentil. Peppery, protein-rich, 2-3 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Round'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'chickpea-oval',
    name: 'Chickpea - Oval',
    scientificName: 'Cicer arietinum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Oval chickpea. Nutty, substantial, hummus sprouts.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Oval'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'broccoli-sprout-long',
    name: 'Broccoli sprout - Long',
    scientificName: 'Brassica oleracea var. italica',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Long broccoli sprout. High sulforaphane, cancer-fighting compound.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Long'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'radish-sprout-short',
    name: 'Radish sprout - Short',
    scientificName: 'Raphanus sativus',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Short radish sprout. Spicy kick, colorful, 3-4 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Short'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'clover-sprout-elongated',
    name: 'Clover sprout - Elongated',
    scientificName: 'Trifolium pratense',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Elongated clover sprout. Mild, sweet, similar to alfalfa.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Elongated'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'fenugreek-single',
    name: 'Fenugreek - Single',
    scientificName: 'Trigonella foenum-graecum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Single fenugreek. Bitter, aromatic, curry spice flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Single'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'alfalfa-double',
    name: 'Alfalfa - Double',
    scientificName: 'Medicago sativa',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Double alfalfa. Mild, nutty, classic sandwich sprout.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Double'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'mung-bean-triple',
    name: 'Mung bean - Triple',
    scientificName: 'Vigna radiata',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 4,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Triple mung bean. Crunchy, mild, Asian cuisine staple.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Triple'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'lentil-multi',
    name: 'Lentil - Multi',
    scientificName: 'Lens culinaris',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Multi lentil. Peppery, protein-rich, 2-3 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Multi'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'chickpea-cluster',
    name: 'Chickpea - Cluster',
    scientificName: 'Cicer arietinum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Cluster chickpea. Nutty, substantial, hummus sprouts.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Cluster'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'broccoli-sprout-solo',
    name: 'Broccoli sprout - Solo',
    scientificName: 'Brassica oleracea var. italica',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Solo broccoli sprout. High sulforaphane, cancer-fighting compound.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Solo'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'radish-sprout-individual',
    name: 'Radish sprout - Individual',
    scientificName: 'Raphanus sativus',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Individual radish sprout. Spicy kick, colorful, 3-4 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Individual'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'clover-sprout-bunch',
    name: 'Clover sprout - Bunch',
    scientificName: 'Trifolium pratense',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bunch clover sprout. Mild, sweet, similar to alfalfa.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Bunch'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'fenugreek-bundle',
    name: 'Fenugreek - Bundle',
    scientificName: 'Trigonella foenum-graecum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bundle fenugreek. Bitter, aromatic, curry spice flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Bundle'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'alfalfa-bouquet',
    name: 'Alfalfa - Bouquet',
    scientificName: 'Medicago sativa',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bouquet alfalfa. Mild, nutty, classic sandwich sprout.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Bouquet'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'mung-bean-sprouting',
    name: 'Mung bean - Sprouting',
    scientificName: 'Vigna radiata',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 4,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Sprouting mung bean. Crunchy, mild, Asian cuisine staple.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Sprouting'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'lentil-microgreen',
    name: 'Lentil - Microgreen',
    scientificName: 'Lens culinaris',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Microgreen lentil. Peppery, protein-rich, 2-3 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Microgreen'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'chickpea-shoot',
    name: 'Chickpea - Shoot',
    scientificName: 'Cicer arietinum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Shoot chickpea. Nutty, substantial, hummus sprouts.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Shoot'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'broccoli-sprout-baby',
    name: 'Broccoli sprout - Baby',
    scientificName: 'Brassica oleracea var. italica',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Baby broccoli sprout. High sulforaphane, cancer-fighting compound.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Baby'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'radish-sprout-tender',
    name: 'Radish sprout - Tender',
    scientificName: 'Raphanus sativus',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Tender radish sprout. Spicy kick, colorful, 3-4 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Tender'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'clover-sprout-organic',
    name: 'Clover sprout - Organic',
    scientificName: 'Trifolium pratense',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Organic clover sprout. Mild, sweet, similar to alfalfa.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Organic'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'fenugreek-non-gmo',
    name: 'Fenugreek - Non-GMO',
    scientificName: 'Trigonella foenum-graecum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Non-GMO fenugreek. Bitter, aromatic, curry spice flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Non-GMO'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'alfalfa-heirloom',
    name: 'Alfalfa - Heirloom',
    scientificName: 'Medicago sativa',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Heirloom alfalfa. Mild, nutty, classic sandwich sprout.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Heirloom'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'mung-bean-hybrid',
    name: 'Mung bean - Hybrid',
    scientificName: 'Vigna radiata',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 4,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Hybrid mung bean. Crunchy, mild, Asian cuisine staple.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Hybrid'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'lentil-open-pollinated',
    name: 'Lentil - Open Pollinated',
    scientificName: 'Lens culinaris',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Open Pollinated lentil. Peppery, protein-rich, 2-3 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Open Pollinated'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'chickpea-dwarf',
    name: 'Chickpea - Dwarf',
    scientificName: 'Cicer arietinum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Dwarf chickpea. Nutty, substantial, hummus sprouts.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Dwarf'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'broccoli-sprout-giant',
    name: 'Broccoli sprout - Giant',
    scientificName: 'Brassica oleracea var. italica',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Giant broccoli sprout. High sulforaphane, cancer-fighting compound.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Giant'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'radish-sprout-baby',
    name: 'Radish sprout - Baby',
    scientificName: 'Raphanus sativus',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Baby radish sprout. Spicy kick, colorful, 3-4 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Baby'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'clover-sprout-micro',
    name: 'Clover sprout - Micro',
    scientificName: 'Trifolium pratense',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Micro clover sprout. Mild, sweet, similar to alfalfa.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Micro'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'fenugreek-mini',
    name: 'Fenugreek - Mini',
    scientificName: 'Trigonella foenum-graecum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Mini fenugreek. Bitter, aromatic, curry spice flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Mini'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'alfalfa-sweet',
    name: 'Alfalfa - Sweet',
    scientificName: 'Medicago sativa',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Sweet alfalfa. Mild, nutty, classic sandwich sprout.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Sweet'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'mung-bean-spicy',
    name: 'Mung bean - Spicy',
    scientificName: 'Vigna radiata',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 4,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Spicy mung bean. Crunchy, mild, Asian cuisine staple.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Spicy'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'lentil-mild',
    name: 'Lentil - Mild',
    scientificName: 'Lens culinaris',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Mild lentil. Peppery, protein-rich, 2-3 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Mild'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'chickpea-peppery',
    name: 'Chickpea - Peppery',
    scientificName: 'Cicer arietinum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Peppery chickpea. Nutty, substantial, hummus sprouts.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Peppery'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'broccoli-sprout-nutty',
    name: 'Broccoli sprout - Nutty',
    scientificName: 'Brassica oleracea var. italica',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Nutty broccoli sprout. High sulforaphane, cancer-fighting compound.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Nutty'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'radish-sprout-crunchy',
    name: 'Radish sprout - Crunchy',
    scientificName: 'Raphanus sativus',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Crunchy radish sprout. Spicy kick, colorful, 3-4 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Crunchy'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'clover-sprout-tender',
    name: 'Clover sprout - Tender',
    scientificName: 'Trifolium pratense',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Tender clover sprout. Mild, sweet, similar to alfalfa.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Tender'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'fenugreek-crisp',
    name: 'Fenugreek - Crisp',
    scientificName: 'Trigonella foenum-graecum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Crisp fenugreek. Bitter, aromatic, curry spice flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Crisp'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'alfalfa-juicy',
    name: 'Alfalfa - Juicy',
    scientificName: 'Medicago sativa',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Juicy alfalfa. Mild, nutty, classic sandwich sprout.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Juicy'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'mung-bean-succulent',
    name: 'Mung bean - Succulent',
    scientificName: 'Vigna radiata',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 4,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Succulent mung bean. Crunchy, mild, Asian cuisine staple.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Succulent'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'lentil-green',
    name: 'Lentil - Green',
    scientificName: 'Lens culinaris',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Green lentil. Peppery, protein-rich, 2-3 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Green'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'chickpea-red',
    name: 'Chickpea - Red',
    scientificName: 'Cicer arietinum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Red chickpea. Nutty, substantial, hummus sprouts.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Red'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'broccoli-sprout-purple',
    name: 'Broccoli sprout - Purple',
    scientificName: 'Brassica oleracea var. italica',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Purple broccoli sprout. High sulforaphane, cancer-fighting compound.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Purple'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'radish-sprout-yellow',
    name: 'Radish sprout - Yellow',
    scientificName: 'Raphanus sativus',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Yellow radish sprout. Spicy kick, colorful, 3-4 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Yellow'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'clover-sprout-golden',
    name: 'Clover sprout - Golden',
    scientificName: 'Trifolium pratense',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Golden clover sprout. Mild, sweet, similar to alfalfa.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Golden'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'fenugreek-dark',
    name: 'Fenugreek - Dark',
    scientificName: 'Trigonella foenum-graecum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Dark fenugreek. Bitter, aromatic, curry spice flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Dark'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'alfalfa-light',
    name: 'Alfalfa - Light',
    scientificName: 'Medicago sativa',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Light alfalfa. Mild, nutty, classic sandwich sprout.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Light'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'mung-bean-pale',
    name: 'Mung bean - Pale',
    scientificName: 'Vigna radiata',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 4,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Pale mung bean. Crunchy, mild, Asian cuisine staple.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Pale'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'lentil-deep',
    name: 'Lentil - Deep',
    scientificName: 'Lens culinaris',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Deep lentil. Peppery, protein-rich, 2-3 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Deep'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'chickpea-bright',
    name: 'Chickpea - Bright',
    scientificName: 'Cicer arietinum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bright chickpea. Nutty, substantial, hummus sprouts.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Bright'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'broccoli-sprout-smooth',
    name: 'Broccoli sprout - Smooth',
    scientificName: 'Brassica oleracea var. italica',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Smooth broccoli sprout. High sulforaphane, cancer-fighting compound.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Smooth'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'radish-sprout-curly',
    name: 'Radish sprout - Curly',
    scientificName: 'Raphanus sativus',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Curly radish sprout. Spicy kick, colorful, 3-4 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Curly'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'clover-sprout-frilly',
    name: 'Clover sprout - Frilly',
    scientificName: 'Trifolium pratense',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Frilly clover sprout. Mild, sweet, similar to alfalfa.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Frilly'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'fenugreek-feathery',
    name: 'Fenugreek - Feathery',
    scientificName: 'Trigonella foenum-graecum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Feathery fenugreek. Bitter, aromatic, curry spice flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Feathery'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'alfalfa-lacy',
    name: 'Alfalfa - Lacy',
    scientificName: 'Medicago sativa',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Lacy alfalfa. Mild, nutty, classic sandwich sprout.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Lacy'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'mung-bean-round',
    name: 'Mung bean - Round',
    scientificName: 'Vigna radiata',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 4,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Round mung bean. Crunchy, mild, Asian cuisine staple.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Round'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'lentil-oval',
    name: 'Lentil - Oval',
    scientificName: 'Lens culinaris',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Oval lentil. Peppery, protein-rich, 2-3 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Oval'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'chickpea-long',
    name: 'Chickpea - Long',
    scientificName: 'Cicer arietinum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Long chickpea. Nutty, substantial, hummus sprouts.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Long'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'broccoli-sprout-short',
    name: 'Broccoli sprout - Short',
    scientificName: 'Brassica oleracea var. italica',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Short broccoli sprout. High sulforaphane, cancer-fighting compound.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Short'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'radish-sprout-elongated',
    name: 'Radish sprout - Elongated',
    scientificName: 'Raphanus sativus',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Elongated radish sprout. Spicy kick, colorful, 3-4 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Elongated'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'clover-sprout-single',
    name: 'Clover sprout - Single',
    scientificName: 'Trifolium pratense',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Single clover sprout. Mild, sweet, similar to alfalfa.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Single'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'fenugreek-double',
    name: 'Fenugreek - Double',
    scientificName: 'Trigonella foenum-graecum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Double fenugreek. Bitter, aromatic, curry spice flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Double'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'alfalfa-triple',
    name: 'Alfalfa - Triple',
    scientificName: 'Medicago sativa',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Triple alfalfa. Mild, nutty, classic sandwich sprout.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Triple'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'mung-bean-multi',
    name: 'Mung bean - Multi',
    scientificName: 'Vigna radiata',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 4,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Multi mung bean. Crunchy, mild, Asian cuisine staple.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Multi'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'lentil-cluster',
    name: 'Lentil - Cluster',
    scientificName: 'Lens culinaris',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Cluster lentil. Peppery, protein-rich, 2-3 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Cluster'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'chickpea-solo',
    name: 'Chickpea - Solo',
    scientificName: 'Cicer arietinum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Solo chickpea. Nutty, substantial, hummus sprouts.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Solo'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'broccoli-sprout-individual',
    name: 'Broccoli sprout - Individual',
    scientificName: 'Brassica oleracea var. italica',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Individual broccoli sprout. High sulforaphane, cancer-fighting compound.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Individual'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'radish-sprout-bunch',
    name: 'Radish sprout - Bunch',
    scientificName: 'Raphanus sativus',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bunch radish sprout. Spicy kick, colorful, 3-4 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Bunch'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'clover-sprout-bundle',
    name: 'Clover sprout - Bundle',
    scientificName: 'Trifolium pratense',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bundle clover sprout. Mild, sweet, similar to alfalfa.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Bundle'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'fenugreek-bouquet',
    name: 'Fenugreek - Bouquet',
    scientificName: 'Trigonella foenum-graecum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bouquet fenugreek. Bitter, aromatic, curry spice flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Bouquet'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'alfalfa-standard-2',
    name: 'Alfalfa - Standard 2',
    scientificName: 'Medicago sativa',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Standard 2 alfalfa. Mild, nutty, classic sandwich sprout.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Standard 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'mung-bean-organic-2',
    name: 'Mung bean - Organic 2',
    scientificName: 'Vigna radiata',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 4,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Organic 2 mung bean. Crunchy, mild, Asian cuisine staple.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Organic 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'lentil-non-gmo-2',
    name: 'Lentil - Non-GMO 2',
    scientificName: 'Lens culinaris',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Non-GMO 2 lentil. Peppery, protein-rich, 2-3 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Non-GMO 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'chickpea-heirloom-2',
    name: 'Chickpea - Heirloom 2',
    scientificName: 'Cicer arietinum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Heirloom 2 chickpea. Nutty, substantial, hummus sprouts.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Heirloom 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'broccoli-sprout-hybrid-2',
    name: 'Broccoli sprout - Hybrid 2',
    scientificName: 'Brassica oleracea var. italica',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Hybrid 2 broccoli sprout. High sulforaphane, cancer-fighting compound.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Hybrid 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'radish-sprout-green-2',
    name: 'Radish sprout - Green 2',
    scientificName: 'Raphanus sativus',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Green 2 radish sprout. Spicy kick, colorful, 3-4 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Green 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'clover-sprout-golden-2',
    name: 'Clover sprout - Golden 2',
    scientificName: 'Trifolium pratense',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Golden 2 clover sprout. Mild, sweet, similar to alfalfa.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Golden 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'fenugreek-yellow-2',
    name: 'Fenugreek - Yellow 2',
    scientificName: 'Trigonella foenum-graecum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Yellow 2 fenugreek. Bitter, aromatic, curry spice flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Yellow 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'alfalfa-brown-2',
    name: 'Alfalfa - Brown 2',
    scientificName: 'Medicago sativa',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Brown 2 alfalfa. Mild, nutty, classic sandwich sprout.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Brown 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'mung-bean-black-2',
    name: 'Mung bean - Black 2',
    scientificName: 'Vigna radiata',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 4,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Black 2 mung bean. Crunchy, mild, Asian cuisine staple.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Black 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'lentil-french-2',
    name: 'Lentil - French 2',
    scientificName: 'Lens culinaris',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'French 2 lentil. Peppery, protein-rich, 2-3 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['French 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'chickpea-spanish-2',
    name: 'Chickpea - Spanish 2',
    scientificName: 'Cicer arietinum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Spanish 2 chickpea. Nutty, substantial, hummus sprouts.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Spanish 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'broccoli-sprout-italian-2',
    name: 'Broccoli sprout - Italian 2',
    scientificName: 'Brassica oleracea var. italica',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Italian 2 broccoli sprout. High sulforaphane, cancer-fighting compound.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Italian 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'radish-sprout-greek-2',
    name: 'Radish sprout - Greek 2',
    scientificName: 'Raphanus sativus',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Greek 2 radish sprout. Spicy kick, colorful, 3-4 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Greek 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'clover-sprout-turkish-2',
    name: 'Clover sprout - Turkish 2',
    scientificName: 'Trifolium pratense',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Turkish 2 clover sprout. Mild, sweet, similar to alfalfa.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Turkish 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'fenugreek-indian-2',
    name: 'Fenugreek - Indian 2',
    scientificName: 'Trigonella foenum-graecum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Indian 2 fenugreek. Bitter, aromatic, curry spice flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Indian 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'alfalfa-chinese-2',
    name: 'Alfalfa - Chinese 2',
    scientificName: 'Medicago sativa',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Chinese 2 alfalfa. Mild, nutty, classic sandwich sprout.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Chinese 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'mung-bean-japanese-2',
    name: 'Mung bean - Japanese 2',
    scientificName: 'Vigna radiata',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 4,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Japanese 2 mung bean. Crunchy, mild, Asian cuisine staple.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Japanese 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'lentil-korean-2',
    name: 'Lentil - Korean 2',
    scientificName: 'Lens culinaris',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Korean 2 lentil. Peppery, protein-rich, 2-3 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Korean 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'chickpea-thai-2',
    name: 'Chickpea - Thai 2',
    scientificName: 'Cicer arietinum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Thai 2 chickpea. Nutty, substantial, hummus sprouts.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Thai 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'broccoli-sprout-dwarf-2',
    name: 'Broccoli sprout - Dwarf 2',
    scientificName: 'Brassica oleracea var. italica',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Dwarf 2 broccoli sprout. High sulforaphane, cancer-fighting compound.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Dwarf 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'radish-sprout-giant-2',
    name: 'Radish sprout - Giant 2',
    scientificName: 'Raphanus sativus',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Giant 2 radish sprout. Spicy kick, colorful, 3-4 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Giant 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'clover-sprout-baby-2',
    name: 'Clover sprout - Baby 2',
    scientificName: 'Trifolium pratense',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Baby 2 clover sprout. Mild, sweet, similar to alfalfa.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Baby 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'fenugreek-micro-2',
    name: 'Fenugreek - Micro 2',
    scientificName: 'Trigonella foenum-graecum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Micro 2 fenugreek. Bitter, aromatic, curry spice flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Micro 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'alfalfa-mini-2',
    name: 'Alfalfa - Mini 2',
    scientificName: 'Medicago sativa',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Mini 2 alfalfa. Mild, nutty, classic sandwich sprout.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Mini 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'mung-bean-quick-2',
    name: 'Mung bean - Quick 2',
    scientificName: 'Vigna radiata',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 4,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Quick 2 mung bean. Crunchy, mild, Asian cuisine staple.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Quick 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'lentil-fast-2',
    name: 'Lentil - Fast 2',
    scientificName: 'Lens culinaris',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Fast 2 lentil. Peppery, protein-rich, 2-3 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Fast 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'chickpea-speedy-2',
    name: 'Chickpea - Speedy 2',
    scientificName: 'Cicer arietinum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Speedy 2 chickpea. Nutty, substantial, hummus sprouts.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Speedy 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'broccoli-sprout-rapid-2',
    name: 'Broccoli sprout - Rapid 2',
    scientificName: 'Brassica oleracea var. italica',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Rapid 2 broccoli sprout. High sulforaphane, cancer-fighting compound.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Rapid 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'radish-sprout-swift-2',
    name: 'Radish sprout - Swift 2',
    scientificName: 'Raphanus sativus',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Swift 2 radish sprout. Spicy kick, colorful, 3-4 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Swift 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'clover-sprout-sweet-2',
    name: 'Clover sprout - Sweet 2',
    scientificName: 'Trifolium pratense',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Sweet 2 clover sprout. Mild, sweet, similar to alfalfa.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Sweet 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'fenugreek-spicy-2',
    name: 'Fenugreek - Spicy 2',
    scientificName: 'Trigonella foenum-graecum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Spicy 2 fenugreek. Bitter, aromatic, curry spice flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Spicy 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'alfalfa-mild-2',
    name: 'Alfalfa - Mild 2',
    scientificName: 'Medicago sativa',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Mild 2 alfalfa. Mild, nutty, classic sandwich sprout.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Mild 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'mung-bean-bitter-2',
    name: 'Mung bean - Bitter 2',
    scientificName: 'Vigna radiata',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 4,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bitter 2 mung bean. Crunchy, mild, Asian cuisine staple.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Bitter 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'lentil-nutty-2',
    name: 'Lentil - Nutty 2',
    scientificName: 'Lens culinaris',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Nutty 2 lentil. Peppery, protein-rich, 2-3 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Nutty 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'chickpea-crunchy-2',
    name: 'Chickpea - Crunchy 2',
    scientificName: 'Cicer arietinum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Crunchy 2 chickpea. Nutty, substantial, hummus sprouts.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Crunchy 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'broccoli-sprout-tender-2',
    name: 'Broccoli sprout - Tender 2',
    scientificName: 'Brassica oleracea var. italica',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Tender 2 broccoli sprout. High sulforaphane, cancer-fighting compound.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Tender 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'radish-sprout-crisp-2',
    name: 'Radish sprout - Crisp 2',
    scientificName: 'Raphanus sativus',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Crisp 2 radish sprout. Spicy kick, colorful, 3-4 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Crisp 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'clover-sprout-soft-2',
    name: 'Clover sprout - Soft 2',
    scientificName: 'Trifolium pratense',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Soft 2 clover sprout. Mild, sweet, similar to alfalfa.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Soft 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'fenugreek-firm-2',
    name: 'Fenugreek - Firm 2',
    scientificName: 'Trigonella foenum-graecum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Firm 2 fenugreek. Bitter, aromatic, curry spice flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Firm 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'alfalfa-green-2',
    name: 'Alfalfa - Green 2',
    scientificName: 'Medicago sativa',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Green 2 alfalfa. Mild, nutty, classic sandwich sprout.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Green 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'mung-bean-red-2',
    name: 'Mung bean - Red 2',
    scientificName: 'Vigna radiata',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 4,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Red 2 mung bean. Crunchy, mild, Asian cuisine staple.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Red 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'lentil-purple-2',
    name: 'Lentil - Purple 2',
    scientificName: 'Lens culinaris',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Purple 2 lentil. Peppery, protein-rich, 2-3 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Purple 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'chickpea-yellow-2',
    name: 'Chickpea - Yellow 2',
    scientificName: 'Cicer arietinum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Yellow 2 chickpea. Nutty, substantial, hummus sprouts.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Yellow 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'broccoli-sprout-golden-2',
    name: 'Broccoli sprout - Golden 2',
    scientificName: 'Brassica oleracea var. italica',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Golden 2 broccoli sprout. High sulforaphane, cancer-fighting compound.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Golden 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'radish-sprout-dark-2',
    name: 'Radish sprout - Dark 2',
    scientificName: 'Raphanus sativus',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Dark 2 radish sprout. Spicy kick, colorful, 3-4 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Dark 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'clover-sprout-light-2',
    name: 'Clover sprout - Light 2',
    scientificName: 'Trifolium pratense',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Light 2 clover sprout. Mild, sweet, similar to alfalfa.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Light 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'fenugreek-pale-2',
    name: 'Fenugreek - Pale 2',
    scientificName: 'Trigonella foenum-graecum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Pale 2 fenugreek. Bitter, aromatic, curry spice flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Pale 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'alfalfa-deep-2',
    name: 'Alfalfa - Deep 2',
    scientificName: 'Medicago sativa',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Deep 2 alfalfa. Mild, nutty, classic sandwich sprout.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Deep 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'mung-bean-bright-2',
    name: 'Mung bean - Bright 2',
    scientificName: 'Vigna radiata',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 4,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bright 2 mung bean. Crunchy, mild, Asian cuisine staple.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Bright 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'lentil-round-2',
    name: 'Lentil - Round 2',
    scientificName: 'Lens culinaris',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Round 2 lentil. Peppery, protein-rich, 2-3 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Round 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'chickpea-oval-2',
    name: 'Chickpea - Oval 2',
    scientificName: 'Cicer arietinum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Oval 2 chickpea. Nutty, substantial, hummus sprouts.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Oval 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'broccoli-sprout-long-2',
    name: 'Broccoli sprout - Long 2',
    scientificName: 'Brassica oleracea var. italica',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Long 2 broccoli sprout. High sulforaphane, cancer-fighting compound.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Long 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'radish-sprout-short-2',
    name: 'Radish sprout - Short 2',
    scientificName: 'Raphanus sativus',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Short 2 radish sprout. Spicy kick, colorful, 3-4 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Short 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'clover-sprout-elongated-2',
    name: 'Clover sprout - Elongated 2',
    scientificName: 'Trifolium pratense',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Elongated 2 clover sprout. Mild, sweet, similar to alfalfa.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Elongated 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'fenugreek-single-2',
    name: 'Fenugreek - Single 2',
    scientificName: 'Trigonella foenum-graecum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Single 2 fenugreek. Bitter, aromatic, curry spice flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Single 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'alfalfa-double-2',
    name: 'Alfalfa - Double 2',
    scientificName: 'Medicago sativa',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Double 2 alfalfa. Mild, nutty, classic sandwich sprout.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Double 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'mung-bean-triple-2',
    name: 'Mung bean - Triple 2',
    scientificName: 'Vigna radiata',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 4,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Triple 2 mung bean. Crunchy, mild, Asian cuisine staple.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Triple 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'lentil-multi-2',
    name: 'Lentil - Multi 2',
    scientificName: 'Lens culinaris',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Multi 2 lentil. Peppery, protein-rich, 2-3 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Multi 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'chickpea-cluster-2',
    name: 'Chickpea - Cluster 2',
    scientificName: 'Cicer arietinum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Cluster 2 chickpea. Nutty, substantial, hummus sprouts.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Cluster 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'broccoli-sprout-solo-2',
    name: 'Broccoli sprout - Solo 2',
    scientificName: 'Brassica oleracea var. italica',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Solo 2 broccoli sprout. High sulforaphane, cancer-fighting compound.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Solo 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'radish-sprout-individual-2',
    name: 'Radish sprout - Individual 2',
    scientificName: 'Raphanus sativus',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Individual 2 radish sprout. Spicy kick, colorful, 3-4 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Individual 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'clover-sprout-bunch-2',
    name: 'Clover sprout - Bunch 2',
    scientificName: 'Trifolium pratense',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bunch 2 clover sprout. Mild, sweet, similar to alfalfa.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Bunch 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'fenugreek-bundle-2',
    name: 'Fenugreek - Bundle 2',
    scientificName: 'Trigonella foenum-graecum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bundle 2 fenugreek. Bitter, aromatic, curry spice flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Bundle 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'alfalfa-bouquet-2',
    name: 'Alfalfa - Bouquet 2',
    scientificName: 'Medicago sativa',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bouquet 2 alfalfa. Mild, nutty, classic sandwich sprout.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Bouquet 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'mung-bean-sprouting-2',
    name: 'Mung bean - Sprouting 2',
    scientificName: 'Vigna radiata',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 4,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Sprouting 2 mung bean. Crunchy, mild, Asian cuisine staple.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Sprouting 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'lentil-microgreen-2',
    name: 'Lentil - Microgreen 2',
    scientificName: 'Lens culinaris',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Microgreen 2 lentil. Peppery, protein-rich, 2-3 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Microgreen 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'chickpea-shoot-2',
    name: 'Chickpea - Shoot 2',
    scientificName: 'Cicer arietinum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Shoot 2 chickpea. Nutty, substantial, hummus sprouts.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Shoot 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'broccoli-sprout-baby-2',
    name: 'Broccoli sprout - Baby 2',
    scientificName: 'Brassica oleracea var. italica',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Baby 2 broccoli sprout. High sulforaphane, cancer-fighting compound.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Baby 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'radish-sprout-tender-2',
    name: 'Radish sprout - Tender 2',
    scientificName: 'Raphanus sativus',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Tender 2 radish sprout. Spicy kick, colorful, 3-4 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Tender 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'clover-sprout-organic-2',
    name: 'Clover sprout - Organic 2',
    scientificName: 'Trifolium pratense',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Organic 2 clover sprout. Mild, sweet, similar to alfalfa.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Organic 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'fenugreek-non-gmo-2',
    name: 'Fenugreek - Non-GMO 2',
    scientificName: 'Trigonella foenum-graecum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Non-GMO 2 fenugreek. Bitter, aromatic, curry spice flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Non-GMO 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'alfalfa-heirloom-2',
    name: 'Alfalfa - Heirloom 2',
    scientificName: 'Medicago sativa',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Heirloom 2 alfalfa. Mild, nutty, classic sandwich sprout.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Heirloom 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'mung-bean-hybrid-2',
    name: 'Mung bean - Hybrid 2',
    scientificName: 'Vigna radiata',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 4,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Hybrid 2 mung bean. Crunchy, mild, Asian cuisine staple.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Hybrid 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'lentil-open-pollinated-2',
    name: 'Lentil - Open Pollinated 2',
    scientificName: 'Lens culinaris',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Open Pollinated 2 lentil. Peppery, protein-rich, 2-3 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Open Pollinated 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'chickpea-dwarf-2',
    name: 'Chickpea - Dwarf 2',
    scientificName: 'Cicer arietinum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Dwarf 2 chickpea. Nutty, substantial, hummus sprouts.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Dwarf 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'broccoli-sprout-giant-2',
    name: 'Broccoli sprout - Giant 2',
    scientificName: 'Brassica oleracea var. italica',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Giant 2 broccoli sprout. High sulforaphane, cancer-fighting compound.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Giant 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'radish-sprout-baby-2',
    name: 'Radish sprout - Baby 2',
    scientificName: 'Raphanus sativus',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Baby 2 radish sprout. Spicy kick, colorful, 3-4 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Baby 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'clover-sprout-micro-2',
    name: 'Clover sprout - Micro 2',
    scientificName: 'Trifolium pratense',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Micro 2 clover sprout. Mild, sweet, similar to alfalfa.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Micro 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'fenugreek-mini-2',
    name: 'Fenugreek - Mini 2',
    scientificName: 'Trigonella foenum-graecum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Mini 2 fenugreek. Bitter, aromatic, curry spice flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Mini 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'alfalfa-sweet-2',
    name: 'Alfalfa - Sweet 2',
    scientificName: 'Medicago sativa',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Sweet 2 alfalfa. Mild, nutty, classic sandwich sprout.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Sweet 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'mung-bean-spicy-2',
    name: 'Mung bean - Spicy 2',
    scientificName: 'Vigna radiata',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 4,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Spicy 2 mung bean. Crunchy, mild, Asian cuisine staple.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Spicy 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'lentil-mild-2',
    name: 'Lentil - Mild 2',
    scientificName: 'Lens culinaris',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Mild 2 lentil. Peppery, protein-rich, 2-3 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Mild 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'chickpea-peppery-2',
    name: 'Chickpea - Peppery 2',
    scientificName: 'Cicer arietinum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Peppery 2 chickpea. Nutty, substantial, hummus sprouts.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Peppery 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'broccoli-sprout-nutty-2',
    name: 'Broccoli sprout - Nutty 2',
    scientificName: 'Brassica oleracea var. italica',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Nutty 2 broccoli sprout. High sulforaphane, cancer-fighting compound.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Nutty 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'radish-sprout-crunchy-2',
    name: 'Radish sprout - Crunchy 2',
    scientificName: 'Raphanus sativus',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Crunchy 2 radish sprout. Spicy kick, colorful, 3-4 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Crunchy 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'clover-sprout-tender-2',
    name: 'Clover sprout - Tender 2',
    scientificName: 'Trifolium pratense',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Tender 2 clover sprout. Mild, sweet, similar to alfalfa.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Tender 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'fenugreek-crisp-2',
    name: 'Fenugreek - Crisp 2',
    scientificName: 'Trigonella foenum-graecum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Crisp 2 fenugreek. Bitter, aromatic, curry spice flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Crisp 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'alfalfa-juicy-2',
    name: 'Alfalfa - Juicy 2',
    scientificName: 'Medicago sativa',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Juicy 2 alfalfa. Mild, nutty, classic sandwich sprout.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Juicy 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'mung-bean-succulent-2',
    name: 'Mung bean - Succulent 2',
    scientificName: 'Vigna radiata',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 4,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Succulent 2 mung bean. Crunchy, mild, Asian cuisine staple.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Succulent 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'lentil-green-2',
    name: 'Lentil - Green 2',
    scientificName: 'Lens culinaris',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Green 2 lentil. Peppery, protein-rich, 2-3 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Green 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'chickpea-red-2',
    name: 'Chickpea - Red 2',
    scientificName: 'Cicer arietinum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Red 2 chickpea. Nutty, substantial, hummus sprouts.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Red 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'broccoli-sprout-purple-2',
    name: 'Broccoli sprout - Purple 2',
    scientificName: 'Brassica oleracea var. italica',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Purple 2 broccoli sprout. High sulforaphane, cancer-fighting compound.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Purple 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'radish-sprout-yellow-2',
    name: 'Radish sprout - Yellow 2',
    scientificName: 'Raphanus sativus',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Yellow 2 radish sprout. Spicy kick, colorful, 3-4 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Yellow 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'clover-sprout-golden-2',
    name: 'Clover sprout - Golden 2',
    scientificName: 'Trifolium pratense',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Golden 2 clover sprout. Mild, sweet, similar to alfalfa.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Golden 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'fenugreek-dark-2',
    name: 'Fenugreek - Dark 2',
    scientificName: 'Trigonella foenum-graecum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Dark 2 fenugreek. Bitter, aromatic, curry spice flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Dark 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'alfalfa-light-2',
    name: 'Alfalfa - Light 2',
    scientificName: 'Medicago sativa',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Light 2 alfalfa. Mild, nutty, classic sandwich sprout.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Light 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'mung-bean-pale-2',
    name: 'Mung bean - Pale 2',
    scientificName: 'Vigna radiata',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 4,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Pale 2 mung bean. Crunchy, mild, Asian cuisine staple.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Pale 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'lentil-deep-2',
    name: 'Lentil - Deep 2',
    scientificName: 'Lens culinaris',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Deep 2 lentil. Peppery, protein-rich, 2-3 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Deep 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'chickpea-bright-2',
    name: 'Chickpea - Bright 2',
    scientificName: 'Cicer arietinum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bright 2 chickpea. Nutty, substantial, hummus sprouts.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Bright 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'broccoli-sprout-smooth-2',
    name: 'Broccoli sprout - Smooth 2',
    scientificName: 'Brassica oleracea var. italica',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Smooth 2 broccoli sprout. High sulforaphane, cancer-fighting compound.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Smooth 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'radish-sprout-curly-2',
    name: 'Radish sprout - Curly 2',
    scientificName: 'Raphanus sativus',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Curly 2 radish sprout. Spicy kick, colorful, 3-4 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Curly 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'clover-sprout-frilly-2',
    name: 'Clover sprout - Frilly 2',
    scientificName: 'Trifolium pratense',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Frilly 2 clover sprout. Mild, sweet, similar to alfalfa.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Frilly 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'fenugreek-feathery-2',
    name: 'Fenugreek - Feathery 2',
    scientificName: 'Trigonella foenum-graecum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Feathery 2 fenugreek. Bitter, aromatic, curry spice flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Feathery 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'alfalfa-lacy-2',
    name: 'Alfalfa - Lacy 2',
    scientificName: 'Medicago sativa',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Lacy 2 alfalfa. Mild, nutty, classic sandwich sprout.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Lacy 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'mung-bean-round-2',
    name: 'Mung bean - Round 2',
    scientificName: 'Vigna radiata',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 4,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Round 2 mung bean. Crunchy, mild, Asian cuisine staple.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Round 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'lentil-oval-2',
    name: 'Lentil - Oval 2',
    scientificName: 'Lens culinaris',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Oval 2 lentil. Peppery, protein-rich, 2-3 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Oval 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'chickpea-long-2',
    name: 'Chickpea - Long 2',
    scientificName: 'Cicer arietinum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Long 2 chickpea. Nutty, substantial, hummus sprouts.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Long 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'broccoli-sprout-short-2',
    name: 'Broccoli sprout - Short 2',
    scientificName: 'Brassica oleracea var. italica',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Short 2 broccoli sprout. High sulforaphane, cancer-fighting compound.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Short 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'radish-sprout-elongated-2',
    name: 'Radish sprout - Elongated 2',
    scientificName: 'Raphanus sativus',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Elongated 2 radish sprout. Spicy kick, colorful, 3-4 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Elongated 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'clover-sprout-single-2',
    name: 'Clover sprout - Single 2',
    scientificName: 'Trifolium pratense',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Single 2 clover sprout. Mild, sweet, similar to alfalfa.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Single 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'fenugreek-double-2',
    name: 'Fenugreek - Double 2',
    scientificName: 'Trigonella foenum-graecum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Double 2 fenugreek. Bitter, aromatic, curry spice flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Double 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'alfalfa-triple-2',
    name: 'Alfalfa - Triple 2',
    scientificName: 'Medicago sativa',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Triple 2 alfalfa. Mild, nutty, classic sandwich sprout.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Triple 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'mung-bean-multi-2',
    name: 'Mung bean - Multi 2',
    scientificName: 'Vigna radiata',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 4,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Multi 2 mung bean. Crunchy, mild, Asian cuisine staple.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Multi 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'lentil-cluster-2',
    name: 'Lentil - Cluster 2',
    scientificName: 'Lens culinaris',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Cluster 2 lentil. Peppery, protein-rich, 2-3 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Cluster 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'chickpea-solo-2',
    name: 'Chickpea - Solo 2',
    scientificName: 'Cicer arietinum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Solo 2 chickpea. Nutty, substantial, hummus sprouts.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Solo 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'broccoli-sprout-individual-2',
    name: 'Broccoli sprout - Individual 2',
    scientificName: 'Brassica oleracea var. italica',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Individual 2 broccoli sprout. High sulforaphane, cancer-fighting compound.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Individual 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'radish-sprout-bunch-2',
    name: 'Radish sprout - Bunch 2',
    scientificName: 'Raphanus sativus',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bunch 2 radish sprout. Spicy kick, colorful, 3-4 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Bunch 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'clover-sprout-bundle-2',
    name: 'Clover sprout - Bundle 2',
    scientificName: 'Trifolium pratense',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bundle 2 clover sprout. Mild, sweet, similar to alfalfa.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Bundle 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'fenugreek-bouquet-2',
    name: 'Fenugreek - Bouquet 2',
    scientificName: 'Trigonella foenum-graecum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bouquet 2 fenugreek. Bitter, aromatic, curry spice flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Bouquet 2'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'alfalfa-standard-3',
    name: 'Alfalfa - Standard 3',
    scientificName: 'Medicago sativa',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Standard 3 alfalfa. Mild, nutty, classic sandwich sprout.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Standard 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'mung-bean-organic-3',
    name: 'Mung bean - Organic 3',
    scientificName: 'Vigna radiata',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 4,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Organic 3 mung bean. Crunchy, mild, Asian cuisine staple.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Organic 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'lentil-non-gmo-3',
    name: 'Lentil - Non-GMO 3',
    scientificName: 'Lens culinaris',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Non-GMO 3 lentil. Peppery, protein-rich, 2-3 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Non-GMO 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'chickpea-heirloom-3',
    name: 'Chickpea - Heirloom 3',
    scientificName: 'Cicer arietinum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Heirloom 3 chickpea. Nutty, substantial, hummus sprouts.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Heirloom 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'broccoli-sprout-hybrid-3',
    name: 'Broccoli sprout - Hybrid 3',
    scientificName: 'Brassica oleracea var. italica',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Hybrid 3 broccoli sprout. High sulforaphane, cancer-fighting compound.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Hybrid 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'radish-sprout-green-3',
    name: 'Radish sprout - Green 3',
    scientificName: 'Raphanus sativus',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Green 3 radish sprout. Spicy kick, colorful, 3-4 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Green 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'clover-sprout-golden-3',
    name: 'Clover sprout - Golden 3',
    scientificName: 'Trifolium pratense',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Golden 3 clover sprout. Mild, sweet, similar to alfalfa.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Golden 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'fenugreek-yellow-3',
    name: 'Fenugreek - Yellow 3',
    scientificName: 'Trigonella foenum-graecum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Yellow 3 fenugreek. Bitter, aromatic, curry spice flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Yellow 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'alfalfa-brown-3',
    name: 'Alfalfa - Brown 3',
    scientificName: 'Medicago sativa',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Brown 3 alfalfa. Mild, nutty, classic sandwich sprout.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Brown 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'mung-bean-black-3',
    name: 'Mung bean - Black 3',
    scientificName: 'Vigna radiata',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 4,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Black 3 mung bean. Crunchy, mild, Asian cuisine staple.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Black 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'lentil-french-3',
    name: 'Lentil - French 3',
    scientificName: 'Lens culinaris',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'French 3 lentil. Peppery, protein-rich, 2-3 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['French 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'chickpea-spanish-3',
    name: 'Chickpea - Spanish 3',
    scientificName: 'Cicer arietinum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Spanish 3 chickpea. Nutty, substantial, hummus sprouts.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Spanish 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'broccoli-sprout-italian-3',
    name: 'Broccoli sprout - Italian 3',
    scientificName: 'Brassica oleracea var. italica',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Italian 3 broccoli sprout. High sulforaphane, cancer-fighting compound.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Italian 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'radish-sprout-greek-3',
    name: 'Radish sprout - Greek 3',
    scientificName: 'Raphanus sativus',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Greek 3 radish sprout. Spicy kick, colorful, 3-4 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Greek 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'clover-sprout-turkish-3',
    name: 'Clover sprout - Turkish 3',
    scientificName: 'Trifolium pratense',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Turkish 3 clover sprout. Mild, sweet, similar to alfalfa.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Turkish 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'fenugreek-indian-3',
    name: 'Fenugreek - Indian 3',
    scientificName: 'Trigonella foenum-graecum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Indian 3 fenugreek. Bitter, aromatic, curry spice flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Indian 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'alfalfa-chinese-3',
    name: 'Alfalfa - Chinese 3',
    scientificName: 'Medicago sativa',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Chinese 3 alfalfa. Mild, nutty, classic sandwich sprout.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Chinese 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'mung-bean-japanese-3',
    name: 'Mung bean - Japanese 3',
    scientificName: 'Vigna radiata',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 4,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Japanese 3 mung bean. Crunchy, mild, Asian cuisine staple.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Japanese 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'lentil-korean-3',
    name: 'Lentil - Korean 3',
    scientificName: 'Lens culinaris',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Korean 3 lentil. Peppery, protein-rich, 2-3 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Korean 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'chickpea-thai-3',
    name: 'Chickpea - Thai 3',
    scientificName: 'Cicer arietinum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Thai 3 chickpea. Nutty, substantial, hummus sprouts.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Thai 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'broccoli-sprout-dwarf-3',
    name: 'Broccoli sprout - Dwarf 3',
    scientificName: 'Brassica oleracea var. italica',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Dwarf 3 broccoli sprout. High sulforaphane, cancer-fighting compound.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Dwarf 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'radish-sprout-giant-3',
    name: 'Radish sprout - Giant 3',
    scientificName: 'Raphanus sativus',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Giant 3 radish sprout. Spicy kick, colorful, 3-4 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Giant 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'clover-sprout-baby-3',
    name: 'Clover sprout - Baby 3',
    scientificName: 'Trifolium pratense',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Baby 3 clover sprout. Mild, sweet, similar to alfalfa.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Baby 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'fenugreek-micro-3',
    name: 'Fenugreek - Micro 3',
    scientificName: 'Trigonella foenum-graecum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Micro 3 fenugreek. Bitter, aromatic, curry spice flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Micro 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'alfalfa-mini-3',
    name: 'Alfalfa - Mini 3',
    scientificName: 'Medicago sativa',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Mini 3 alfalfa. Mild, nutty, classic sandwich sprout.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Mini 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'mung-bean-quick-3',
    name: 'Mung bean - Quick 3',
    scientificName: 'Vigna radiata',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 4,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Quick 3 mung bean. Crunchy, mild, Asian cuisine staple.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Quick 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'lentil-fast-3',
    name: 'Lentil - Fast 3',
    scientificName: 'Lens culinaris',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Fast 3 lentil. Peppery, protein-rich, 2-3 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Fast 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'chickpea-speedy-3',
    name: 'Chickpea - Speedy 3',
    scientificName: 'Cicer arietinum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Speedy 3 chickpea. Nutty, substantial, hummus sprouts.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Speedy 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'broccoli-sprout-rapid-3',
    name: 'Broccoli sprout - Rapid 3',
    scientificName: 'Brassica oleracea var. italica',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Rapid 3 broccoli sprout. High sulforaphane, cancer-fighting compound.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Rapid 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'radish-sprout-swift-3',
    name: 'Radish sprout - Swift 3',
    scientificName: 'Raphanus sativus',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Swift 3 radish sprout. Spicy kick, colorful, 3-4 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Swift 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'clover-sprout-sweet-3',
    name: 'Clover sprout - Sweet 3',
    scientificName: 'Trifolium pratense',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Sweet 3 clover sprout. Mild, sweet, similar to alfalfa.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Sweet 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'fenugreek-spicy-3',
    name: 'Fenugreek - Spicy 3',
    scientificName: 'Trigonella foenum-graecum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Spicy 3 fenugreek. Bitter, aromatic, curry spice flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Spicy 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'alfalfa-mild-3',
    name: 'Alfalfa - Mild 3',
    scientificName: 'Medicago sativa',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Mild 3 alfalfa. Mild, nutty, classic sandwich sprout.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Mild 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'mung-bean-bitter-3',
    name: 'Mung bean - Bitter 3',
    scientificName: 'Vigna radiata',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 4,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bitter 3 mung bean. Crunchy, mild, Asian cuisine staple.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Bitter 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'lentil-nutty-3',
    name: 'Lentil - Nutty 3',
    scientificName: 'Lens culinaris',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Nutty 3 lentil. Peppery, protein-rich, 2-3 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Nutty 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'chickpea-crunchy-3',
    name: 'Chickpea - Crunchy 3',
    scientificName: 'Cicer arietinum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Crunchy 3 chickpea. Nutty, substantial, hummus sprouts.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Crunchy 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'broccoli-sprout-tender-3',
    name: 'Broccoli sprout - Tender 3',
    scientificName: 'Brassica oleracea var. italica',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Tender 3 broccoli sprout. High sulforaphane, cancer-fighting compound.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Tender 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'radish-sprout-crisp-3',
    name: 'Radish sprout - Crisp 3',
    scientificName: 'Raphanus sativus',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Crisp 3 radish sprout. Spicy kick, colorful, 3-4 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Crisp 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'clover-sprout-soft-3',
    name: 'Clover sprout - Soft 3',
    scientificName: 'Trifolium pratense',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Soft 3 clover sprout. Mild, sweet, similar to alfalfa.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Soft 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'fenugreek-firm-3',
    name: 'Fenugreek - Firm 3',
    scientificName: 'Trigonella foenum-graecum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Firm 3 fenugreek. Bitter, aromatic, curry spice flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Firm 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'alfalfa-green-3',
    name: 'Alfalfa - Green 3',
    scientificName: 'Medicago sativa',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Green 3 alfalfa. Mild, nutty, classic sandwich sprout.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Green 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'mung-bean-red-3',
    name: 'Mung bean - Red 3',
    scientificName: 'Vigna radiata',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 4,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Red 3 mung bean. Crunchy, mild, Asian cuisine staple.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Red 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'lentil-purple-3',
    name: 'Lentil - Purple 3',
    scientificName: 'Lens culinaris',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Purple 3 lentil. Peppery, protein-rich, 2-3 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Purple 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'chickpea-yellow-3',
    name: 'Chickpea - Yellow 3',
    scientificName: 'Cicer arietinum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Yellow 3 chickpea. Nutty, substantial, hummus sprouts.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Yellow 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'broccoli-sprout-golden-3',
    name: 'Broccoli sprout - Golden 3',
    scientificName: 'Brassica oleracea var. italica',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Golden 3 broccoli sprout. High sulforaphane, cancer-fighting compound.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Golden 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'radish-sprout-dark-3',
    name: 'Radish sprout - Dark 3',
    scientificName: 'Raphanus sativus',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Dark 3 radish sprout. Spicy kick, colorful, 3-4 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Dark 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'clover-sprout-light-3',
    name: 'Clover sprout - Light 3',
    scientificName: 'Trifolium pratense',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Light 3 clover sprout. Mild, sweet, similar to alfalfa.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Light 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'fenugreek-pale-3',
    name: 'Fenugreek - Pale 3',
    scientificName: 'Trigonella foenum-graecum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Pale 3 fenugreek. Bitter, aromatic, curry spice flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Pale 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'alfalfa-deep-3',
    name: 'Alfalfa - Deep 3',
    scientificName: 'Medicago sativa',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Deep 3 alfalfa. Mild, nutty, classic sandwich sprout.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Deep 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'mung-bean-bright-3',
    name: 'Mung bean - Bright 3',
    scientificName: 'Vigna radiata',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 4,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bright 3 mung bean. Crunchy, mild, Asian cuisine staple.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Bright 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'lentil-round-3',
    name: 'Lentil - Round 3',
    scientificName: 'Lens culinaris',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Round 3 lentil. Peppery, protein-rich, 2-3 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Round 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'chickpea-oval-3',
    name: 'Chickpea - Oval 3',
    scientificName: 'Cicer arietinum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Oval 3 chickpea. Nutty, substantial, hummus sprouts.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Oval 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'broccoli-sprout-long-3',
    name: 'Broccoli sprout - Long 3',
    scientificName: 'Brassica oleracea var. italica',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Long 3 broccoli sprout. High sulforaphane, cancer-fighting compound.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Long 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'radish-sprout-short-3',
    name: 'Radish sprout - Short 3',
    scientificName: 'Raphanus sativus',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Short 3 radish sprout. Spicy kick, colorful, 3-4 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Short 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'clover-sprout-elongated-3',
    name: 'Clover sprout - Elongated 3',
    scientificName: 'Trifolium pratense',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Elongated 3 clover sprout. Mild, sweet, similar to alfalfa.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Elongated 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'fenugreek-single-3',
    name: 'Fenugreek - Single 3',
    scientificName: 'Trigonella foenum-graecum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Single 3 fenugreek. Bitter, aromatic, curry spice flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Single 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'alfalfa-double-3',
    name: 'Alfalfa - Double 3',
    scientificName: 'Medicago sativa',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Double 3 alfalfa. Mild, nutty, classic sandwich sprout.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Double 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'mung-bean-triple-3',
    name: 'Mung bean - Triple 3',
    scientificName: 'Vigna radiata',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 4,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Triple 3 mung bean. Crunchy, mild, Asian cuisine staple.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Triple 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'lentil-multi-3',
    name: 'Lentil - Multi 3',
    scientificName: 'Lens culinaris',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Multi 3 lentil. Peppery, protein-rich, 2-3 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Multi 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'chickpea-cluster-3',
    name: 'Chickpea - Cluster 3',
    scientificName: 'Cicer arietinum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Cluster 3 chickpea. Nutty, substantial, hummus sprouts.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Cluster 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'broccoli-sprout-solo-3',
    name: 'Broccoli sprout - Solo 3',
    scientificName: 'Brassica oleracea var. italica',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Solo 3 broccoli sprout. High sulforaphane, cancer-fighting compound.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Solo 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'radish-sprout-individual-3',
    name: 'Radish sprout - Individual 3',
    scientificName: 'Raphanus sativus',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Individual 3 radish sprout. Spicy kick, colorful, 3-4 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Individual 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'clover-sprout-bunch-3',
    name: 'Clover sprout - Bunch 3',
    scientificName: 'Trifolium pratense',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bunch 3 clover sprout. Mild, sweet, similar to alfalfa.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Bunch 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'fenugreek-bundle-3',
    name: 'Fenugreek - Bundle 3',
    scientificName: 'Trigonella foenum-graecum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bundle 3 fenugreek. Bitter, aromatic, curry spice flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Bundle 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'alfalfa-bouquet-3',
    name: 'Alfalfa - Bouquet 3',
    scientificName: 'Medicago sativa',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bouquet 3 alfalfa. Mild, nutty, classic sandwich sprout.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Bouquet 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'mung-bean-sprouting-3',
    name: 'Mung bean - Sprouting 3',
    scientificName: 'Vigna radiata',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 4,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Sprouting 3 mung bean. Crunchy, mild, Asian cuisine staple.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Sprouting 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'lentil-microgreen-3',
    name: 'Lentil - Microgreen 3',
    scientificName: 'Lens culinaris',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Microgreen 3 lentil. Peppery, protein-rich, 2-3 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Microgreen 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'chickpea-shoot-3',
    name: 'Chickpea - Shoot 3',
    scientificName: 'Cicer arietinum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Shoot 3 chickpea. Nutty, substantial, hummus sprouts.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Shoot 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'broccoli-sprout-baby-3',
    name: 'Broccoli sprout - Baby 3',
    scientificName: 'Brassica oleracea var. italica',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Baby 3 broccoli sprout. High sulforaphane, cancer-fighting compound.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Baby 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'radish-sprout-tender-3',
    name: 'Radish sprout - Tender 3',
    scientificName: 'Raphanus sativus',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Tender 3 radish sprout. Spicy kick, colorful, 3-4 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Tender 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'clover-sprout-organic-3',
    name: 'Clover sprout - Organic 3',
    scientificName: 'Trifolium pratense',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Organic 3 clover sprout. Mild, sweet, similar to alfalfa.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Organic 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'fenugreek-non-gmo-3',
    name: 'Fenugreek - Non-GMO 3',
    scientificName: 'Trigonella foenum-graecum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Non-GMO 3 fenugreek. Bitter, aromatic, curry spice flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Non-GMO 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'alfalfa-heirloom-3',
    name: 'Alfalfa - Heirloom 3',
    scientificName: 'Medicago sativa',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Heirloom 3 alfalfa. Mild, nutty, classic sandwich sprout.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Heirloom 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'mung-bean-hybrid-3',
    name: 'Mung bean - Hybrid 3',
    scientificName: 'Vigna radiata',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 4,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Hybrid 3 mung bean. Crunchy, mild, Asian cuisine staple.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Hybrid 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'lentil-open-pollinated-3',
    name: 'Lentil - Open Pollinated 3',
    scientificName: 'Lens culinaris',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Open Pollinated 3 lentil. Peppery, protein-rich, 2-3 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Open Pollinated 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'chickpea-dwarf-3',
    name: 'Chickpea - Dwarf 3',
    scientificName: 'Cicer arietinum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Dwarf 3 chickpea. Nutty, substantial, hummus sprouts.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Dwarf 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'broccoli-sprout-giant-3',
    name: 'Broccoli sprout - Giant 3',
    scientificName: 'Brassica oleracea var. italica',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Giant 3 broccoli sprout. High sulforaphane, cancer-fighting compound.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Giant 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'radish-sprout-baby-3',
    name: 'Radish sprout - Baby 3',
    scientificName: 'Raphanus sativus',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Baby 3 radish sprout. Spicy kick, colorful, 3-4 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Baby 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'clover-sprout-micro-3',
    name: 'Clover sprout - Micro 3',
    scientificName: 'Trifolium pratense',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Micro 3 clover sprout. Mild, sweet, similar to alfalfa.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Micro 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'fenugreek-mini-3',
    name: 'Fenugreek - Mini 3',
    scientificName: 'Trigonella foenum-graecum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Mini 3 fenugreek. Bitter, aromatic, curry spice flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Mini 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'alfalfa-sweet-3',
    name: 'Alfalfa - Sweet 3',
    scientificName: 'Medicago sativa',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Sweet 3 alfalfa. Mild, nutty, classic sandwich sprout.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Sweet 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'mung-bean-spicy-3',
    name: 'Mung bean - Spicy 3',
    scientificName: 'Vigna radiata',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 4,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Spicy 3 mung bean. Crunchy, mild, Asian cuisine staple.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Spicy 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'lentil-mild-3',
    name: 'Lentil - Mild 3',
    scientificName: 'Lens culinaris',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Mild 3 lentil. Peppery, protein-rich, 2-3 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Mild 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'chickpea-peppery-3',
    name: 'Chickpea - Peppery 3',
    scientificName: 'Cicer arietinum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Peppery 3 chickpea. Nutty, substantial, hummus sprouts.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Peppery 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'broccoli-sprout-nutty-3',
    name: 'Broccoli sprout - Nutty 3',
    scientificName: 'Brassica oleracea var. italica',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Nutty 3 broccoli sprout. High sulforaphane, cancer-fighting compound.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Nutty 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'radish-sprout-crunchy-3',
    name: 'Radish sprout - Crunchy 3',
    scientificName: 'Raphanus sativus',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Crunchy 3 radish sprout. Spicy kick, colorful, 3-4 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Crunchy 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'clover-sprout-tender-3',
    name: 'Clover sprout - Tender 3',
    scientificName: 'Trifolium pratense',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Tender 3 clover sprout. Mild, sweet, similar to alfalfa.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Tender 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'fenugreek-crisp-3',
    name: 'Fenugreek - Crisp 3',
    scientificName: 'Trigonella foenum-graecum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Crisp 3 fenugreek. Bitter, aromatic, curry spice flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Crisp 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'alfalfa-juicy-3',
    name: 'Alfalfa - Juicy 3',
    scientificName: 'Medicago sativa',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Juicy 3 alfalfa. Mild, nutty, classic sandwich sprout.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Juicy 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'mung-bean-succulent-3',
    name: 'Mung bean - Succulent 3',
    scientificName: 'Vigna radiata',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 4,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Succulent 3 mung bean. Crunchy, mild, Asian cuisine staple.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Succulent 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'lentil-green-3',
    name: 'Lentil - Green 3',
    scientificName: 'Lens culinaris',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Green 3 lentil. Peppery, protein-rich, 2-3 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Green 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'chickpea-red-3',
    name: 'Chickpea - Red 3',
    scientificName: 'Cicer arietinum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Red 3 chickpea. Nutty, substantial, hummus sprouts.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Red 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'broccoli-sprout-purple-3',
    name: 'Broccoli sprout - Purple 3',
    scientificName: 'Brassica oleracea var. italica',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Purple 3 broccoli sprout. High sulforaphane, cancer-fighting compound.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Purple 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'radish-sprout-yellow-3',
    name: 'Radish sprout - Yellow 3',
    scientificName: 'Raphanus sativus',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Yellow 3 radish sprout. Spicy kick, colorful, 3-4 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Yellow 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'clover-sprout-golden-3',
    name: 'Clover sprout - Golden 3',
    scientificName: 'Trifolium pratense',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Golden 3 clover sprout. Mild, sweet, similar to alfalfa.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Golden 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'fenugreek-dark-3',
    name: 'Fenugreek - Dark 3',
    scientificName: 'Trigonella foenum-graecum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Dark 3 fenugreek. Bitter, aromatic, curry spice flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Dark 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'alfalfa-light-3',
    name: 'Alfalfa - Light 3',
    scientificName: 'Medicago sativa',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Light 3 alfalfa. Mild, nutty, classic sandwich sprout.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Light 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'mung-bean-pale-3',
    name: 'Mung bean - Pale 3',
    scientificName: 'Vigna radiata',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 4,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Pale 3 mung bean. Crunchy, mild, Asian cuisine staple.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Pale 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'lentil-deep-3',
    name: 'Lentil - Deep 3',
    scientificName: 'Lens culinaris',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Deep 3 lentil. Peppery, protein-rich, 2-3 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Deep 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'chickpea-bright-3',
    name: 'Chickpea - Bright 3',
    scientificName: 'Cicer arietinum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bright 3 chickpea. Nutty, substantial, hummus sprouts.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Bright 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'broccoli-sprout-smooth-3',
    name: 'Broccoli sprout - Smooth 3',
    scientificName: 'Brassica oleracea var. italica',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Smooth 3 broccoli sprout. High sulforaphane, cancer-fighting compound.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Smooth 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'radish-sprout-curly-3',
    name: 'Radish sprout - Curly 3',
    scientificName: 'Raphanus sativus',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Curly 3 radish sprout. Spicy kick, colorful, 3-4 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Curly 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'clover-sprout-frilly-3',
    name: 'Clover sprout - Frilly 3',
    scientificName: 'Trifolium pratense',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Frilly 3 clover sprout. Mild, sweet, similar to alfalfa.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Frilly 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'fenugreek-feathery-3',
    name: 'Fenugreek - Feathery 3',
    scientificName: 'Trigonella foenum-graecum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Feathery 3 fenugreek. Bitter, aromatic, curry spice flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Feathery 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'alfalfa-lacy-3',
    name: 'Alfalfa - Lacy 3',
    scientificName: 'Medicago sativa',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Lacy 3 alfalfa. Mild, nutty, classic sandwich sprout.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Lacy 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'mung-bean-round-3',
    name: 'Mung bean - Round 3',
    scientificName: 'Vigna radiata',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 4,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Round 3 mung bean. Crunchy, mild, Asian cuisine staple.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Round 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'lentil-oval-3',
    name: 'Lentil - Oval 3',
    scientificName: 'Lens culinaris',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Oval 3 lentil. Peppery, protein-rich, 2-3 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Oval 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'chickpea-long-3',
    name: 'Chickpea - Long 3',
    scientificName: 'Cicer arietinum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Long 3 chickpea. Nutty, substantial, hummus sprouts.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Long 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'broccoli-sprout-short-3',
    name: 'Broccoli sprout - Short 3',
    scientificName: 'Brassica oleracea var. italica',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Short 3 broccoli sprout. High sulforaphane, cancer-fighting compound.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Short 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'radish-sprout-elongated-3',
    name: 'Radish sprout - Elongated 3',
    scientificName: 'Raphanus sativus',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Elongated 3 radish sprout. Spicy kick, colorful, 3-4 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Elongated 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'clover-sprout-single-3',
    name: 'Clover sprout - Single 3',
    scientificName: 'Trifolium pratense',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Single 3 clover sprout. Mild, sweet, similar to alfalfa.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Single 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'fenugreek-double-3',
    name: 'Fenugreek - Double 3',
    scientificName: 'Trigonella foenum-graecum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Double 3 fenugreek. Bitter, aromatic, curry spice flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Double 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'alfalfa-triple-3',
    name: 'Alfalfa - Triple 3',
    scientificName: 'Medicago sativa',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Triple 3 alfalfa. Mild, nutty, classic sandwich sprout.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Triple 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'mung-bean-multi-3',
    name: 'Mung bean - Multi 3',
    scientificName: 'Vigna radiata',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 4,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Multi 3 mung bean. Crunchy, mild, Asian cuisine staple.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Multi 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'lentil-cluster-3',
    name: 'Lentil - Cluster 3',
    scientificName: 'Lens culinaris',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Cluster 3 lentil. Peppery, protein-rich, 2-3 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Cluster 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'chickpea-solo-3',
    name: 'Chickpea - Solo 3',
    scientificName: 'Cicer arietinum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Solo 3 chickpea. Nutty, substantial, hummus sprouts.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Solo 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'broccoli-sprout-individual-3',
    name: 'Broccoli sprout - Individual 3',
    scientificName: 'Brassica oleracea var. italica',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Individual 3 broccoli sprout. High sulforaphane, cancer-fighting compound.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Individual 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'radish-sprout-bunch-3',
    name: 'Radish sprout - Bunch 3',
    scientificName: 'Raphanus sativus',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bunch 3 radish sprout. Spicy kick, colorful, 3-4 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Bunch 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'clover-sprout-bundle-3',
    name: 'Clover sprout - Bundle 3',
    scientificName: 'Trifolium pratense',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bundle 3 clover sprout. Mild, sweet, similar to alfalfa.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Bundle 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'fenugreek-bouquet-3',
    name: 'Fenugreek - Bouquet 3',
    scientificName: 'Trigonella foenum-graecum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bouquet 3 fenugreek. Bitter, aromatic, curry spice flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Bouquet 3'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'alfalfa-standard-4',
    name: 'Alfalfa - Standard 4',
    scientificName: 'Medicago sativa',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Standard 4 alfalfa. Mild, nutty, classic sandwich sprout.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Standard 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'mung-bean-organic-4',
    name: 'Mung bean - Organic 4',
    scientificName: 'Vigna radiata',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 4,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Organic 4 mung bean. Crunchy, mild, Asian cuisine staple.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Organic 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'lentil-non-gmo-4',
    name: 'Lentil - Non-GMO 4',
    scientificName: 'Lens culinaris',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Non-GMO 4 lentil. Peppery, protein-rich, 2-3 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Non-GMO 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'chickpea-heirloom-4',
    name: 'Chickpea - Heirloom 4',
    scientificName: 'Cicer arietinum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Heirloom 4 chickpea. Nutty, substantial, hummus sprouts.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Heirloom 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'broccoli-sprout-hybrid-4',
    name: 'Broccoli sprout - Hybrid 4',
    scientificName: 'Brassica oleracea var. italica',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Hybrid 4 broccoli sprout. High sulforaphane, cancer-fighting compound.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Hybrid 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'radish-sprout-green-4',
    name: 'Radish sprout - Green 4',
    scientificName: 'Raphanus sativus',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Green 4 radish sprout. Spicy kick, colorful, 3-4 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Green 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'clover-sprout-golden-4',
    name: 'Clover sprout - Golden 4',
    scientificName: 'Trifolium pratense',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Golden 4 clover sprout. Mild, sweet, similar to alfalfa.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Golden 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'fenugreek-yellow-4',
    name: 'Fenugreek - Yellow 4',
    scientificName: 'Trigonella foenum-graecum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Yellow 4 fenugreek. Bitter, aromatic, curry spice flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Yellow 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'alfalfa-brown-4',
    name: 'Alfalfa - Brown 4',
    scientificName: 'Medicago sativa',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Brown 4 alfalfa. Mild, nutty, classic sandwich sprout.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Brown 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'mung-bean-black-4',
    name: 'Mung bean - Black 4',
    scientificName: 'Vigna radiata',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 4,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Black 4 mung bean. Crunchy, mild, Asian cuisine staple.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Black 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'lentil-french-4',
    name: 'Lentil - French 4',
    scientificName: 'Lens culinaris',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'French 4 lentil. Peppery, protein-rich, 2-3 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['French 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'chickpea-spanish-4',
    name: 'Chickpea - Spanish 4',
    scientificName: 'Cicer arietinum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Spanish 4 chickpea. Nutty, substantial, hummus sprouts.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Spanish 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'broccoli-sprout-italian-4',
    name: 'Broccoli sprout - Italian 4',
    scientificName: 'Brassica oleracea var. italica',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Italian 4 broccoli sprout. High sulforaphane, cancer-fighting compound.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Italian 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'radish-sprout-greek-4',
    name: 'Radish sprout - Greek 4',
    scientificName: 'Raphanus sativus',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Greek 4 radish sprout. Spicy kick, colorful, 3-4 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Greek 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'clover-sprout-turkish-4',
    name: 'Clover sprout - Turkish 4',
    scientificName: 'Trifolium pratense',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Turkish 4 clover sprout. Mild, sweet, similar to alfalfa.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Turkish 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'fenugreek-indian-4',
    name: 'Fenugreek - Indian 4',
    scientificName: 'Trigonella foenum-graecum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Indian 4 fenugreek. Bitter, aromatic, curry spice flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Indian 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'alfalfa-chinese-4',
    name: 'Alfalfa - Chinese 4',
    scientificName: 'Medicago sativa',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Chinese 4 alfalfa. Mild, nutty, classic sandwich sprout.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Chinese 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'mung-bean-japanese-4',
    name: 'Mung bean - Japanese 4',
    scientificName: 'Vigna radiata',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 4,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Japanese 4 mung bean. Crunchy, mild, Asian cuisine staple.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Japanese 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'lentil-korean-4',
    name: 'Lentil - Korean 4',
    scientificName: 'Lens culinaris',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Korean 4 lentil. Peppery, protein-rich, 2-3 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Korean 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'chickpea-thai-4',
    name: 'Chickpea - Thai 4',
    scientificName: 'Cicer arietinum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Thai 4 chickpea. Nutty, substantial, hummus sprouts.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Thai 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'broccoli-sprout-dwarf-4',
    name: 'Broccoli sprout - Dwarf 4',
    scientificName: 'Brassica oleracea var. italica',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Dwarf 4 broccoli sprout. High sulforaphane, cancer-fighting compound.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Dwarf 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'radish-sprout-giant-4',
    name: 'Radish sprout - Giant 4',
    scientificName: 'Raphanus sativus',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Giant 4 radish sprout. Spicy kick, colorful, 3-4 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Giant 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'clover-sprout-baby-4',
    name: 'Clover sprout - Baby 4',
    scientificName: 'Trifolium pratense',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Baby 4 clover sprout. Mild, sweet, similar to alfalfa.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Baby 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'fenugreek-micro-4',
    name: 'Fenugreek - Micro 4',
    scientificName: 'Trigonella foenum-graecum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Micro 4 fenugreek. Bitter, aromatic, curry spice flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Micro 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'alfalfa-mini-4',
    name: 'Alfalfa - Mini 4',
    scientificName: 'Medicago sativa',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Mini 4 alfalfa. Mild, nutty, classic sandwich sprout.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Mini 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'mung-bean-quick-4',
    name: 'Mung bean - Quick 4',
    scientificName: 'Vigna radiata',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 4,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Quick 4 mung bean. Crunchy, mild, Asian cuisine staple.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Quick 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'lentil-fast-4',
    name: 'Lentil - Fast 4',
    scientificName: 'Lens culinaris',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Fast 4 lentil. Peppery, protein-rich, 2-3 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Fast 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'chickpea-speedy-4',
    name: 'Chickpea - Speedy 4',
    scientificName: 'Cicer arietinum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Speedy 4 chickpea. Nutty, substantial, hummus sprouts.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Speedy 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'broccoli-sprout-rapid-4',
    name: 'Broccoli sprout - Rapid 4',
    scientificName: 'Brassica oleracea var. italica',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Rapid 4 broccoli sprout. High sulforaphane, cancer-fighting compound.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Rapid 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'radish-sprout-swift-4',
    name: 'Radish sprout - Swift 4',
    scientificName: 'Raphanus sativus',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Swift 4 radish sprout. Spicy kick, colorful, 3-4 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Swift 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'clover-sprout-sweet-4',
    name: 'Clover sprout - Sweet 4',
    scientificName: 'Trifolium pratense',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Sweet 4 clover sprout. Mild, sweet, similar to alfalfa.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Sweet 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'fenugreek-spicy-4',
    name: 'Fenugreek - Spicy 4',
    scientificName: 'Trigonella foenum-graecum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Spicy 4 fenugreek. Bitter, aromatic, curry spice flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Spicy 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'alfalfa-mild-4',
    name: 'Alfalfa - Mild 4',
    scientificName: 'Medicago sativa',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Mild 4 alfalfa. Mild, nutty, classic sandwich sprout.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Mild 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'mung-bean-bitter-4',
    name: 'Mung bean - Bitter 4',
    scientificName: 'Vigna radiata',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 4,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bitter 4 mung bean. Crunchy, mild, Asian cuisine staple.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Bitter 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'lentil-nutty-4',
    name: 'Lentil - Nutty 4',
    scientificName: 'Lens culinaris',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Nutty 4 lentil. Peppery, protein-rich, 2-3 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Nutty 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'chickpea-crunchy-4',
    name: 'Chickpea - Crunchy 4',
    scientificName: 'Cicer arietinum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Crunchy 4 chickpea. Nutty, substantial, hummus sprouts.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Crunchy 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'broccoli-sprout-tender-4',
    name: 'Broccoli sprout - Tender 4',
    scientificName: 'Brassica oleracea var. italica',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Tender 4 broccoli sprout. High sulforaphane, cancer-fighting compound.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Tender 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'radish-sprout-crisp-4',
    name: 'Radish sprout - Crisp 4',
    scientificName: 'Raphanus sativus',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Crisp 4 radish sprout. Spicy kick, colorful, 3-4 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Crisp 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'clover-sprout-soft-4',
    name: 'Clover sprout - Soft 4',
    scientificName: 'Trifolium pratense',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Soft 4 clover sprout. Mild, sweet, similar to alfalfa.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Soft 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'fenugreek-firm-4',
    name: 'Fenugreek - Firm 4',
    scientificName: 'Trigonella foenum-graecum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Firm 4 fenugreek. Bitter, aromatic, curry spice flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Firm 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'alfalfa-green-4',
    name: 'Alfalfa - Green 4',
    scientificName: 'Medicago sativa',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Green 4 alfalfa. Mild, nutty, classic sandwich sprout.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Green 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'mung-bean-red-4',
    name: 'Mung bean - Red 4',
    scientificName: 'Vigna radiata',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 4,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Red 4 mung bean. Crunchy, mild, Asian cuisine staple.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Red 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'lentil-purple-4',
    name: 'Lentil - Purple 4',
    scientificName: 'Lens culinaris',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Purple 4 lentil. Peppery, protein-rich, 2-3 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Purple 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'chickpea-yellow-4',
    name: 'Chickpea - Yellow 4',
    scientificName: 'Cicer arietinum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Yellow 4 chickpea. Nutty, substantial, hummus sprouts.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Yellow 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'broccoli-sprout-golden-4',
    name: 'Broccoli sprout - Golden 4',
    scientificName: 'Brassica oleracea var. italica',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Golden 4 broccoli sprout. High sulforaphane, cancer-fighting compound.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Golden 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'radish-sprout-dark-4',
    name: 'Radish sprout - Dark 4',
    scientificName: 'Raphanus sativus',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Dark 4 radish sprout. Spicy kick, colorful, 3-4 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Dark 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'clover-sprout-light-4',
    name: 'Clover sprout - Light 4',
    scientificName: 'Trifolium pratense',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Light 4 clover sprout. Mild, sweet, similar to alfalfa.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Light 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'fenugreek-pale-4',
    name: 'Fenugreek - Pale 4',
    scientificName: 'Trigonella foenum-graecum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Pale 4 fenugreek. Bitter, aromatic, curry spice flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Pale 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'alfalfa-deep-4',
    name: 'Alfalfa - Deep 4',
    scientificName: 'Medicago sativa',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Deep 4 alfalfa. Mild, nutty, classic sandwich sprout.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Deep 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'mung-bean-bright-4',
    name: 'Mung bean - Bright 4',
    scientificName: 'Vigna radiata',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 4,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bright 4 mung bean. Crunchy, mild, Asian cuisine staple.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Bright 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'lentil-round-4',
    name: 'Lentil - Round 4',
    scientificName: 'Lens culinaris',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Round 4 lentil. Peppery, protein-rich, 2-3 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Round 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'chickpea-oval-4',
    name: 'Chickpea - Oval 4',
    scientificName: 'Cicer arietinum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Oval 4 chickpea. Nutty, substantial, hummus sprouts.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Oval 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'broccoli-sprout-long-4',
    name: 'Broccoli sprout - Long 4',
    scientificName: 'Brassica oleracea var. italica',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Long 4 broccoli sprout. High sulforaphane, cancer-fighting compound.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Long 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'radish-sprout-short-4',
    name: 'Radish sprout - Short 4',
    scientificName: 'Raphanus sativus',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Short 4 radish sprout. Spicy kick, colorful, 3-4 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Short 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'clover-sprout-elongated-4',
    name: 'Clover sprout - Elongated 4',
    scientificName: 'Trifolium pratense',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Elongated 4 clover sprout. Mild, sweet, similar to alfalfa.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Elongated 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'fenugreek-single-4',
    name: 'Fenugreek - Single 4',
    scientificName: 'Trigonella foenum-graecum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Single 4 fenugreek. Bitter, aromatic, curry spice flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Single 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'alfalfa-double-4',
    name: 'Alfalfa - Double 4',
    scientificName: 'Medicago sativa',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Double 4 alfalfa. Mild, nutty, classic sandwich sprout.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Double 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'mung-bean-triple-4',
    name: 'Mung bean - Triple 4',
    scientificName: 'Vigna radiata',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 4,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Triple 4 mung bean. Crunchy, mild, Asian cuisine staple.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Triple 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'lentil-multi-4',
    name: 'Lentil - Multi 4',
    scientificName: 'Lens culinaris',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Multi 4 lentil. Peppery, protein-rich, 2-3 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Multi 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'chickpea-cluster-4',
    name: 'Chickpea - Cluster 4',
    scientificName: 'Cicer arietinum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Cluster 4 chickpea. Nutty, substantial, hummus sprouts.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Cluster 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'broccoli-sprout-solo-4',
    name: 'Broccoli sprout - Solo 4',
    scientificName: 'Brassica oleracea var. italica',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Solo 4 broccoli sprout. High sulforaphane, cancer-fighting compound.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Solo 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'radish-sprout-individual-4',
    name: 'Radish sprout - Individual 4',
    scientificName: 'Raphanus sativus',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Individual 4 radish sprout. Spicy kick, colorful, 3-4 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Individual 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'clover-sprout-bunch-4',
    name: 'Clover sprout - Bunch 4',
    scientificName: 'Trifolium pratense',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bunch 4 clover sprout. Mild, sweet, similar to alfalfa.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Bunch 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'fenugreek-bundle-4',
    name: 'Fenugreek - Bundle 4',
    scientificName: 'Trigonella foenum-graecum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bundle 4 fenugreek. Bitter, aromatic, curry spice flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Bundle 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'alfalfa-bouquet-4',
    name: 'Alfalfa - Bouquet 4',
    scientificName: 'Medicago sativa',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bouquet 4 alfalfa. Mild, nutty, classic sandwich sprout.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Bouquet 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'mung-bean-sprouting-4',
    name: 'Mung bean - Sprouting 4',
    scientificName: 'Vigna radiata',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 4,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Sprouting 4 mung bean. Crunchy, mild, Asian cuisine staple.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Sprouting 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'lentil-microgreen-4',
    name: 'Lentil - Microgreen 4',
    scientificName: 'Lens culinaris',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Microgreen 4 lentil. Peppery, protein-rich, 2-3 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Microgreen 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'chickpea-shoot-4',
    name: 'Chickpea - Shoot 4',
    scientificName: 'Cicer arietinum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Shoot 4 chickpea. Nutty, substantial, hummus sprouts.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Shoot 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'broccoli-sprout-baby-4',
    name: 'Broccoli sprout - Baby 4',
    scientificName: 'Brassica oleracea var. italica',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Baby 4 broccoli sprout. High sulforaphane, cancer-fighting compound.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Baby 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'radish-sprout-tender-4',
    name: 'Radish sprout - Tender 4',
    scientificName: 'Raphanus sativus',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Tender 4 radish sprout. Spicy kick, colorful, 3-4 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Tender 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'clover-sprout-organic-4',
    name: 'Clover sprout - Organic 4',
    scientificName: 'Trifolium pratense',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Organic 4 clover sprout. Mild, sweet, similar to alfalfa.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Organic 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'fenugreek-non-gmo-4',
    name: 'Fenugreek - Non-GMO 4',
    scientificName: 'Trigonella foenum-graecum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Non-GMO 4 fenugreek. Bitter, aromatic, curry spice flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Non-GMO 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'alfalfa-heirloom-4',
    name: 'Alfalfa - Heirloom 4',
    scientificName: 'Medicago sativa',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Heirloom 4 alfalfa. Mild, nutty, classic sandwich sprout.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Heirloom 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'mung-bean-hybrid-4',
    name: 'Mung bean - Hybrid 4',
    scientificName: 'Vigna radiata',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 4,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Hybrid 4 mung bean. Crunchy, mild, Asian cuisine staple.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Hybrid 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'lentil-open-pollinated-4',
    name: 'Lentil - Open Pollinated 4',
    scientificName: 'Lens culinaris',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Open Pollinated 4 lentil. Peppery, protein-rich, 2-3 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Open Pollinated 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'chickpea-dwarf-4',
    name: 'Chickpea - Dwarf 4',
    scientificName: 'Cicer arietinum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Dwarf 4 chickpea. Nutty, substantial, hummus sprouts.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Dwarf 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'broccoli-sprout-giant-4',
    name: 'Broccoli sprout - Giant 4',
    scientificName: 'Brassica oleracea var. italica',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Giant 4 broccoli sprout. High sulforaphane, cancer-fighting compound.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Giant 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'radish-sprout-baby-4',
    name: 'Radish sprout - Baby 4',
    scientificName: 'Raphanus sativus',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Baby 4 radish sprout. Spicy kick, colorful, 3-4 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Baby 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'clover-sprout-micro-4',
    name: 'Clover sprout - Micro 4',
    scientificName: 'Trifolium pratense',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Micro 4 clover sprout. Mild, sweet, similar to alfalfa.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Micro 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'fenugreek-mini-4',
    name: 'Fenugreek - Mini 4',
    scientificName: 'Trigonella foenum-graecum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Mini 4 fenugreek. Bitter, aromatic, curry spice flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Mini 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'alfalfa-sweet-4',
    name: 'Alfalfa - Sweet 4',
    scientificName: 'Medicago sativa',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Sweet 4 alfalfa. Mild, nutty, classic sandwich sprout.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Sweet 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'mung-bean-spicy-4',
    name: 'Mung bean - Spicy 4',
    scientificName: 'Vigna radiata',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 4,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Spicy 4 mung bean. Crunchy, mild, Asian cuisine staple.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Spicy 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'lentil-mild-4',
    name: 'Lentil - Mild 4',
    scientificName: 'Lens culinaris',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Mild 4 lentil. Peppery, protein-rich, 2-3 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Mild 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'chickpea-peppery-4',
    name: 'Chickpea - Peppery 4',
    scientificName: 'Cicer arietinum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Peppery 4 chickpea. Nutty, substantial, hummus sprouts.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Peppery 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'broccoli-sprout-nutty-4',
    name: 'Broccoli sprout - Nutty 4',
    scientificName: 'Brassica oleracea var. italica',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Nutty 4 broccoli sprout. High sulforaphane, cancer-fighting compound.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Nutty 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'radish-sprout-crunchy-4',
    name: 'Radish sprout - Crunchy 4',
    scientificName: 'Raphanus sativus',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Crunchy 4 radish sprout. Spicy kick, colorful, 3-4 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Crunchy 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'clover-sprout-tender-4',
    name: 'Clover sprout - Tender 4',
    scientificName: 'Trifolium pratense',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Tender 4 clover sprout. Mild, sweet, similar to alfalfa.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Tender 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'fenugreek-crisp-4',
    name: 'Fenugreek - Crisp 4',
    scientificName: 'Trigonella foenum-graecum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Crisp 4 fenugreek. Bitter, aromatic, curry spice flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Crisp 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'alfalfa-juicy-4',
    name: 'Alfalfa - Juicy 4',
    scientificName: 'Medicago sativa',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Juicy 4 alfalfa. Mild, nutty, classic sandwich sprout.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Juicy 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'mung-bean-succulent-4',
    name: 'Mung bean - Succulent 4',
    scientificName: 'Vigna radiata',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 4,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Succulent 4 mung bean. Crunchy, mild, Asian cuisine staple.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Succulent 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'lentil-green-4',
    name: 'Lentil - Green 4',
    scientificName: 'Lens culinaris',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Green 4 lentil. Peppery, protein-rich, 2-3 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Green 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'chickpea-red-4',
    name: 'Chickpea - Red 4',
    scientificName: 'Cicer arietinum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Red 4 chickpea. Nutty, substantial, hummus sprouts.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Red 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'broccoli-sprout-purple-4',
    name: 'Broccoli sprout - Purple 4',
    scientificName: 'Brassica oleracea var. italica',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Purple 4 broccoli sprout. High sulforaphane, cancer-fighting compound.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Purple 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'radish-sprout-yellow-4',
    name: 'Radish sprout - Yellow 4',
    scientificName: 'Raphanus sativus',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Yellow 4 radish sprout. Spicy kick, colorful, 3-4 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Yellow 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'clover-sprout-golden-4',
    name: 'Clover sprout - Golden 4',
    scientificName: 'Trifolium pratense',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Golden 4 clover sprout. Mild, sweet, similar to alfalfa.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Golden 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'fenugreek-dark-4',
    name: 'Fenugreek - Dark 4',
    scientificName: 'Trigonella foenum-graecum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Dark 4 fenugreek. Bitter, aromatic, curry spice flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Dark 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'alfalfa-light-4',
    name: 'Alfalfa - Light 4',
    scientificName: 'Medicago sativa',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Light 4 alfalfa. Mild, nutty, classic sandwich sprout.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Light 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'mung-bean-pale-4',
    name: 'Mung bean - Pale 4',
    scientificName: 'Vigna radiata',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 4,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Pale 4 mung bean. Crunchy, mild, Asian cuisine staple.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Pale 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'lentil-deep-4',
    name: 'Lentil - Deep 4',
    scientificName: 'Lens culinaris',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Deep 4 lentil. Peppery, protein-rich, 2-3 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Deep 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'chickpea-bright-4',
    name: 'Chickpea - Bright 4',
    scientificName: 'Cicer arietinum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bright 4 chickpea. Nutty, substantial, hummus sprouts.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Bright 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'broccoli-sprout-smooth-4',
    name: 'Broccoli sprout - Smooth 4',
    scientificName: 'Brassica oleracea var. italica',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Smooth 4 broccoli sprout. High sulforaphane, cancer-fighting compound.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Smooth 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'radish-sprout-curly-4',
    name: 'Radish sprout - Curly 4',
    scientificName: 'Raphanus sativus',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Curly 4 radish sprout. Spicy kick, colorful, 3-4 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Curly 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'clover-sprout-frilly-4',
    name: 'Clover sprout - Frilly 4',
    scientificName: 'Trifolium pratense',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Frilly 4 clover sprout. Mild, sweet, similar to alfalfa.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Frilly 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'fenugreek-feathery-4',
    name: 'Fenugreek - Feathery 4',
    scientificName: 'Trigonella foenum-graecum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Feathery 4 fenugreek. Bitter, aromatic, curry spice flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Feathery 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'alfalfa-lacy-4',
    name: 'Alfalfa - Lacy 4',
    scientificName: 'Medicago sativa',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Lacy 4 alfalfa. Mild, nutty, classic sandwich sprout.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Lacy 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'mung-bean-round-4',
    name: 'Mung bean - Round 4',
    scientificName: 'Vigna radiata',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 4,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Round 4 mung bean. Crunchy, mild, Asian cuisine staple.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Round 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'lentil-oval-4',
    name: 'Lentil - Oval 4',
    scientificName: 'Lens culinaris',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Oval 4 lentil. Peppery, protein-rich, 2-3 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Oval 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'chickpea-long-4',
    name: 'Chickpea - Long 4',
    scientificName: 'Cicer arietinum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Long 4 chickpea. Nutty, substantial, hummus sprouts.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Long 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'broccoli-sprout-short-4',
    name: 'Broccoli sprout - Short 4',
    scientificName: 'Brassica oleracea var. italica',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Short 4 broccoli sprout. High sulforaphane, cancer-fighting compound.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Short 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'radish-sprout-elongated-4',
    name: 'Radish sprout - Elongated 4',
    scientificName: 'Raphanus sativus',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Elongated 4 radish sprout. Spicy kick, colorful, 3-4 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Elongated 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'clover-sprout-single-4',
    name: 'Clover sprout - Single 4',
    scientificName: 'Trifolium pratense',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Single 4 clover sprout. Mild, sweet, similar to alfalfa.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Single 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'fenugreek-double-4',
    name: 'Fenugreek - Double 4',
    scientificName: 'Trigonella foenum-graecum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Double 4 fenugreek. Bitter, aromatic, curry spice flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Double 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'alfalfa-triple-4',
    name: 'Alfalfa - Triple 4',
    scientificName: 'Medicago sativa',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Triple 4 alfalfa. Mild, nutty, classic sandwich sprout.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Triple 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'mung-bean-multi-4',
    name: 'Mung bean - Multi 4',
    scientificName: 'Vigna radiata',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 4,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Multi 4 mung bean. Crunchy, mild, Asian cuisine staple.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Multi 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'lentil-cluster-4',
    name: 'Lentil - Cluster 4',
    scientificName: 'Lens culinaris',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Cluster 4 lentil. Peppery, protein-rich, 2-3 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Cluster 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'chickpea-solo-4',
    name: 'Chickpea - Solo 4',
    scientificName: 'Cicer arietinum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Solo 4 chickpea. Nutty, substantial, hummus sprouts.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Solo 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'broccoli-sprout-individual-4',
    name: 'Broccoli sprout - Individual 4',
    scientificName: 'Brassica oleracea var. italica',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Individual 4 broccoli sprout. High sulforaphane, cancer-fighting compound.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Individual 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'radish-sprout-bunch-4',
    name: 'Radish sprout - Bunch 4',
    scientificName: 'Raphanus sativus',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bunch 4 radish sprout. Spicy kick, colorful, 3-4 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Bunch 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'clover-sprout-bundle-4',
    name: 'Clover sprout - Bundle 4',
    scientificName: 'Trifolium pratense',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bundle 4 clover sprout. Mild, sweet, similar to alfalfa.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Bundle 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'fenugreek-bouquet-4',
    name: 'Fenugreek - Bouquet 4',
    scientificName: 'Trigonella foenum-graecum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bouquet 4 fenugreek. Bitter, aromatic, curry spice flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Bouquet 4'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'alfalfa-standard-5',
    name: 'Alfalfa - Standard 5',
    scientificName: 'Medicago sativa',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Standard 5 alfalfa. Mild, nutty, classic sandwich sprout.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Standard 5'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'mung-bean-organic-5',
    name: 'Mung bean - Organic 5',
    scientificName: 'Vigna radiata',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 4,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Organic 5 mung bean. Crunchy, mild, Asian cuisine staple.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Organic 5'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'lentil-non-gmo-5',
    name: 'Lentil - Non-GMO 5',
    scientificName: 'Lens culinaris',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Non-GMO 5 lentil. Peppery, protein-rich, 2-3 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Non-GMO 5'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'chickpea-heirloom-5',
    name: 'Chickpea - Heirloom 5',
    scientificName: 'Cicer arietinum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Heirloom 5 chickpea. Nutty, substantial, hummus sprouts.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Heirloom 5'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'broccoli-sprout-hybrid-5',
    name: 'Broccoli sprout - Hybrid 5',
    scientificName: 'Brassica oleracea var. italica',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Hybrid 5 broccoli sprout. High sulforaphane, cancer-fighting compound.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Hybrid 5'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'radish-sprout-green-5',
    name: 'Radish sprout - Green 5',
    scientificName: 'Raphanus sativus',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Green 5 radish sprout. Spicy kick, colorful, 3-4 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Green 5'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'clover-sprout-golden-5',
    name: 'Clover sprout - Golden 5',
    scientificName: 'Trifolium pratense',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Golden 5 clover sprout. Mild, sweet, similar to alfalfa.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Golden 5'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'fenugreek-yellow-5',
    name: 'Fenugreek - Yellow 5',
    scientificName: 'Trigonella foenum-graecum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Yellow 5 fenugreek. Bitter, aromatic, curry spice flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Yellow 5'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'alfalfa-brown-5',
    name: 'Alfalfa - Brown 5',
    scientificName: 'Medicago sativa',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Brown 5 alfalfa. Mild, nutty, classic sandwich sprout.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Brown 5'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'mung-bean-black-5',
    name: 'Mung bean - Black 5',
    scientificName: 'Vigna radiata',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 4,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Black 5 mung bean. Crunchy, mild, Asian cuisine staple.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Black 5'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'lentil-french-5',
    name: 'Lentil - French 5',
    scientificName: 'Lens culinaris',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'French 5 lentil. Peppery, protein-rich, 2-3 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['French 5'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'chickpea-spanish-5',
    name: 'Chickpea - Spanish 5',
    scientificName: 'Cicer arietinum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Spanish 5 chickpea. Nutty, substantial, hummus sprouts.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Spanish 5'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'broccoli-sprout-italian-5',
    name: 'Broccoli sprout - Italian 5',
    scientificName: 'Brassica oleracea var. italica',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Italian 5 broccoli sprout. High sulforaphane, cancer-fighting compound.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Italian 5'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'radish-sprout-greek-5',
    name: 'Radish sprout - Greek 5',
    scientificName: 'Raphanus sativus',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Greek 5 radish sprout. Spicy kick, colorful, 3-4 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Brassicaceae',
    varieties: ['Greek 5'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'clover-sprout-turkish-5',
    name: 'Clover sprout - Turkish 5',
    scientificName: 'Trifolium pratense',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Turkish 5 clover sprout. Mild, sweet, similar to alfalfa.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Turkish 5'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'fenugreek-indian-5',
    name: 'Fenugreek - Indian 5',
    scientificName: 'Trigonella foenum-graecum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Indian 5 fenugreek. Bitter, aromatic, curry spice flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Indian 5'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'alfalfa-chinese-5',
    name: 'Alfalfa - Chinese 5',
    scientificName: 'Medicago sativa',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 5,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Chinese 5 alfalfa. Mild, nutty, classic sandwich sprout.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Chinese 5'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'mung-bean-japanese-5',
    name: 'Mung bean - Japanese 5',
    scientificName: 'Vigna radiata',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 4,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Japanese 5 mung bean. Crunchy, mild, Asian cuisine staple.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Japanese 5'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'lentil-korean-5',
    name: 'Lentil - Korean 5',
    scientificName: 'Lens culinaris',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Korean 5 lentil. Peppery, protein-rich, 2-3 days.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Korean 5'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  },
  {
    id: 'chickpea-thai-5',
    name: 'Chickpea - Thai 5',
    scientificName: 'Cicer arietinum',
    category: 'sprout',
    spacing: 0.1,
    rowSpacing: 0.1,
    daysToGermination: 2,
    daysToHarvest: 3,
    sun: 'indirect',
    water: 'medium',
    soil: 'none (jar/sprouting tray)',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Thai 5 chickpea. Nutty, substantial, hummus sprouts.',
    hardinessZones: 'indoor',
    plantingSeason: 'year-round',
    height: '1-2 inches',
    spread: 'dense cluster',
    family: 'Fabaceae',
    varieties: ['Thai 5'],
    uses: ['sandwiches', 'salads', 'stir fry', 'nutrition', 'raw']
  }

]
